
bamQueue.addToQueue(function(){
	/****************/
	/*	 LOADERS	*/
	/****************/
	var modalsLoader = new loaderProObject(false);
	var modalLoaderHTML = modalsLoader.outputHTML();
	var warningMsg="Taking too much time, check your internet connection.\nContinue with the loading?";
	customModals=function(){
		interceptModals({ holdHTML:modalLoaderHTML,timeOut:{
			time:8000,
			warnMsg:warningMsg,
			timeOutCallback:function(){
// 				$('[data-reveal]').core_reveal("close");
				try {
					webkit.messageHandlers.modalListener.postMessage("failed");
				} catch(err) {
					console.log('The native context does not exist yet');
					var confValue = confirm(warningMsg);
					if(confValue == false){
						$('[data-reveal]').core_reveal("close");
					}
				}
			}
		}})
	}
	//LANZAMOS LOS EVENTOS DE LOS MODALES -para evitar que carguen vacíos-
	//$('[data-reveal]').foundation();
	//********************************************************************
	// 	launchSubscriptionEvents();
	customLabelEvents();


})

function customLabelEvents(element){
	var elem = 'body';
	if(typeof element != "undefined"){
		elem = element;
	}
/*
	$('label.beautified input[type=checkbox]').off('click.beautified').on('click.beautified',function(){
		$(this).parent().toggleClass('is-active');
		if($(this).parent().hasClass('is-active')){
			$(this).prop('checked',true)
		}else{
			$(this).prop('checked',false)
		}

	})
*/

	$(elem).find('label.beautifiedRadio input[type=radio]').add('label.beautified input[type=radio]').add('label.beautifiedRadio input[type=checkbox]').add('label.beautified input[type=checkbox]').off('click.beautified').on('click.beautified',function(){

		if($(this).attr('type')=='radio'){
			var name=$(this).attr('name');
			$('input[name="'+name+'"]').each(function(){
				var parent=$(this).parent();
				if($(parent).hasClass('beautifiedRadio') || $(parent).hasClass('beautified')){
					$(parent).removeClass('is-active');
				}
			})
			$(this).parent('label.beautifiedRadio').addClass('is-active');
			$(this).parent('label.beautified').addClass('is-active');

		}else if($(this).attr('type')=='checkbox'){

			$(this).parent().toggleClass('is-active');

			if($(this).parent().hasClass('is-active')){
				$(this).prop('checked',true)
			}else{
				$(this).prop('checked',false)
			}

		}

	})

	$('label.beautified input[type=checkbox]').add('label.beautifiedRadio input[type=checkbox]').each(function(){
		if($(this).prop('checked')){
			$(this).parent().addClass('is-active')
		}else{
			$(this).parent().removeClass('is-active')
		}
	})
}

/****************************************/
/*	 CONTADORES DE SEGUNDOS QUE QUEDAN	*/
/****************************************/
function setCountDown(seconds,elem,options){

	var strings = {
		days: "d",
		hours: "h",
		minutes: "m",
		seconds: "s"
	}

	var indicatorsTag = "small";
	var countersTag = options?.countersTag ?? "";

	if(typeof options != "undefined"){
		if (typeof options.strings != "undefined"){
			if (options.strings.days != "undefined") { strings.days = options.strings.days}
			if (options.strings.hours != "undefined") { strings.hours = options.strings.hours}
			if (options.strings.minutes != "undefined") { strings.minutes = options.strings.minutes}
			if (options.strings.seconds != "undefined") { strings.seconds = options.strings.seconds}
		}
		if (typeof options.indicatorsTag != "undefined"){
			indicatorsTag = options.indicatorsTag
		}

	}

	window.secondsRemainingCounter=setInterval(function(){ countDown(seconds,elem,window.secondsRemainingCounter,options)}, 1000);
}

function countDown(seconds,elem,timer,options){
	var strings = {
		days: "d",
		hours: "h",
		minutes: "m",
		seconds: "s"
	}
	const countersTag = options?.countersTag ?? "";
	var indicatorsTag = "small";
	var tagsOpening = "";
	var tagsClosure = "";
	let opening = "";
	let closure = "";

	if(typeof options != "undefined"){
		if (typeof options.strings != "undefined"){
			if (options.strings.days != "undefined") { strings.days = options.strings.days}
			if (options.strings.hours != "undefined") { strings.hours = options.strings.hours}
			if (options.strings.minutes != "undefined") { strings.minutes = options.strings.minutes}
			if (options.strings.seconds != "undefined") { strings.seconds = options.strings.seconds}
		}
		if (typeof options.indicatorsTag != "undefined"){
			indicatorsTag = options.indicatorsTag
		}
	}

	if(typeof $(elem).data("elapsed") == "undefined"){
		$(elem).data("elapsed",seconds)
	}

	if(countersTag.length > 0){
		opening = `<${countersTag}>`;
		closure = `</${countersTag}>`;
	}
	if(indicatorsTag.length > 0){
		tagsOpening = "<"+indicatorsTag+">"
		tagsClosure = "</"+indicatorsTag+">"
	}

	var elapsed= $(elem).data("elapsed");
	var seconds = parseInt(elapsed, 10);
	var days = Math.floor(seconds / (3600*24));
	seconds  -= days*3600*24;
	var hrs   = Math.floor(seconds / 3600);
	seconds  -= hrs*3600;
	var mnts = Math.floor(seconds / 60);
	seconds  -= mnts*60;
	$(elem).data("elapsed",elapsed-1)
	if(days==0 && hrs == 0){
		var resultString =  opening + pad(mnts,2) + tagsOpening+strings.minutes+" "+tagsClosure + closure + opening + pad(seconds,2)+tagsOpening+strings.seconds+tagsClosure + closure;
	}else if(days==0){
		var resultString =  opening + pad(hrs,2) + tagsOpening+strings.hours+" "+tagsClosure + closure + opening + pad(mnts,2)+tagsOpening+strings.minutes+" "+tagsClosure + closure + opening + pad(seconds,2)+tagsOpening+strings.seconds+tagsClosure + closure;
	}else{
		var resultString =  opening + pad(days,2) + tagsOpening+strings.days+" "+tagsClosure + closure + opening + pad(hrs,2)+tagsOpening+strings.hours+" "+tagsClosure + closure + opening + pad(mnts,2)+tagsOpening+strings.minutes+" "+tagsClosure + closure + opening + pad(seconds,2)+tagsOpening+strings.seconds+tagsClosure + closure;
	}
	$(elem).html(resultString);
	if(elapsed <= 0){
		clearInterval(timer)
	}
}

function pad(num, size){ return ('000000000' + num).substr(-size); }





var fndt_paginationJS = function(selector,haystack,perPage){
	var self = this;
	this.pageActual = 1;
	this.pageAnterior = false;
	this.object = $(selector);
	this.haystack = haystack;
	this.perPage = perPage;
	this.pages = Math.ceil(this.haystack.length/perPage);
	this.interfaceOpts = {};

	// Bindeamos acciones
	$(this.object).find("li").each(function(){
		if(typeof $(this).attr("data-prev") != "undefined"){
			$(this).on("click",function(){ self.prev()});
		} else if(typeof $(this).attr("data-next") != "undefined"){
			$(this).on("click",function(){ self.next()});
		} else {
			$(this).on("click",function(){ self.goto($(this).attr("data-goto"))});
		}
	});
}
fndt_paginationJS.prototype.prev = function(){
	if(this.pageActual > 1) this.goto(this.pageActual-1);
}
fndt_paginationJS.prototype.next = function(){
	if(this.pageActual < this.pages) this.goto(this.pageActual+1);
}
fndt_paginationJS.prototype.goto = function(page){
	if(this.pageActual == parseInt(page)) return false;
	this.pageAnterior = this.pageActual;
	this.pageActual = parseInt(page);
	this.updatePagination();
	this.interface(this.interfaceOpts);
}
fndt_paginationJS.prototype.updatePagination = function(){
	if(this.pageActual != 1){
		$(this.object).find("[data-prev].disabled").removeClass("disabled").html("<a>"+this.lang_prev+"</a>");
	} else {
		$(this.object).find("[data-prev]:not(.disabled)").addClass("disabled").html(this.lang_prev+"<span class='show-for-sr'>"+this.lang_page+"</span>");
	}
	if(this.pageActual != this.pages){
		$(this.object).find("[data-next].disabled").removeClass("disabled").html("<a>"+this.lang_next+"</a>");
	} else {
		$(this.object).find("[data-next]:not(.disabled)").addClass("disabled").html(this.lang_next+"<span class='show-for-sr'>"+this.lang_page+"</span>");
	}
	$(this.object).find("[data-goto].current").removeClass("current").html("<a>"+this.pageAnterior+"</a>");
	$(this.object).find("[data-goto="+this.pageActual+"]").addClass("current").html("<span class='show-for-sr'>"+this.lang_actual+"</span> "+this.pageActual);;
}


/********************************************/
/* NORMALIZA FILAS DE PARTIDOS Y RESULTADOS */
/********************************************/
function equalizeReducidasRows(containerElem){
	var i=0;
	var elem=containerElem;
	if(typeof elem == 'undefined'){
		$('table.quiniela:not([data-betsSummary])  tr').each(function(){
				var biggestTDMAHeight = 0;
				var biggestTDBSHeight = 0;
				$(this).children().each(function(){
					if($(this).outerHeight() > biggestTDMAHeight){
						biggestTDMAHeight = $(this).outerHeight();
					}
				})
				$('table.quiniela[data-betsSummary]:visible  tr:eq('+i+') >*').each(function(){
					if($(this).outerHeight() > biggestTDBSHeight){
						biggestTDBSHeight = $(this).outerHeight();
					}
				})
				if( biggestTDMAHeight > biggestTDBSHeight){
					$('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').css('height',biggestTDMAHeight+'px');
				}else{
					$(this).css('height',biggestTDBSHeight+'px')
				}
/*
			if( $(this).outerHeight() > $('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').outerHeight()){
				$('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').css('height',$(this).outerHeight()+'px');
			}else{
				$(this).css('height',$('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').outerHeight()+'px')
			}
*/
			i++;
		})
		if (/Edge/.test(navigator.userAgent)) {
			$('table.quiniela').css('table-layout','inherit') //Hack para edge, que no le gusta el redimensionado dinámico de las filas
		}

	}else{
		$(containerElem).each(function(k,v){
			i=0;
			$(v).find('table.quiniela:not([data-betsSummary])  tr').each(function(){
				var biggestTDMAHeight = 0;
				var biggestTDBSHeight = 0;
				$(this).children().each(function(){
					if($(this).outerHeight() > biggestTDMAHeight){
						biggestTDMAHeight = $(this).outerHeight();
					}
				})
				$(v).find('table.quiniela[data-betsSummary]:visible  tr:eq('+i+') >*').each(function(){
					if($(this).outerHeight() > biggestTDBSHeight){
						biggestTDBSHeight = $(this).outerHeight();
					}
				})


				if( biggestTDMAHeight > biggestTDBSHeight){
					$(v).find('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').css('height',biggestTDMAHeight+'px');
				}else{
					$(this).css('height',biggestTDBSHeight+'px')
				}

/*
				if( $(this).outerHeight() > $(v).find('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').outerHeight()){
					$(v).find('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').css('height',$(this).outerHeight()+'px');
				}else{
					$(this).css('height',$(v).find('table.quiniela[data-betsSummary]:visible  tr:eq('+i+')').outerHeight()+'px')
				}
*/
				i++;
			})

		})
		$('table.quiniela').css('table-layout','inherit') //Hack para edge, que no le gusta el redimensionado dinámico de las filas


	}
}





//FUNCION QUE INYECTA DINAMICAMENTE UN BOLETO POR AJAX Y LIMPIA EL DOM DE BOLETOS ANTERIORES
function loadDynamicBoleto(tipoSorteo,injectTo,clearElem,callbackOnSuccess,options){

	var modoComunidad 		= false;
	var periodicidad		= 0;
	var decimo 				= false;
	var precioParticipacion = 0;
	var dataParams 			= {};
	var peticiones 			= "";
	var discount 			= "";
	var ignoreCookies		= false;
	var ignoreFileSending	= true;
	var sorteo;
	var callback=function(){};

 	if(options){
 		if ( typeof options.modoComunidad != "undefined" ) 		{ modoComunidad 		= options.modoComunidad; }
 		if ( typeof options.periodicidad != "undefined" ) 		{ periodicidad 			= options.periodicidad; }
 		if ( typeof options.precioParticipacion != "undefined") { precioParticipacion 	= options.precioParticipacion; }
 		if ( typeof options.decimo != "undefined") 				{
	 		if(options.decimo.length > 0){
		 		decimo = options.decimo;
		 	}else{
			 	//Si decimo llega "", es porque el juego está cerrado. No seguimos.
			 	return false;
		 	}
	 	}
 		if ( typeof options.peticiones != "undefined") 			{ peticiones 			= options.peticiones; }
 		if ( typeof options.discount != "undefined") 			{ discount 				= options.discount; }
 		if ( typeof options.ignoreCookies != "undefined") 		{ ignoreCookies 		= options.ignoreCookies; }
 		if ( typeof options.ignoreFileSending != "undefined") 	{ ignoreFileSending 	= options.ignoreFileSending; }
 		if ( typeof options.sorteo != "undefined") 	{ sorteo = options.sorteo; }
 		if ( typeof callbackOnSuccess != "undefined") 	{ callback = callbackOnSuccess; }

 	}
	clearDynamicBoleto(clearElem);

	if(!modoComunidad){
		var ajaxURL="/data/?action=getBoleto&tipo="+tipoSorteo+"&typeDiscount="+discount+"&ignoreCookies="+ignoreCookies;
	} else {
		var ajaxURL="/data/?action=getBoleto&tipo="+tipoSorteo+"&modoComunidad="+modoComunidad+"&ignoreCookies="+ignoreCookies+"&periodicidad="+periodicidad+"&sorteo="+sorteo;
	}

	ajaxURL = ajaxURL + "&precioParticipacion=" + precioParticipacion;
	if(decimo) {
		var ajaxURL = "/data/?action=getDecimo";
		if(modoComunidad) {
			ajaxURL = "/data/?action=getDecimoComunidad&modoComunidad="+modoComunidad+"&periodicidad="+periodicidad;
		}
		ajaxURL += "&tipo="+tipoSorteo+"&sorteo="+decimo;
		dataParams = {"peticiones":JSON.stringify(peticiones)};
	}

	ajaxURL = ajaxURL+ "&ignoreFileSending="+ignoreFileSending;

	var paramsURL = parseQueryString();
	if(typeof paramsURL["partner"] != 'undefined') {
		ajaxURL = ajaxURL+ "&partner="+paramsURL["partner"];
	}

	$.ajax({
		type: "POST",
		url: ajaxURL,
		dataType: 'json',
		data: dataParams,
		success: function(data)	{
			$(injectTo).html(data.data);
			callback();
		},
		error: function() {

		}
	});

	function clearDynamicBoleto(elemToClear){
		$(elemToClear).empty();
	}
}

var parseQueryString = function() {

    var str = window.location.search;
    var objURL = {};

    str.replace(
        new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
        function( $0, $1, $2, $3 ){
            objURL[ $1 ] = $3;
        }
    );
    return objURL;
};

//Clase para caja de bonus por cantidad de apuestas
var tramosPrice = function(precioPorDefecto,descuentosObj,purchaseOptionsObj,options){
	/*
	var descuentosObj = {
						'tramos':[
									{
										'inicio': 1,
										'fin': 2,
										'precioPorApuesta': 1
									},
									{
										'inicio': 3,
										'fin': 4,
										'precioPorApuesta': 0.5
									},
									{
										'inicio': 5,
										'fin': 999,
										'precioPorApuesta': 0.25
									}
								],
								'precioPorRenovacion': 0.25,
								'bonusesInCart': true|false 			//si existe, indica hay ofertas aplicadas por haber apuestas en el carro.
					}
	*/
	this.precioPorDefecto = precioPorDefecto;
	this.descuentosObj = descuentosObj;
	this.purchaseOptionsObj = purchaseOptionsObj;
	this.strings = {
		superPrice:"{t}¡Super precio!{/t}",
		betPrice: "{t}Precio de apuesta{/t}",
		betsOrSubscribe:"{t}apuestas o abónate{/t}",
		subscribe:"{t}Si te abonas{/t}",
		bets: "{t}apuestas{/t}",
		discountAppliedToPurchase: "{t}Descuento aplicado en tu compra{/t}",
		discountAppliedToPurchaseExtended: "{t}Consigues un gran precio al comprar múltiples apuestas, ya que se tienen en cuenta las que tienes en el carro de compra.{/t}"
	}
	this.isAbonoActive = false;

	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.superPrice != "undefined"){ this.strings.superPrice = options.strings.superPrice}
			if(typeof options.strings.betPrice != "undefined"){ this.strings.betPrice = options.strings.betPrice}
			if(typeof options.strings.betsOrSubscribe != "undefined"){ this.strings.betsOrSubscribe = options.strings.betsOrSubscribe}
			if(typeof options.strings.subscribe != "undefined"){ this.strings.subscribe = options.strings.subscribe}
			if(typeof options.strings.bets != "undefined"){ this.strings.bets = options.strings.bets}
			if(typeof options.strings.discountAppliedToPurchase != "undefined"){ this.strings.discountAppliedToPurchase = options.strings.discountAppliedToPurchase}
			if(typeof options.strings.discountAppliedToPurchaseExtended != "undefined"){ this.strings.discountAppliedToPurchaseExtended = options.strings.discountAppliedToPurchaseExtended}
		}
	}
	var self = this;

	this.currentActiveTramo = false;  //false -> no se han establecido, //0: sin tramo aplicable (precio por defecto)  , // > 0: tramo activo
}

tramosPrice.prototype.setNewTramos = function(newDescuentosObj){
	//Método que:
	//Reemplaza los datos de tramos por uno nuevo.
	//No recalcula ni obtiene nada, hay que llamar a los métodos que se deseen de nuevo
	//*********************************************************************************
	this.descuentosObj = newDescuentosObj;
	this.currentActiveTramo = false;
	this.isAbonoActive = false;
}

tramosPrice.prototype.render = function(renderIntoSelector){
	//Método que:
	//Renderiza la UI en el selector indicado, con los datos de tramos
	//**************************************************************************
	var self = this;
	var lowestPrice = self.precioPorDefecto;
	var superPrecioHTML = '<span class="superPrecio"><span>'+this.strings.superPrice+'</span></span>';
	var inCartHTML = '<dl data-bonuses-cart><dt><strong>'+this.strings.discountAppliedToPurchase+'</strong><dd>'+this.strings.discountAppliedToPurchaseExtended+'</dd></dl>';


	if(typeof global_currency == "undefined"){
		var ppp = parseFloat(this.precioPorDefecto).formatMoney(2, ',', '.') + '€';
	}else{
		var ppp = global_currency.getMoneda(parseFloat(this.precioPorDefecto),null,{wrapper:"small"});
	}
	var precioPorApuestaHTML = '<div class="column column-block">'+
									'<div data-bonusItem>'+
										'<span></span>'+
										'<p>' + this.strings.betPrice + ': <strong data-price>'+ ppp +'</strong></p>'+
									'</div>'+
								'</div>';
	var tramosHTML = "";
	var lastTramoValue = 0;
	var lowestPriceTramo = 0;
	if(this.descuentosObj.tramos != null && this.descuentosObj.tramos.length > 1){
		$.each(this.descuentosObj.tramos,function(k,v){
			if(v.fin > lastTramoValue){
				lastTramoValue = v.fin;
			}
			if(v.precioPorApuesta < lowestPrice){
				lowestPrice = v.precioPorApuesta
			}
		})
	}else{
		var lastRangoHTML = "";
		if(self.descuentosObj.precioPorRenovacion < self.precioPorDefecto){
			if(typeof global_currency == "undefined"){
				var ppp = parseFloat(self.descuentosObj.precioPorRenovacion).formatMoney(2, ',', '.') + '€';
			}else{
				var ppp = global_currency.getMoneda(parseFloat(self.descuentosObj.precioPorRenovacion),null,{wrapper:"small"});
			}

			lastRangoHTML = lastRangoHTML + '<p><strong>' + self.strings.subscribe + ': </strong> <strong data-price>' + ppp + '</strong>';
			lastRangoHTML = lastRangoHTML + superPrecioHTML + '</p>';
			tramosHTML = tramosHTML + '	<div class="column column-block">'+
											'<div data-bonusItem>'+
												'<span></span>'+ lastRangoHTML +
											'</div>'+
										'</div>'
		}
	}
	$.each(this.descuentosObj.tramos,function(k,v){
		var rangoHTML = "";
		var lastRangoHTML = "";
		if(typeof global_currency == "undefined"){
			var ppp = parseFloat(v.precioPorApuesta).formatMoney(2, ',', '.') + '€';
		}else{
			var ppp = global_currency.getMoneda(parseFloat(v.precioPorApuesta),null,{wrapper:"small"});
		}
		if(v.fin < lastTramoValue){
			if(v.inicio != v.fin){
				var ran = '<strong>' + v.inicio + '</strong>-<strong>' + v.fin + '</strong> ';
			}else{
				var ran = '<strong>' + v.inicio + '</strong> ';
			}

			if(v.precioPorApuesta == self.descuentosObj.precioPorRenovacion){
				rangoHTML = rangoHTML + '<p>'+ ran + self.strings.betsOrSubscribe + ': <strong data-price>' + ppp + '</strong>';
				if(lowestPrice == v.precioPorApuesta){
					rangoHTML = rangoHTML + superPrecioHTML;
				}
			}else{
				rangoHTML = rangoHTML + '<p>' + ran + self.strings.bets + ': <strong data-price>' + ppp + '</strong>';
				if(lowestPrice == v.precioPorApuesta){
					rangoHTML = rangoHTML + superPrecioHTML;
				}
			}
			rangoHTML = rangoHTML + "</p>";
		}else{
			if(v.precioPorApuesta == self.descuentosObj.precioPorRenovacion){
				lastRangoHTML = lastRangoHTML + '<p><strong>' + v.inicio + '</strong>+ '+ self.strings.betsOrSubscribe + ': <strong data-price>' + ppp + '</strong>';
				if(lowestPrice == v.precioPorApuesta){
					lastRangoHTML = lastRangoHTML + superPrecioHTML;
				}
			}else{
				lastRangoHTML = lastRangoHTML + '<p><strong>' + v.inicio + '</strong>+ '+ self.strings.bets + ': <strong data-price>' + ppp + '</strong>';
				if(lowestPrice == v.precioPorApuesta){
					lastRangoHTML = lastRangoHTML + superPrecioHTML;
				}
			}
			lastRangoHTML = lastRangoHTML + "</p>";
		}

		tramosHTML = tramosHTML + '	<div class="column column-block">'+
										'<div data-bonusItem>'+
											'<span></span>'+ rangoHTML + lastRangoHTML +
										'</div>'+
									'</div>'
	})

	var	HTMLFinal = '	<div data-bonusesPerPurchase class="is-active">'+
							'<div class="row small-up-3 collapse">' + precioPorApuestaHTML + tramosHTML +
							'</div>'+
						'</div>'

	if(typeof self.descuentosObj.bonusesInCart != "undefined" && self.descuentosObj.bonusesInCart === true){
		var defPrice 	= self.getDefaultPrice();
		var abonoPrice	= self.descuentosObj.precioPorRenovacion;
		var foundLowerThanPrice = false;
		$(self.descuentosObj.tramos).each(function(tramokey,tramovalue){
			if(tramovalue.precioPorApuesta < defPrice){
				foundLowerThanPrice = true;
			}
		})
		if(abonoPrice < defPrice){
			foundLowerThanPrice = true;
		}
		if(foundLowerThanPrice){
			HTMLFinal = HTMLFinal + inCartHTML;
		}
	}

	if(typeof renderIntoSelector != "undefined"){
		$(renderIntoSelector).html(HTMLFinal);
	}else{
		return HTMLFinal;
	}
}

tramosPrice.prototype.updateTramoPrize = function(apuestas,dias,semanas,esDecimo){
	//Método que:
	//Obtiene el tramo correspondiente en función de los datos indicados, y establece los importes en el objeto purchaseOption pasado al inicializar la instancia
	//***********************************************************************************************************************************************************
	var self = this;
	var isDecimo = false;
	var days = 1;
	var weeks = 1;
	var apuestasTotal = false; //incluyendo dias, y semanas
	if(typeof semanas == "number"){
		weeks = semanas;
	}
	if(typeof days == "number"){
		days = dias;
	}
	if(typeof esDecimo != "undefined" && esDecimo === true){
		isDecimo = true;
	}
	if(typeof apuestas === "number"){
		apuestasTotal = apuestas * dias * semanas
	}else{
		apuestasTotal = apuestas
	}
	var tramoIndex = self.getCurrentTramo(apuestasTotal);

	if(typeof apuestas == "number" && apuestas >= 0){
		if(tramoIndex != 0){ //si es decimo y no hay tramo disponible (es falso,pej. cuando hay 0 apuestas), hay que devolver 0 y no el importe por defecto
			if(!self.isAbonoActive){
				self.purchaseOptionsObj.setPrice(self.descuentosObj.tramos[tramoIndex-1].precioPorApuesta,apuestas,true);
				self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
			}else{ //Si es abono, usamos el precio del abono en todos los casos
				//Cambiamos el precio si el abono es más alto que el tramo correspondiente
				if(tramoIndex != "abonoOnly"){
					if(self.descuentosObj.precioPorRenovacion <= self.descuentosObj.tramos[tramoIndex-1].precioPorApuesta){
						self.purchaseOptionsObj.setPrice(self.descuentosObj.precioPorRenovacion,apuestas,true);
						self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
					}else{
						self.purchaseOptionsObj.setPrice(self.descuentosObj.tramos[tramoIndex-1].precioPorApuesta,apuestas,true);
						self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
					}
				}else{ //Si no hay tramos, y sólo existen descuentos por renovación
					if(self.descuentosObj.precioPorRenovacion < self.precioPorDefecto){
						self.purchaseOptionsObj.setPrice(self.descuentosObj.precioPorRenovacion,apuestas,true);
						self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
					}
				}
			}
		}else{
			self.purchaseOptionsObj.setPrice(self.precioPorDefecto,apuestas,true);
		}
	}else{
		//Refrescamos precio para los ya marcados cuando se esté abonado
		if(typeof self.purchaseOptionsObj.numeroApuestas == "number"){
			if(tramoIndex != 0){
				if(tramoIndex != "abonoOnly"){
					self.purchaseOptionsObj.setPrice(self.descuentosObj.tramos[tramoIndex-1].precioPorApuesta,self.purchaseOptionsObj.numeroApuestas,true);
					self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
				}else{
					//Si no hay tramos, y sólo existen descuentos por renovación
					if(self.descuentosObj.precioPorRenovacion < self.precioPorDefecto){
						self.purchaseOptionsObj.setPrice(self.descuentosObj.precioPorRenovacion,self.purchaseOptionsObj.numeroApuestas,true);
						self.purchaseOptionsObj.setManualDiscount(self.precioPorDefecto);
					}
				}
			}else{
				if(!isDecimo){ //Si es un décimo de lotería, se ignora porque los cálculos se hacen desde fuera
					if(typeof self.purchaseOptionsObj.numeroApuestas == "number"){
						var ap = self.purchaseOptionsObj.numeroApuestas * self.purchaseOptionsObj.dias * self.purchaseOptionsObj.semanas
						var currentTramo = false;
						$(this.descuentosObj.tramos).each(function(k,v){
							//Obtenemos tramo al que correspondería el número de apuesta lo guardamos
							if(ap >= v.inicio && ap <= v.fin){
								currentTramo = k;
							}
						})
						if(currentTramo !== false && (self.descuentosObj.tramos[currentTramo].precioPorApuesta <= self.precioPorDefecto)){
							self.purchaseOptionsObj.setPrice(self.descuentosObj.tramos[currentTramo].precioPorApuesta,self.purchaseOptionsObj.numeroApuestas,true);
						}else{
							self.purchaseOptionsObj.setPrice(self.precioPorDefecto,self.purchaseOptionsObj.numeroApuestas,true);
						}


					}else{
						self.purchaseOptionsObj.setPrice(self.precioPorDefecto,self.purchaseOptionsObj.numeroApuestas,true);
					}

				}
			}
		}
	}
}

tramosPrice.prototype.setActiveTramo = function(tramo){
	//Método que:
	//Establece el índice del tramo activo en la UI
	//**************************************************************************
	this.currentActiveTramo = tramo;
}

tramosPrice.prototype.getActiveTramo = function(){
	//Método que:
	//Obtiene el índice del tramo activo en la UI
	//**************************************************************************
	//false -> no se ha establecido en la interfaz, //0: sin tramo aplicable (precio por defecto)  , // > 0: tramo activo
	if(this.currentActiveTramo && (this.currentActiveTramo > 0 || this.currentActiveTramo == "abonoOnly")){
		return this.currentActiveTramo;
	}else{
		return false;
	}

}

tramosPrice.prototype.setUITramo = function(apuestas,dias,semanas){
	//Método que:
	//Obtiene el tramo correspondiente y establece la UI en función de los datos indicados
	//*************************************************************************************

	var self = this;
	var days = 1 ;
	var weeks = 1;
	$('[data-bonusesperpurchase] [data-bonusitem]').removeClass('is-active');
	$('[data-bonusesperpurchase] [data-bonusitem]').closest('.column').removeClass('is-active');

	if(typeof apuestas !="undefined"){
		if(typeof semanas != "undefined"){
			weeks = semanas
		}
		if(typeof dias != "undefined"){
			days = dias
		}
		if(typeof apuestas === "number"){
			apuestas = apuestas * dias * semanas
		}
		var tramoIndex = self.getCurrentTramo(apuestas);

		var activarDescuentosAbonos = false;

		//Si los abonos cuestan igual que el precio base, no hay descuentos por abonos y no los tenemos en cuenta para nada
		if(typeof apuestas === "boolean" && self.descuentosObj.precioPorRenovacion != self.descuentosObj.precioPorRenovacion){
			activarDescuentosAbonos = true;
		}


		if(tramoIndex !== false){
			if(tramoIndex != "abonoOnly"){
				$('[data-bonusesperpurchase] [data-bonusitem]').eq(tramoIndex).addClass('is-active');
				$('[data-bonusesperpurchase] [data-bonusitem]').eq(tramoIndex).closest('.column').addClass('is-active');
				self.setActiveTramo(tramoIndex);
			}else{
				//Si no hay tramos, y sólo existen descuentos por renovación
				$('[data-bonusesperpurchase] [data-bonusitem]').eq(1).addClass('is-active');
				$('[data-bonusesperpurchase] [data-bonusitem]').eq(1).closest('.column').addClass('is-active');
				self.setActiveTramo("abonoOnly");
			}

		}else if(tramoIndex === false){
			$('[data-bonusesperpurchase] [data-bonusitem]').eq(0).addClass('is-active');
			$('[data-bonusesperpurchase] [data-bonusitem]').eq(0).closest('.column').addClass('is-active');
			self.setActiveTramo(0);
		}

	}

}

tramosPrice.prototype.getCurrentTramo = function(apuestas){
	//Método que:
	//Obtiene el índice del tramo que corresponde al número de apuestas indicado
	//**************************************************************************


	var self = this;
	var valueToReturn = false;
	//Si apuestas es TRUE, activamos el abono y buscamos el tramo que coincida con su precio
	//Si apuestas es FALSE, desactivamos el abono, y reevaluamos las apuestas y su precio
	var abonoDescuentoViabilidad = false;
	var thereIsABetterMatch = false;
	var currentTramo = false;
	var abonoTramo = false;
	//Si los abonos cuestan igual que el precio base, no hay descuentos por abonos y no los tenemos en cuenta para nada

	if(self.descuentosObj.precioPorRenovacion != self.precioPorDefecto){
		abonoDescuentoViabilidad = true;
	}

	if(typeof apuestas == "number" || apuestas === true){

		if((abonoDescuentoViabilidad && typeof apuestas == "boolean" && apuestas === true) || self.isAbonoActive){ //Detectamos si estamos ante una activación de un abono
			self.isAbonoActive = true;
		}
		if(typeof apuestas == "boolean"){ //Si se activa o desactiva el botón de abonos, apuestas llega true|false, hay que obtener el nº de apuestas a través de purchaseOptionsObj
			if(typeof self.purchaseOptionsObj != "undefined" && typeof self.purchaseOptionsObj.numeroApuestas == "number"){
				var ap = self.purchaseOptionsObj.numeroApuestas * self.purchaseOptionsObj.dias * self.purchaseOptionsObj.semanas
			}
		}else{
			var ap = apuestas;
		}

		if(this.descuentosObj.tramos != null && this.descuentosObj.tramos.length > 0){
			$(this.descuentosObj.tramos).each(function(k,v){
				//Obtenemos tramo al que correspondería el número de apuesta lo guardamos
				if(ap >= v.inicio && ap <= v.fin){
					currentTramo = k + 1;
				}
				//Si el abono está activo y es viable buscamos su tramo
				if(abonoDescuentoViabilidad && self.isAbonoActive/* typeof apuestas == "boolean" && apuestas === true */){
					if(v.precioPorApuesta == self.descuentosObj.precioPorRenovacion){
						abonoTramo = k + 1;
					}
				}
			})
		}else{
			//Si no hay tramos, pero hay un abono activo:
			if(abonoDescuentoViabilidad && self.isAbonoActive){
				if(self.descuentosObj.precioPorRenovacion <= self.precioPorDefecto){
					abonoTramo = true;
					currentTramo = null;
				}
			}

		}
		valueToReturn = currentTramo;
		if(!abonoTramo){ //Si al recorrer todos los tramos , no hay abono coincidente, desactivamos el modo abono
			self.isAbonoActive = false;
			valueToReturn = currentTramo;
		}else if(abonoTramo === true &&	currentTramo === null ){	//Existe abono y no hay tramos definidos. Devolvemos "abonoOnly".
			return "abonoOnly";
		}else if(abonoTramo && currentTramo){			//Si hay abono, miramos si las condiciones del tramo actual son mejores, entonces descartamos el abono. Si no, lo usamos.
			if(self.descuentosObj.tramos[abonoTramo-1].precioPorApuesta < self.descuentosObj.tramos[currentTramo-1].precioPorApuesta){
				valueToReturn = abonoTramo;
			}else{
				valueToReturn = currentTramo;
			}
		}else if(abonoTramo && !currentTramo){
			valueToReturn = abonoTramo;
		}


	} else if (apuestas === false && abonoDescuentoViabilidad){
		self.isAbonoActive = false;
		valueToReturn = 0;
		if(self.purchaseOptionsObj.numeroApuestas){
			if(self.descuentosObj.tramos != null && self.descuentosObj.tramos.length > 0 ){
				$(self.descuentosObj.tramos).each(function(k,v){
					if(typeof self.purchaseOptionsObj != "undefined" && typeof self.purchaseOptionsObj.numeroApuestas == "number"){
						if(self.purchaseOptionsObj.numeroApuestas*self.purchaseOptionsObj.dias * self.purchaseOptionsObj.semanas >= v.inicio && self.purchaseOptionsObj.numeroApuestas*self.purchaseOptionsObj.dias * self.purchaseOptionsObj.semanas <= v.fin){
							valueToReturn = k + 1;
							return false;
						}
					}
				})
			}
		}
	}
	return valueToReturn;
}

tramosPrice.prototype.getActiveTramoPrice = function(){
	//Método que:
	//Obtiene el precio del tramo activo en la UI
	//*******************************************
	var self = this;
	var tramoActivo = self.getActiveTramo();
	if(tramoActivo){
		if(tramoActivo > 0 || tramoActivo == "abonoOnly"){
			if(tramoActivo != "abonoOnly"){
				return parseFloat(self.descuentosObj.tramos[tramoActivo-1].precioPorApuesta);
			}else{
				return parseFloat(self.descuentosObj.precioPorRenovacion);
			}
		}else{
			return self.precioPorDefecto;
		}
	}else{
		return self.precioPorDefecto;
	}
}

tramosPrice.prototype.getTramoPriceFromApuestas = function(apuestas){
	//Método que:
	//Obtiene el tramo que corresponde al número de apuestas indicado y devuelve su precio
	//Si se pasa TRUE en lugar de apuestas, es que hay abono
	//************************************************************************************
	var self = this;

	var tramo = self.getCurrentTramo(apuestas);
	if(tramo){
		if(tramo > 0 || tramo == "abonoOnly"){
			if(tramo != "abonoOnly"){
				return parseFloat(self.descuentosObj.tramos[tramo-1].precioPorApuesta);
			}else{
				return parseFloat(self.descuentosObj.precioPorRenovacion);
			}
		}else{
			return self.precioPorDefecto;
		}
	}else{
		return self.precioPorDefecto;
	}
}

tramosPrice.prototype.getDefaultPrice = function(){
	return this.precioPorDefecto;
}


//objeto para opciones de compra
/**
 * Función encarga de calcular el precio de cualquier tipo de juego.
 */
var purchaseOptions = function (game,price,options) {

	var parentObj = this;
	this.game 					= game;
	this.priceBet 				= parseFloat(price);
	this.canBuy 				= false;
	this.price 					= 0.0;
	this.priceWithoutDiscount 	= 0.0;
	this.numeroApuestas 		= 0;
	this.semanas 				= 1;
	this.dias					= 1;
	this.abono					= false;
	this.abonoRandom			= false;
	this.itemIDforEdition		= false; //Establece si se está editando, almacenará el id del
	this.minAbonoSemanas 		= 1;	 //Número mínimo de semanas que es necesario jugar al activar el abono
	// Juegos con mini-sorteos adicionales
	this.additionalGame			= false;
	this.originalGamePrice		= this.priceBet;	//Precio original por apuesta del juego
/*
	this.additionalGame = new Array({
		game:"elige8",
		precio: 0.50,
		bets: 1
	})
*/
	// Primitiva
	this.jokerPrice 			= 0;
	this.playJoker 				= false;
	// Décimos
	this.pricePartDecimos		= 0;
	this.partDecimos 			= 0;
	// Descuento apuesta
	this.discount 				= 0;
	this.discountPercentage		= 0;
	this.discountExtra			= 0;
	this.dataDiscount;
	this.discountPromo			= 0;
	this.free 					= false;
	// Proviene de fichero
	this.betsFromFile			= false;
	// Objeto numberChooser
	this.numberChooserObj		= false;

	// Variables opcionales
	if(typeof(options)!="undefined") {
		if(typeof(options.precioParts)!="undefined") 			{ this.pricePartDecimos = options.precioParts; } //#1 Décimos
		if(typeof(options.discount)!="undefined") 				{ this.discountPromo = options.discount; }
		if(typeof(options.dataDiscount)!="undefined") 			{ this.dataDiscount = options.dataDiscount; }
		if(typeof(options.betsFromFile)!="undefined") 			{ this.betsFromFile = options.betsFromFile; }
		if(typeof(options.numberChooserObj)!="undefined") 		{ this.numberChooserObj = options.numberChooserObj; }
		if(typeof options.itemIDforEdition !="undefined") 		{ this.itemIDforEdition = options.itemIDforEdition }
		if(typeof options.additionalGame != "undefined")		{ this.playAdditionalGame = options.additionalGame }
		if(typeof options.minAbonoSemanas != "undefined")		{ this.minAbonoSemanas = options.minAbonoSemanas;}

	}

	this.init();
}

purchaseOptions.prototype.init = function(){
	var parentObj = this;
	this.setCanBuy = function(canBuy) {
		this.canBuy = canBuy;
		updateButtonCompra(this);
	}

	this.updatePrice = function(numeroApuestas) {
		if(typeof(price)!="undefined") {
			this.priceBet = price;
		}
		this.numeroApuestas = numeroApuestas;

		var price = this.calculatePrice(this.numeroApuestas*this.semanas*this.dias,false);

		if(this.playJoker || this.additionalGame) {

			if(this.playJoker){
				price += this.jokerPrice*this.semanas*this.dias;
			}

			//Si hay mini-juegos adicionales, se añaden a los cálculos
			if(this.additionalGame && numeroApuestas>0){
				$(this.additionalGame).each(function(k,v){
					if(v.state){
						price += v.precio*v.bets*parentObj.semanas*parentObj.dias;
					}
				})
			}
		}
		if(typeof(this.dataDiscount)!="undefined" || typeof(this.discountPromo)=="object") {
			this.calculateDiscount(price);
			this.priceWithoutDiscount = price.toFixed(2);
		}
		price = price - this.discount - this.discountExtra;
		if(price<0 && (this.discount>0 || this.discountExtra>0)) price = 0;
		if(parseFloat(this.discount)>0) this.discount = (this.discount).toFixed(2);
		if(parseFloat(this.discountExtra)>0) this.discountExtra = (this.discountExtra).toFixed(2);
		this.price = price.toFixed(2);
		updatePriceLabels(this);
	}

	this.calculateDiscount = function (price) {
		var discountPrice = 0;
		var apuestasPart = this.numeroApuestas*this.semanas*this.dias;
		if(typeof this.dataDiscount != "undefined" && (this.semanas>=this.dataDiscount.descuentoSemanasMin || (this.dataDiscount.descuentoPart && apuestasPart>=this.dataDiscount.descuentoPart))) {
			if(typeof(this.dataDiscount.descuentoRango)!="undefined") {
				var mediaRangoSemana = Math.floor((this.semanas-this.dataDiscount.descuentoSemanasMin)/parseInt(this.dataDiscount.descuentoRango));
				discountPrice = (Math.round(((mediaRangoSemana*this.dataDiscount.descuentoAumento)+parseFloat(this.dataDiscount.descuentoPorcentaje))*100)/100).toFixed(2);
			} else {
				discountPrice = this.dataDiscount.descuentoPorcentaje;
			}
		}
		this.discountPercentage = (discountPrice*100).toFixed(2);
		this.discount = price - (price*(1-discountPrice));
		// Discount by promo/code
		this.discountExtra = 0;
		if(typeof(this.discountPromo)=="object") {
			switch(this.discountPromo.type) {
				case "bet":
					this.discountExtra = this.priceBet*this.discountPromo.bets;
				break;
				case "amount":
					this.discountExtra = this.discountPromo.amount.toFixed(2);
				break;
			}
		}
	}

	this.setDays = function(nameControl) {
		this.dias = $("["+nameControl+"]").find("input:checked").length;
		if (this.dias == 0) {
			this.dias = $("["+nameControl+"]").find("input:not([data-value=-1])").length;
		}

	}

	this.calculatePrice = function (numeroApuestas,format,price) {
		if(typeof(price)!="undefined") {
			this.priceBet = price;
		}
		var price = this.priceBet*numeroApuestas;
		price += this.pricePartDecimos*this.partDecimos; //#1
		if(format) {
			price = Math.round(price * 100)/100;
			price.toFixed(2)
		}
		return price;
	}

	this.setSorteos = function(arrayOfSorteos){
		$('[data-daysChooser] input').prop('checked',false).trigger('change').parent('label').removeClass('is-active')
		$(arrayOfSorteos).each(function(key,value){
			if($('[data-daysChooser] input').length==1){
				$('[data-daysChooser] input:eq('+value+')').removeAttr('disabled').trigger('click').attr('disabled','disabled');
			}else{
				$('[data-daysChooser] input:eq('+value+')').trigger('click');
			}
		})
		parentObj.setDays;
	}
	this.getCurrentSorteoWeek = function(){
		var valor = $('[data-daysChooser] input[data-orderday=0]').attr('data-value');
		return valor;
	}

	this.setSemanas = function(semanas){
		var elem=$('[data-weeksChooser] input[data-value='+semanas+']');
		if($(elem).length>0){
			$(elem).trigger('click').prop("checked",true);
			this.semanas=parseInt(semanas);
		}
	}
	this.setRenew = function(boolOfRenewal,boolOfRandomRenewal){
		if(boolOfRenewal==true){
			$('[data-abonoChooser] input').prop('checked',true).trigger('change').parent('label').addClass('is-active');
			if(boolOfRandomRenewal==true){
				$('[data-abonoRandom] input').prop('checked',true).trigger('change').parent('label').addClass('is-active');
			}else{
				$('[data-abonoRandom] input').prop('checked',false).trigger('change').parent('label').removeClass('is-active');
			}
		}else{
			$('[data-abonoChooser] input').prop('checked',false).trigger('change').parent('label').removeClass('is-active');
		}
	}
}

purchaseOptions.prototype.setAdditionalGame = function (state,additionalGameObj){
	//	"state":true		//Si se tiene en cuenta o no, para activarlo o desactivarlo en los calculos

	//additionalGameObj
	//{
	//	"game":"elige8", 	//juego
	//	"price":0.50,		//precio por apuesta
	//	"state":true,
	//	"bets":3
	//}
	var self = this;
	var found = false;
	$(this.additionalGame).each(function(k,v){
		if(v.game == additionalGameObj.game){
			self.additionalGame[k] = additionalGameObj;
			self.additionalGame[k]["state"] = state;
			found = true;
			return false;
		}
	})
	if(!found){
		//Si no está, lo añadimos
		if(!self.additionalGame){
			self.additionalGame = new Array();
		}
		var ag = additionalGameObj;
		ag["state"] = state;
		self.additionalGame.push(ag);
	}


/*

	if(typeof additionalGameObj != "undefined"){
		this.additionalGame = additionalGameObj;
	}
	if(this.additionalGame){
		this.additionalGame["state"] = state;
	}
*/
}
purchaseOptions.prototype.setPrice = function(newPrice,apuestas,updatePrice){
	this.priceBet = parseFloat(newPrice);
	if(updatePrice === true){
		this.init();
		this.updatePrice(apuestas);
	}
}
purchaseOptions.prototype.setManualDiscount = function(basePrice){
	var baseTotal = (this.numeroApuestas * basePrice * this.dias * this.semanas);
	var price = 0;
	var self = this;
	if(self.playJoker || self.additionalGame) {

		if(this.playJoker){
			price += self.jokerPrice*self.semanas*self.dias;
		}

		//Si hay mini-juegos adicionales, se añaden a los cálculos
		if(self.additionalGame && self.numeroApuestas>0){
			$(self.additionalGame).each(function(k,v){
				if(v.state){
					price += v.precio*v.bets*self.semanas*self.dias;
				}
			})
		}
	}
	this.priceWithoutDiscount = (baseTotal+price).toFixed(2);

	updatePriceLabels(this,true);
	this.discountPercentage = 0;
	this.discount = 0;
	this.priceWithoutDiscount = 0;
}

purchaseOptions.prototype.reset = function (options){
	this.numeroApuestas = 0;
	this.price 			= "0,00";
	this.priceWithoutDiscount = "0,00";
	this.setCanBuy(false);
	updatePriceLabels(this);
}

purchaseOptions.prototype.getMinAbonoSemanas = function(){
	return this.minAbonoSemanas;
}
purchaseOptions.prototype.getSemanas = function(){
	return this.semanas;
}
purchaseOptions.prototype.blockWeeksUntil = function(deactivateUntilWeek){
	var elem=$('[data-weeksChooser] input[data-value]');
	$(elem).each(function(k,v){
		var semana = false;
		if(typeof $(v).attr('data-value') != "undefined"){
			semana = parseInt($(v).attr('data-value'));
			if(semana < deactivateUntilWeek){
				$(v).attr('disabled','disabled');
				$(v).closest('label').addClass('disabled');
			}
		}

	})

}
purchaseOptions.prototype.unblockWeeks = function(){
	var elem=$('[data-weeksChooser] input[data-value]');
	$(elem).each(function(k,v){
		$(v).removeAttr('disabled');
		$(v).closest('label').removeClass('disabled');
	})
}

var comunidadOptions = function(game,restantes,playGames,dataGames,importeRestantes,purchaseOptionsObj,elemInfo,elemInfoBets) {

	// var parentObj = this;
	this.gameSelect 		= game;
	this.restantes 			= restantes;
	this.playGames 			= playGames;
	this.priceGames 	 	= dataGames;
	this.importeRes			= importeRestantes;
	this.participaciones 	= 0;
	this.bets 				= new Array();
	this.decimosAdd 		= {};
	this.drawPrice			= {};
	this.drawSelect			= 0;

	if(typeof(elemInfo)!="undefined") {// Muestra el html con la info dependiendo del juego que se esté visualizando
		this.elemInfo 		= elemInfo;
	} else {
		this.elemInfo 		= "[data-info-participaciones-ctrl-purchase-option]";
	}
	if(typeof(elemInfoBets)!="undefined") {// Muestra el html con la info dependiendo del juego que se esté visualizando
		this.elemInfoBets 	= elemInfoBets;
	} else {
		this.elemInfoBets 	= "[data-participaciones-ctrl-purchase-option]";
	}

	// Añade la info
	this.dataInfoCtrlPurchaseOption = function() {
		$("[data-number-of-participaciones]").html(this.formatParticipaciones(this.participaciones));
		$(this.elemInfo).parent().find("span").remove();
		$(this.elemInfoBets).html("0 apuesta");
	}

	this.addParticipaciones = function() {
		this.restantes = parseFloat(this.restantes)-parseFloat(this.participaciones);
		this.restantes = this.formatParticipaciones(this.restantes);
		updateParticipacionesRestantesLabels(this.restantes);
	}

	this.removeParticipaciones = function() {
		this.restantes = (parseFloat(this.restantes)+parseFloat(this.participaciones));
		this.restantes = this.formatParticipaciones(this.restantes);
		updateParticipacionesRestantesLabels(this.restantes);
	}

	this.formatParticipaciones = function(format) {
		if(parseFloat(format).toString() !== format.toString()) {
			format = parseInt(format);
		}
		var n = parseFloat(format).toFixed(2);
		return n;
	}

	this.setCanBuyComunidad = function(participaciones,importeAdd,setbuy) {
		var importeAdd 			= importeAdd;
		var participaciones 	= participaciones;
		var importeRes 			= this.importeRes;
		var buy 				= true;

		if(typeof setbuy != "undefined"){
			var buy = setbuy;
		}

		importeRes -= importeAdd;
		if(importeRes<0) importeRes = 0;
		if(parseFloat(participaciones)>0 && parseFloat(participaciones) <= parseFloat(this.restantes) && buy) {
			$("[data-purchase-button]").removeClass("disabled").removeAttr('disabled');
			$("[data-purchase-button-small]").removeClass("disabled").removeAttr('disabled');
		} else {
			$("[data-purchase-button]").addClass("disabled").attr('disabled','');
			$("[data-purchase-button-small]").addClass("disabled").attr('disabled','');
		}
		// Actualiza los valores de apuestas de los tabs de juegos
		this.updateTabs(importeRes);
		this.participaciones = participaciones;
		this.dataInfoCtrlPurchaseOption();
	}

	this.updateTabs = function (importeRes) {
		for (var indice in this.priceGames) {
			var betsByGame = Math.floor(importeRes/this.priceGames[indice]["precioBase"]);
			if(this.priceGames[indice]["tipo"]=="decimo") {
				var precioPart = this.priceGames[indice]["precioBase"]/4;
		  		var diffDecimals = Math.floor((importeRes - (Math.floor(importeRes/this.priceGames[indice]["precioBase"])*this.priceGames[indice]["precioBase"]))/precioPart)/4;
		  		if(diffDecimals>0) betsByGame += diffDecimals;
			}
			$("[data-max-bets-"+indice+"] span").html(betsByGame);
			if(betsByGame<=0) {
				$("[data-max-bets-"+indice+"]").closest("li").addClass("disabled");
			} else {
				$("[data-max-bets-"+indice+"]").closest("li").removeClass("disabled");
			}
		}
	}

	this.setSorteoDecimos = function(data) {
		var sorteo = data.sorteo;
		this.drawSelect = sorteo;
		var apuestasXpart = ((parseFloat(data.precioBase)*parseFloat(this.priceGames[this.gameSelect]["apuestasXpart"]))/parseFloat(this.priceGames[this.gameSelect]["precioBase"])).toFixed(3);
		if(typeof(this.decimosAdd[sorteo])=="undefined") { this.decimosAdd[sorteo] = {}; }
		if(typeof(this.drawPrice[sorteo])=="undefined") { this.drawPrice[sorteo] = { "decimo":data.precio,"participacion":data.precioParts,"apuestasXpart":apuestasXpart }; }
	}

}
function purchaseOptionsRewrite(myPurchaseOptionsObj,comunidadObject) {
	console.log('launchPOR')

	var originalEvent = purchaseOptionsObj.setDays;
    myPurchaseOptionsObj.setDays = function(){
        originalEvent.apply(this, arguments);
        this.setCanBuy();
    }

	myPurchaseOptionsObj.setCanBuy = function(setBuy) {
		var apuestas = this.numeroApuestas*this.dias;
		if(this.playJoker) apuestas += 1*this.dias;
		var importeAdd = parseInt(apuestas)*parseFloat(comunidadObject.priceGames[this.game]["precioBase"]);
		var participaciones = Math.round((parseInt(apuestas)*parseFloat(comunidadObject.priceGames[this.game]["apuestasXpart"]))*100)/100;
		this.canBuy = setBuy;
		comunidadObject.setCanBuyComunidad(participaciones,importeAdd,setBuy);
	}
	$('[data-joker]').on("change",function(){
		if(myPurchaseOptionsObj.numberChooserObj.isMultipleInProgress){
			myPurchaseOptionsObj.setCanBuy(myPurchaseOptionsObj.canBuy);
		}

	})
}
function calculatePrice(numeroApuestas, precioApuesta, comisionApuesta) {
	return roundNumber(numeroApuestas * (precioApuesta + comisionApuesta));
}
function updatePercentages(numberOfCategories, element) {
	for (var i=1;i<numberOfCategories+1;i++) {
		$("[data-prob-" + i + "]").html(element.attr("data-cat" + i) + "%");
	}
}
function parseGameSelection(juego,options){
	var bets = { rows:[],extra:[],sorteos:[],tipo:juego,idSorteos:[] };

	var chooserObj = false;
	var purchaseOptionsObj = false;
	var listDecimosBuy = false;
	var gameType = "boleto"; //boleto|club|decimo

	if(typeof options != "undefined"){
		if(typeof options.chooserObj != "undefined"){ chooserObj = options.chooserObj }
		if(typeof options.purchaseOptionsObj != "undefined"){ purchaseOptionsObj = options.purchaseOptionsObj; }
		if(typeof options.listDecimos != "undefined"){ listDecimosBuy = options.listDecimos; }
		if(typeof options.gameType != "undefined"){ gameType = options.gameType; }
		if(typeof options.discountPromo != "undefined"){ discountPromo = options.discountPromo; }

	}

	if( typeof options!="undefined" && typeof options.desarrollo != "undefined" ){
		bets.rows = options.desarrollo.split("-");
	} else if(gameType == "boleto"){
		var apuestasUser=chooserObj.getRawValues({exportNumsAndExtras:true});
		bets.rows=apuestasUser["nums"];
		bets.extra=apuestasUser["extras"];
		if(typeof purchaseOptionsObj!="undefined" && purchaseOptionsObj.itemIDforEdition){
			bets.item=purchaseOptionsObj.itemIDforEdition;
		}
		if(typeof apuestasUser["joker"]!="undefined" && apuestasUser["joker"]==1){
			bets.joker=apuestasUser["joker"];
		}
		if(typeof apuestasUser["idReduccion"] != "undefined"){
			bets.reduccion = apuestasUser["idReduccion"];
		}
		if(typeof apuestasUser["condicion"] != "undefined"){
			bets.condiciones = apuestasUser["condicion"];
		}
		if(typeof apuestasUser["multiple"] != "undefined"){
			bets.multiple = apuestasUser["multiple"];
		}
		if(typeof apuestasUser["elige8"]!="undefined" && apuestasUser["elige8"].length > 0){
			bets.elige8=apuestasUser["elige8"];
		}
		if(typeof discountCode!="undefined"){
			bets.discountCode = discountCode;
		}

	} else if(listDecimosBuy){
		for(var sorteo in listDecimosBuy){
			for(var numero in listDecimosBuy[sorteo]){
				if(typeof(listDecimosBuy[sorteo][numero].peticion) == "undefined") listDecimosBuy[sorteo][numero].peticion = 0;
				bets.rows.push({numero:numero,decimos:listDecimosBuy[sorteo][numero].decimos,parts:listDecimosBuy[sorteo][numero].participaciones,
						sorteo:sorteo,peticion:listDecimosBuy[sorteo][numero].peticion});
			}
		}
	} else {
		$('[data-purchase-id]').each(function(){
			if($(this).closest("[data-purchase-options]").length > 0){
				if($(this).closest("[data-purchase-options]").is(":visible")){
					if($(this).text() > 0){
						bets.rows.push({id:$(this).data("purchase-id"),parts:+$(this).text()});
					}
				}
			} else {
				if($(this).text() > 0){
					bets.rows.push({id:$(this).data("purchase-id"),parts:+$(this).text()});
				}
			}
		});
	}

	bets.semanas = parseInt($('[data-weeksChooser]').find("input:checked").data("value"));
	if($('[data-abonoChooser]').length) bets.abono = +$('[data-abonoChooser]').find("input").is(":checked");
	else bets.abono = 0;
	if($('[data-abonoRandom]').length) bets.abonoRandom = +$('[data-abonoRandom]').find("input").is(":checked");
	else bets.abonoRandom = 0;
	$('[data-daysChooser]').find("input:checked").each(function(i,obj){
		if(typeof($(this).attr("data-fixed-date"))!=="undefined") bets.idSorteos.push($(this).attr("data-fixed-date"));
		else bets.sorteos.push($(obj).data("value"));
	});

	return bets;
}

var updatePriceLabels = function(purchaseOptionsObject,forceManual,reset) {
	if(typeof forceManual != "undefined" && forceManual === true){
		if(typeof reset !="undefined" && reset === true){
			$("[data-discount-price]").add("#floatingCart [data-discount-price]").html();
			$("[data-purchase-options]").add("#floatingCart").removeClass("hasDiscounts");

		}else{
			if(typeof global_currency == "undefined"){
				var ppp = purchaseOptionsObject.priceWithoutDiscount+"€";
			}else{
				var ppp = global_currency.getMoneda(parseFloat(purchaseOptionsObject.priceWithoutDiscount),null,{wrapper:"small"});
			}
			$("[data-discount-price]").add("#floatingCart [data-discount-price]").html(ppp);
			$("[data-purchase-options]").add("#floatingCart").addClass("hasDiscounts");
		}
	}else{
		if(typeof global_currency == "undefined"){
			var ppp = purchaseOptionsObject.price + "€";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(purchaseOptionsObject.price),null,{wrapper:"small"});
		}
		$("[data-purchase-total]").add("[data-carttotal-importe]").html(ppp);
		// Discount
		$("[data-discount-percentage]").html(parseFloat(purchaseOptionsObject.discountPercentage)>0? "-"+purchaseOptionsObject.discountPercentage+"%" : "");
		if(typeof global_currency == "undefined"){
			var ppp = parseFloat(purchaseOptionsObject.discount).formatMoney(2, ",", ".")+"€";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(purchaseOptionsObject.discount));
		}
		$("[data-discount-value]").html(purchaseOptionsObject.discount>0 ? ppp : "");
		//Trazamos si viene de un descuento manual
		if(!(purchaseOptionsObject.priceBet != purchaseOptionsObject.originalGamePrice && purchaseOptionsObject.numeroApuestas > 0)){
			if(typeof global_currency == "undefined"){
				var ppp = parseFloat(purchaseOptionsObject.priceWithoutDiscount).formatMoney(2, ",", ".")+"€";
			}else{
				var ppp = global_currency.getMoneda(parseFloat(purchaseOptionsObject.priceWithoutDiscount));
			}
			if(purchaseOptionsObject.numeroApuestas > 0){
				$("[data-discount-price]").html(ppp);
			}else{
				$("[data-discount-price]").html("");
			}
		}else{
			if(typeof global_currency == "undefined"){
				var ppp = parseFloat(purchaseOptionsObject.originalGamePrice*purchaseOptionsObject.numeroApuestas*purchaseOptionsObject.dias*purchaseOptionsObject.semanas).formatMoney(2, ",", ".")+"€";
			}else{
				var ppp = global_currency.getMoneda(parseFloat(purchaseOptionsObject.originalGamePrice*purchaseOptionsObject.numeroApuestas*purchaseOptionsObject.dias*purchaseOptionsObject.semanas));
			}
			$("[data-discount-price]").html(ppp)
		}
		if(purchaseOptionsObject.discount>0 || purchaseOptionsObject.discountExtra>0) {
			$("[data-purchase-options]").add("#floatingCart").addClass("hasDiscounts");
		} else {
			$("[data-purchase-options]").removeClass("hasDiscounts");
		}
		updateButtonCompra(purchaseOptionsObject);
	}

}
var updatePriceLabelsPenyas = function() {
	$("[data-purchase-total]").add("[data-carttotal-importe]").html(myPurchaseOptions.numeroApuestas)
	updateButtonCompra(myPurchaseOptions);
}
var updateParticipacionesLabels = function() {
	$("[data-number-of-participaciones]").html(myPurchaseOptions.numeroParticipaciones);
	$("[data-participaciones-ctrl-purchase-option]").html(myPurchaseOptions.numeroApuestas+" apuestas");
}

var updateButtonCompra = function(purchaseOptionsObject) {
	if (purchaseOptionsObject.canBuy) {
		$("[data-purchase-button]").removeClass("disabled").removeAttr('disabled');
		$("[data-purchase-button-small]").removeClass("disabled").removeAttr('disabled');
	} else {
		$("[data-purchase-button]").addClass("disabled").attr('disabled','');
		$("[data-purchase-button-small]").addClass("disabled").attr('disabled','');
	}
}
var updateParticipacionesRestantesLabels = function(participaciones) {
	$("[data-participaciones-restantes]").html(participaciones)
}


/***********************************/

/***********************************/
/* CONTACTO */
/***********************************/
function launchHelpdeskScripts(formElem,options){
	var ajaxObjParams=false

	var statusMsg = {
						ok: "Mensaje enviado, recibirás respuesta pronto",
						ko: "Error",
						hold: "Enviando ..."
					}

	var submitBt = {
						holdMsg: "..."
					}

	var callback = function(e){
			$(formElem).remove();
			$('#helpdeskPostMessage').removeClass("hide");
		}


	if (typeof options != "undefined"){
		if (typeof options.ajaxObjParams != "undefined"){ ajaxObjParams=options.ajaxObjParams}
	}

	if (ajaxObjParams){
		ajaxObjParams.clearOnSubmit=true,
		ajaxObjParams.callbackOnSuccess = callback
		if(typeof ajaxObjParams.statusMsg == "undefined"){
			ajaxObjParams.statusMsg = statusMsg
		}
		if(typeof ajaxObjParams.submitBt == "undefined"){
			ajaxObjParams.submitBt = submitBt
		}
	}else{
		ajaxObjParams.clearOnSubmit=true,
		ajaxObjParams.callbackOnSuccess = callback
		ajaxObjParams.statusMsg = statusMsg
		ajaxObjParams.submitBt = submitBt
	}

	$(formElem).find('[data-submit]').on('click',function(){
		var formSubmit=new formeSubmit( $(formElem),"/data/?action=helpdeskMessage", ajaxObjParams);
	})
}
function launchChatScripts(zopimToken,zopimObj,options){
	var attempts=10;
	var callback = false;
	var failedCallback = false;
	if (typeof options != "undefined"){
		if(typeof options.callback != "undefined"){ callback = options.callback }
		if(typeof options.failedCallback != "undefined"){ failedCallback = options.failedCallback }
	}
	window.$zopim||(function(d,s){var z=$zopim=function(c){z._.push(c)},$=z.s=d.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set._.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute("charset","utf-8");$.src="https://v2.zopim.com/?"+zopimToken+"";z.t=+new Date;$.type="text/javascript";e.parentNode.insertBefore($,e)})(document,"script");
	var currentAttempt=0;

	$zopim(function(){
		$zopim.livechat.window.hide()
		$zopim.livechat.setOnConnected(function(){
			zopimObj()
			if(callback){ callback() }
		})
	})
	var zopimLoader=setInterval(function(){
		if (typeof($zopim.livechat) != 'undefined'){
			clearInterval(zopimLoader);
		}else{
			currentAttempt++;
		}
		if(currentAttempt==attempts+1){
			clearInterval(zopimLoader);
			if(failedCallback){ failedCallback() }
		}
	}, 1000)
}


function invoqueChat(zopimToken,options){

	var strings = {
		chat: "Chat"
	}

	var loadWithoutOpenChat = false


	if(typeof options != "undefined"){
		if (typeof options.strings != "undefined"){
			if (options.strings.chat != "undefined") { strings.chat = options.strings.chat}
		}
		if (typeof options.loadWithoutOpenChat != "undefined"){
			if(options.loadWithoutOpenChat) { loadWithoutOpenChat = true; } else { loadWithoutOpenChat = false; }
		}

	}

	if(typeof $zopim == "undefined"){
		var zopimCallback = function(){
			if(!loadWithoutOpenChat) {
				bamQueue.waitForExistance("$zopim.state",function(){
 					if($zopim.state=="online"){
						$zopim.livechat.window.show();
					}else if($zopim.state=="offline"){
						$('#chatBt').removeAttr('data-online').attr('data-offline',"")
						$('#helpdesk').core_reveal("open");
					}
				})
			}
			$('#chatBt').removeAttr("disabled").removeAttr("data-loading");
		}
		var zopimFailedCallback = function(){
			$('#chatBt').removeAttr("disabled").removeAttr("data-loading");
			$('#chatBt').removeAttr('data-online').attr('data-offline',"")
			if(!loadWithoutOpenChat) {
				$('#helpdesk').core_reveal("open");
			}
			$('[data-chatstatus]').html("{t}No disponible{/t}");
		}
		$('#chatBt').attr("disabled","disabled")
		$('#chatBt').attr('data-loading','')
		launchChatScripts(zopimToken,zopim,{ "callback": zopimCallback,"failedCallback": zopimFailedCallback});
		$('#chatBt').removeClass('has-messages');
		$('#chatBt [data-btText]').html(strings.chat)
	}else{
		if($('#chatBt[data-online]').length>0){
			$zopim.livechat.window.show();
		}else if($('#chatBt[data-offline]').length>0){
			$('#helpdesk').core_reveal("open");
		}
	}
}


/***********************************/
/* FUNCIONES GENÉRICAS */
/***********************************/
function roundNumber(number) {
	return Math.round(number * 100) / 100
}

function factorial(n) {
	if (n<0) {
		return 1;
	}
	if (n == 0 || n == 1){
		return 1;
	}
	return n * factorial (n-1);
}

function pad_with_zeros(number, length) {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }

    return my_string;
}

function isValidField(formElem,arrayOfElemFields){
	//función que evalua los abide de un campo de un formulario, y devuelve true o false si son válidos
	var elemParsedCount=0;
	var errors=false;
	$(arrayOfElemFields).each(function(e,v){
		if($(v).length > 0){
			$(formElem).foundation('validateInput',$(v));
			if ( typeof $(v).attr('data-invalid') != "undefined" ){
				errors=true;
			}
			elemParsedCount++;
		}else{
			return false;
		}
	})
	if(elemParsedCount>0 && !errors){
		return true;
	}else{
		return false;
	}
}

function countersEvents(options){
	return new CountersEvents(options);
}
var CountersEvents = function(options){ //FUNCIONES PARA LOS EVENTOS DE BOTONES + Y -

	this.min=1;
	this.max=99;
	this.dec=0;
	this.elem=false;
	this.step=1;
	this.calculatePurchaseOptionsAfterRemCallback = options?.calculatePurchaseOptionsAfterRemCallback ?? function(){}
	this.calculatePurchaseOptionsAfterAddCallback = options?.calculatePurchaseOptionsAfterAddCallback ?? function(){}
	this.previousValue=false;
	if( typeof options.min != "undefined" ){ this.min = parseFloat(options.min) }
	if( typeof options.max != "undefined" ){ this.max = parseFloat(options.max) }
	if( typeof options.elem != "undefined" ){ this.elem = options.elem }

	if( typeof options.decimals != "undefined" ){ this.dec = options.decimals }
	if( typeof options.step != "undefined" ){ this.step = options.step }

	const self = this;

	if( this.elem ){
		this.remElem = $(this.elem).find('[data-rem]');
		this.addElem = $(this.elem).find('[data-add]');
		this.counterElem = $(this.elem).find('[data-counter]');
	}else{
		this.remElem = $('[data-rem]');
		this.addElem = $('[data-add]');
		this.counterElem = $('[data-counter]');
	}
	$(this.remElem).off('click.counterEvents').on('click.counterEvents',function(){
		var returnedDecs="";
		var countElem=$(this).parent().find('[data-counter]');
		if ($(countElem).is('input')){
			var isInput=true;
			var elemValue = $(countElem).val();
		}else{
			var isInput=false;
			var elemValue = $(countElem).text();
		}
		if(parseFloat(elemValue)>self.min && (parseFloat(elemValue)-self.step) > self.min){

			if(self.dec>0){
				returnedDecs="."+getDecValue(elemValue,self.dec)
			}
			if(isInput){
				if(self.dec==0){
					$(countElem).val(parseInt(elemValue)-self.step);
					$(countElem).val($(countElem).val()+returnedDecs);
				}else{
					$(countElem).val(parseFloat(elemValue)-parseFloat(self.step));
				}
			}else{
				if(self.dec==0){
					$(countElem).text(parseInt($(countElem).text())-self.step);
					$(countElem).text($(countElem).text()+returnedDecs);
				}else{
					$(countElem).text(parseFloat($(countElem).text())-parseFloat(self.step));
				}
			}


		}else{
			if(isInput){
				$(countElem).val(self.min);
			}else{
				$(countElem).text(self.min);
			}

		}
		let val;
		if ($(countElem).is('input')){
			val = $(countElem).val();
		}else{
			val = $(countElem).text();
		}

		self.calculatePurchaseOptionsAfterRemCallback($(this),val,$(countElem),self);

		$(self.counterElem).blur();
	});
	$(this.counterElem).off('keydown.counterEvents').on('keydown.counterEvents',function(e){
		if(e.keyCode == 38){
			$(self.addElem).click();
			$(this).focus();
		}else if(e.keyCode == 40){
			$(self.remElem).click();
			$(this).focus();
		}
	})


	$(this.counterElem).off('keydown.counterEvents').on('keydown.counterEvents',function(e,elem){
		var countElem=$(e.target);
		var countElemVal = $(countElem).val();
		var key = e.key;
		var hasDec = false;
		if ($(countElem).is('input')){
			var isInput=true;
		}else{
			var isInput=false;
		}

		if(e.keyCode == 38){
			$(self.addElem).click();
			$(this).focus();
		}else if(e.keyCode == 40){
			$(self.remElem).click();
			$(this).focus();
		}else if(e.keyCode == 46 || e.keyCode == 8 || e.keyCode == 37 || e.keyCode == 39 || e.keyCode == 16){
			//Permitimos flechas laterales de cursor
			//Shift
			//Borrar y Suprimir
			return true;
		}else if(e.keyCode == 13){
			$(this).blur();
		}else if (key.match(/[^0-9.]/g)){ //Si no es un número o un punto, rechazamos la entrada
			return false;
		}else{
			if(key.match(/[.]/g)){ //Si es un punto, ajustamos que sólo haya un signo decimal
				if(isInput){
					if(countElemVal.indexOf('.') == -1/* -step */){
						return true;
					}
				}else{
					if(countElemVal.text().indexOf('.') == -1 /* -step */){
						return true;
					}
				}
			}else{ //Si es cualquier otro número
				var posDecimal = $(countElem).val().indexOf('.');
				var startPos = $(self.counterElem)[0].selectionStart;
				var endPos = $(self.counterElem)[0].selectionEnd;
				if(posDecimal != -1){ //Si hay decimales, ubicamos la posición del cursor

					if(startPos == endPos){ //No hay selección
						//Si el cursor esta a más de DEC posiciones desde el punto, ignoramos la entrada
						if(startPos > posDecimal + self.dec){
							return false;
						}else if(startPos > posDecimal){ //Si no está al final, sino que está situado el cursor en algún lugar despues del punto decimal, y si ya están completados los decimales máximos, lo ignoramos
							if(countElemVal.substr(posDecimal+1,countElemVal.length).length >= self.dec){
								return false;
							}
						}else{
							//Si estoy fuera del rango de los decimales
							var proposedValue = countElemVal;
							var output = [proposedValue.slice(0,startPos),key,proposedValue.slice(startPos)].join('');
							return checkValueValidity(output);
						}
					}else{
						var proposedValue = countElemVal;
						var outputStart = proposedValue.substr(0,startPos);// [proposedValue.slice(startPos,proposedValue.length - startPos)];
						var outputEnd = proposedValue.substr(endPos,proposedValue.length-endPos)
						var output = outputStart + key + outputEnd;
						return checkValueValidity(output);
					}
				}else{
					//Si no hay decimales escritos
					var proposedValue = countElemVal;
					var output = [proposedValue.slice(0,startPos),key,proposedValue.slice(startPos)].join('');
					return checkValueValidity(output);
				}
				return true;

			}

		}
 		return false;
	})

	function evalNumber(elem){
		var valor = parseFloat($(elem).val());
		if($(elem).val() > 0){
			if(valor > this.max){
				valor = this.max;
			}else if(valor < this.min){
				valor = this.min;
			}
		}

		if($(elem).val().length==0 ){
			valor = 0;
		}

		if(self.dec > 0){
			valor = valor.toFixed(self.dec);
		}
		return valor;
	}

	function checkValueValidity(value){
		var valor = parseFloat(value);
		if(valor < self.min || valor > self.max){
			return false;
		}
		return true;
	}

	$(this.counterElem).off('blur.counterEvents').on('blur.counterEvents',function(){
		var hadToChange = false;
		var evaluatedNumber = evalNumber($(this));
		$(this).val(evaluatedNumber);
		$(this).change();
	})
	$(this.counterElem).off('input.counterEvents').on('input.counterEvents',function(){
		var minOffset = 4;
		var maxOffset = 9;
		var baseClass = "sm_";
		var classOutput = "";
		var digitos = String($(this).val()).length
		$(this).removeClass('sm_1 sm_2 sm_3 sm_4 sm_5')
		if(digitos >= maxOffset){
			classOutput = "5"
		}else{
			switch (digitos){
				case 5:
					classOutput = "1"
				break;
				case 6:
					classOutput = "2"
				break;
				case 7:
					classOutput = "3"
				break;
				case 8:
					classOutput = "4"
				break
			}
		}
		$(this).parent().css('font-size',$(this).css('font-size'))
		$(this).addClass(baseClass+classOutput);

	})
	$(this.addElem).off('click.counterEvents').on('click.counterEvents', function() {
		if(typeof options.calculateMax != "undefined") {
			self.max = options.calculateMax($(this));
		}
		var returnedDecs="";
		var countElem=$(this).parent().find('[data-counter]');
		if ($(countElem).is('input')){
			var isInput=true;
			var elemValue = $(countElem).val();
		}else{
			var isInput=false;
			var elemValue = $(countElem).text();
		}

		if(elemValue < self.max){
			if(self.dec>0){
				returnedDecs="."+getDecValue(elemValue,self.dec)
			}
			if(isInput){
				if(self.dec==0){
					$(countElem).val(parseInt(elemValue)+self.step);
					$(countElem).val($(countElem).val()+returnedDecs);
				}else{
					$(countElem).val(parseFloat(elemValue)+parseFloat(self.step));
				}
			}else{
				if(self.dec==0){
					$(countElem).text(parseInt(elemValue)+self.step);
					$(countElem).text($(countElem).text()+returnedDecs);
				}else{
					$(countElem).text(parseFloat(elemValue)+parseFloat(self.step) );
				}
			}
			let val;
			if ($(countElem).is('input')){
				val = $(countElem).val();
			}else{
				val = $(countElem).text();
			}
			self.calculatePurchaseOptionsAfterAddCallback($(this),val,$(countElem),self);
		}
		$(self.counterElem).blur();
	});

	function getDecValue(myStr,defaultDecs){
		//buscamos valor de los decimales
		var pos = myStr.indexOf('.');
		var decs = "";
		if(pos > 0){
			var currentDecValue =myStr.substr(pos+1,myStr.length);
			return currentDecValue;
		}else{
			for(i=0;i<defaultDecs;i++){
				decs=decs+"0";
			}
			return decs;
		}
	}
}

function animatedCounters(elemToAnimate){ //FUNCIONES PARA LOS EVENTOS DE BOTONES + Y -
	var durationMs=1500;
	var hasDecsWithZeros=false;
	var hasDecimals=false;
	var decPoint;

	$(elemToAnimate).each(function () {
		var elemValue = $(this).text();
		var hasDecimals=false;
		var initialChars=0;
		if($(this).text().length==2 && $(this).text().substr(0,1)=="0"){
			hasDecsWithZeros=true;
		}
		$(this).text($(this).text().replace(".", ""));
		$(this).text($(this).text().replace(",", "."));
		if(parseFloat($(this).text()) %1 != 0){
			hasDecimals=true;
		}

		$(this).css('visibility','visible');
	    $(this).prop('Counter',0).animate({
	        Counter: $(this).text()
	    }, {
	        duration: durationMs,
	        easing: 'swing',
	        step: function (now) {
				this.Counter.toString().replace("./g", "");
				this.Counter.toString().replace(",/g", ".");
				if(hasDecimals){
					this.Counter=parseFloat(now);
				}else{
					this.Counter=Math.ceil(now);
				}
				if(hasDecsWithZeros){
			        var decVal="0";
		        }else{
			        var decVal="";
		        }

				if(this.Counter %1 != 0){ //tiene decimales
					$(this).text(/* zerosStr+ */this.Counter.formatMoney(2, ',', '.'))
				}else{
					$(this).text(this.Counter.formatMoney(0, ',', '.'))
				}
				$(this).text(decVal+$(this).text());
	        },
	        complete: function(){
		    	$(this).text(elemValue)
			}
	    });
	});
}


String.prototype.placeHolder = function(arrayOfValues){
	var texto = this
	if(Array.isArray(arrayOfValues)){
		$(arrayOfValues).each(function(k,v){
			var placeHolder = "%"+(k+1);
			texto = texto.replace(new RegExp(placeHolder, 'g'), v);
		})
	}else{
		var placeHolder = "%1";
		texto = texto.replace(new RegExp(placeHolder, 'g'), arrayOfValues);
	}
	return texto;
}

/************************************/
/* FUNCIONES PARA POPUP EN PANTALLA */
/************************************/

function newPopUp(htmlMessage,options){
//       "htmlMessage":"<strong>BOTE de Euromillones</strong><br>Este viernes 120.000.000€ en premios",
// 	 {
//        "hasLinkToURL":"https://www.hispaloto.es/bonoloto/individual",    //[opcional] Sólo si se necesita enlace
//        "hasClasses":"euromillones".                                      //[opcional] Sólo si hay que pasar clases al notificador javascript
//        "hasImgURL":"http://www.url.../avatars/xxx.jpg",                  //[opcional] Sólo si queremos imagen en el notificador
//        "hasIcon":false|class del icono                                   //[opcional] Sustituye la imagen por un i con la clase que se indique.
//		  "timeOut": 7
//   }


	var link=false;
	var classes="";
	var icon=false;
	var imgURL=false;
	var interval = 7; //s. de tiempo hasta que se anima la salida y se destruye

	if(typeof options != "undefined"){
		if(typeof options.hasLinkToURL != "undefined"){
			link=options.hasLinkToURL;
		}
		if(typeof options.hasImgURL != "undefined"){
			imgURL=options.hasImgURL;
		}
		if(typeof options.hasClasses != "undefined") {
			classes=options.hasClasses;
		}
		if(typeof options.hasIcon != "undefined") {
			if(options.hasIcon){
				icon=options.hasIcon;
			}
		}
		if(typeof options.timeOut != "undefined") {
			interval=options.timeOut;
	}
	}
	var htmlIMG="";
	if(imgURL && !icon){
		var htmlIMG='<img src="'+imgURL+'" class="avatar">'
	}
	if(icon && !imgURL){
		var htmlIMG='<i class="' + icon + '"></i>'
	}

	if (link)	{
		var html=		'<a href="'+link+'?fromNotification=true" data-popup-notifier class="media-object is-active '+classes+'">';

		if(icon || imgURL){
			html = html+'<span class="media-object-section">'+htmlIMG+'</span>'
		}

		html = html +	'<span class="media-object-section">'+htmlMessage+'</span>'+
						'</a>';
	}else{
		var html=		'<button data-popup-notifier class="media-object is-active '+classes+'">';
		if(icon || imgURL){
			html = html+'<span class="media-object-section">'+htmlIMG+'</span>'
		}
		html = html + 	'<span class="media-object-section">'+htmlMessage+'</span>'+
						'</button>';
	}

	if($('body [data-popup-notifier]').length > 0){
		$('[data-popup-notifier]').remove();
		if(typeof $('body').data('popup-notifier-timerId') != "undefined"){
		   	window.clearTimeout($('body').data('popup-notifier-timerId'));
	   	}
	}
	$('body').append(html);
// 	$('[data-popup-notifier]').css('animation-duration',interval-1);

	myTimer = new Timer(function(){
		$('[data-popup-notifier]').removeClass('is-active');
		setTimeout(function(){
		$('[data-popup-notifier]').remove();
		},1500)
// 		$('[data-popup-notifier]').remove();
		$('body').removeData('popup-notifier-timerId');
	} , interval*1000);

	$('body').data('popup-notifier-timerId',myTimer.returnTimerId())

	$('[data-popup-notifier]').on('mouseenter',function(){ myTimer.pause()})
	$('[data-popup-notifier]').on('mouseleave',function(){ myTimer.resume()})
}

function Timer(callback, delay) { //SETTIMEOUT AVANZADO QUE PERMITE PAUSAR LA EJECUCION
	var timerId, start, remaining = delay;
	this.pause = function() {
	    window.clearTimeout(timerId);
	    remaining -= new Date() - start;
	};

	this.resume = function() {
	    start = new Date();
	    window.clearTimeout(timerId);
	    timerId = window.setTimeout(callback, remaining);
	};
	this.resume();

	this.returnTimerId = function(){
		return timerId;
	}

}


/***************************************/
/* FUNCIONES PARA LISTA PARTICIPANTES 	/
/***************************************/
function setParticipantsPopupValues(participantsMode){ 	//	Establece los parámetros para mostrar modal con apuestas de los fondos, o de perfil para el participante indicado
														//	participantsMode betsSummary o profile (para mostrar apuestas, o perfiles)
														//	El button/opener ha de tener data-userId con el id del usuario a mostrar
														//	Si el reveal tiene parametros (data-reveal-params), los pasará al modal además de los que pudiera tener el button/opener, q se le concatenarán también

	$('[data-participants] button[data-open]').on('click',function(){

		var userId=$(this).attr('data-userId');
		switch(participantsMode){
			case "betsSummary":
				var elem="#betsSummary";
				var paramsString='"userId":"'+userId+'"';
			break;
			case "profile":
				var elem="#profileModal";
				var paramsString='"user":"'+userId+'"';
			break;
		}

		var parseParams=$(elem).attr('data-reveal-params');

		if( typeof $(elem).attr('originalParams')=="undefined"){
			if (typeof parseParams =="undefined"){
				$(elem).attr('originalParams',"");
			}else{
				$(elem).attr('originalParams',parseParams);
			}
		}else{
			$(elem).removeAttr('data-reveal-params').attr('data-reveal-params',$(elem).attr('originalParams'));
			parseParams=$(elem).attr('originalParams');
		}

		if (typeof parseParams =="undefined" || parseParams==""){
			parseParams="{"+paramsString+"}";
		}else{
		parseParams=parseParams.substr(0,parseParams.length-1);
			parseParams=parseParams+','+paramsString+'}';
		}
		$(elem).attr('data-reveal-params',parseParams);
	})
}

function setChildLimiter(elem,options){
	var elem = $(elem);
	var limit = 21;

	if($(elem).length == 0){
		return false;
	}

	var strings = {
		remaining: "Mostrar %1 restantes",
	}

	if(typeof options != "undefined"){
		if (typeof options.strings != "undefined"){
			if (options.strings.remaining != "undefined") { strings.remaining = options.strings.remaining}
		}
		if (typeof options.limit != "undefined"){
			limit = options.limit;
		}

	}

	$(elem).each(function(){
		var elemento = $(this);
		if(typeof $(elemento).attr('data-limit') != "undefined"){
			limit = parseInt($(elemento).attr('data-limit'));
		}

		var remainingElemCount = parseInt($(elemento).children().length) - parseInt(limit-1);
		var stringRpc = strings.remaining.replace("%1",remainingElemCount);
		var navigatorHTML = '<p data-limiterNav><button type="button" data-showAllBt>'+stringRpc+'</button></p>'
		if(typeof $(elemento).attr('data-limit') == "undefined" ){
			$(elemento).attr('data-limit',limit);
		}
		if($(elemento).children().length >= limit){
			$(elemento).children().eq(limit-1).prevAll().addClass('limit-show');
			$(elemento).children().eq(limit-1).nextAll().removeClass('limit-show');
			$(navigatorHTML).insertAfter(elemento);
			$(elemento).addClass('is-rendered');
			$(elemento).next('[data-limiterNav]').find('[data-showAllBt]').on('click',function(){
				$(elemento).children().addClass('limit-show');
				$(this).closest('[data-limiterNav]').remove();
			});
		}else{
			$(elemento).children().addClass('limit-show');
			$(elemento).addClass('is-rendered');
		}
	})

}




/*******************/
/* CONFIGURACION 	/
/*******************/

//Función para los filtros de los grupos en el Panel de Usuario
function panelFilterScripts(){
	$('[name="filter"]').on('change',function(e){
		var rowsElem = '[data-groups-summary] table tbody tr';
		var currentView = $('[name="filter"]');
		var expression = new Array();
		var notExpression = new Array();
		var andExpression = new Array();

		$(rowsElem).hide()
		$(currentView).each(function(){
			var filterType=$(this).attr('data-filter');
			var filterValue=$(this).prop('checked');
			switch (filterType) {
				case "o": //Owner
					var selector = "[data-owner]";
					if(filterValue){
						expression.push(selector)
					}
				break;
				case "g": //Guest
					var selector = "[data-guest]";
					if(filterValue){
						expression.push(selector)
					}
				break;

				case "j": //Joined
					var selector = "[data-joined]";
					if(filterValue){
						expression.push(selector)
					}
				break;
				case "p": //Played
					var selector = "[data-played]";
					if(!filterValue){
						notExpression.push(":not("+selector+")");
					}else{
						andExpression.push(selector);
						expression.push('[data-joined]')
					}
				break;
			}
		})
		if(expression.length == 0){
			expression.push('[data-joined]')
		}

		var notExpr = notExpression.join("");
		var andExpr = andExpression.join("");

		if(expression.length == 0){
			$(rowsElem).show();
		}else{
			$(expression).each(function(k,v){
				$(rowsElem + v + andExpr + notExpr).show()
			})
		}
	})
}


function panelValidationScripts(options){
	var strings = {
		sending: "{t}Enviando un email de activación a tu cuenta... Espera por favor{/t}"
	}

	if(typeof options.strings != "undefined"){
		if(typeof options.strings.sending != "undefined"){
			strings.sending = options.strings.sending
		}
	}

	$('[data-validateEmail]').off('click').on('click',function(){
		var emailModal = $("#validateEmail");
		sendValidateEmail(null,$(this),{
			strings: strings,
			callbackOnSuccess:function(e){
				$(emailModal).data('callback',function(e){
					launchEMailValidationScript({
						callbackOnSuccess: function(e,statusMsgElem){
							var text = $(statusMsgElem).text();
							var intervalo = 3;
							$(statusMsgElem).text(text +" (" + intervalo + ")");
							var closeInterval = setInterval(function(){
								intervalo--;
								if(intervalo == 0){
									location.reload();
								}else{
									$(statusMsgElem).text(text +" (" + intervalo + ")");
								}
							}, 1000);
						},
						callbackOnError:function(e){
							alert(e.error);
							$(emailModal).core_reveal('close');
							return false;
						},
						callbackOnFail:function(e,j,k){
							alert(j);
							$(emailModal).core_reveal('close');
							return false;
						}
					});
				})
				$(emailModal).core_reveal('open',{ params:{ 'ignoreScripts':true}});
			}
		})
	})

	$('[data-validatePhone]').off('click').on('click',function(){
		var phoneModal = $("#validatePhone");
		$(phoneModal).data('callback',function(e){
			launchPhoneValidationScript({
				callbackOnSuccess: function(e,statusMsgElem){
					var text = $(statusMsgElem).text();
					var intervalo = 3;
					$(statusMsgElem).text(text +" (" + intervalo + ")");
					var closeInterval = setInterval(function(){
						intervalo--;
						if(intervalo == 0){
							location.reload();
						}else{
							$(statusMsgElem).text(text +" (" + intervalo + ")");
						}
					}, 1000);
				}
			});
		})
		$(phoneModal).core_reveal('open',{ params:{ 'ignoreScripts':true}});
	})
}
//Clase para manejar las librerias de métodos de pago y cobro almacenados
var manageLibrariesConfig = function(elem,almacenObj,options){

	this.elem = elem;
	this.onRemoveMethodURL 			= "/data/?action=removeStoredPayment";
	this.onRemoveMethod 			= function(){};
	this.onRemoveMethodCallback 	= function(){};
	this.onOrderChangeURL 			= "/data/?action=reorderStoredPayment";
	this.onOrderChange 				= function(){};
	this.onOrderChangeCallback 		= function(){};
	this.onSelectionChangeURL 		= "/data/?action=selectionStoredPayment";
	this.onSelectionChange 			= function(){};
	this.onSelectionChangeCallback 	= function(){};

	this.myStoredPaymentTypesTbody 	= $(elem).find('[data-myStoredPaymentMethods]').find('tbody'); //Tabla con datos

	this.showSelectionForMethods 	= new Array(); //Array de métodos de pago que tienen opcion "seleccionable"
	this.paymentMethodsOBJ = almacenObj;

	this.savingTimer = new Array(null,null,null);
	this.strings = {
		confirmDeletion: "{t}¿Seguro que deseas eliminar este método de pago/retirada de premios?. Podrás añadirlo de nuevo marcando la opción de guardar al realizar una operación de pago o cobro de premios.{/t}",
		saving:"{t}Guardando... espere{/t}"
	}
	if(typeof options != "undefined"){
		if(typeof options.selectablePaymentMethods != "undefined"){
			this.showSelectionForMethods = options.selectablePaymentMethods;
		}
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.confirmDeletion != "undefined"){
				this.strings.confirmDeletion = options.strings.confirmDeletion;
			}
			if(typeof options.strings.saving != "undefined"){
				this.strings.saving = options.strings.saving;
			}
		}

	}
	var self = this;


	this.refresh();


}
manageLibrariesConfig.prototype.refresh = function(){
	var self = this;
	//Llenamos la tabla con los métodos de pago almacenados
	$(self.myStoredPaymentTypesTbody).html(self.paymentMethodsOBJ.retrieveHTML({
		showSelectionForMethods: self.showSelectionForMethods
	}));

	//Lanzamos el sistema de drag-n-drop para ordenar solo para los elementos que pueden usarse para abonos
	bamQueue.waitForExistance("jQuery.ui",function(){
		$(function(){
			$(self.myStoredPaymentTypesTbody).each(function(k,v){
				$(v).find('[data-paymentmethodselector]:not([disabled])').closest('tr').attr('data-sortableItem',"");
			});
			$(self.myStoredPaymentTypesTbody).sortable({
				cancel: "[data-sortableitem] button,[data-sortableitem] input",
				items: $(self.myStoredPaymentTypesTbody).find('[data-sortableitem]'),
				stop: function( event, ui ) {
					var elemsArray = new Array()
					$(self.myStoredPaymentTypesTbody).find('tr[data-value]').each(function(k,v){
						elemsArray.push($(v).attr('data-value'))
					});
					self.changeOrder(elemsArray);
				}
			});
			$(self.myStoredPaymentTypesTbody).disableSelection();
		})
	})

	//Eventos change del selector
	$(this.myStoredPaymentTypesTbody).find("[data-paymentMethodSelector]").off('change').on('change',function(){
		var currentElem = $(this).closest('tr[data-value]');
		var methodId = $(currentElem).attr('data-method-value');
		var submethodId = $(currentElem).attr('data-submethod-value');
		var value = $(currentElem).attr('data-value');
		self.changeSelection(methodId,submethodId,value,$(this).prop('checked'));
	})

	//Eventos para borrar
	$(this.myStoredPaymentTypesTbody).find("[data-remove]").off('change').on('click',function(){
		var currentElem = $(this).closest('tr[data-value]');
		var methodId = $(currentElem).attr('data-method-value');
		var submethodId = $(currentElem).attr('data-submethod-value');
		var value = $(currentElem).attr('data-value');
		var agree = confirm(self.strings.confirmDeletion);
		if(agree) {
			self.removeMethod(methodId,submethodId,value);
		}
	})

}

manageLibrariesConfig.prototype.getDOM = function(methodId,submethodId,id){
	var self = this;
	var returnValue = false;
	var elem = $(self.myStoredPaymentTypesTbody).find('tr[data-method-value="'+methodId+'"][data-submethod-value="'+submethodId+'"][data-value="'+id+'"]');
	if($(elem).length > 0){
		returnValue = elem;
	}
	return returnValue;
}

manageLibrariesConfig.prototype.changeOrder = function(elemsOrderArray){
	var self = this;

	clearTimeout(self.savingTimer[1]);
	$(self.elem).find("[data-status-msg]").html(self.strings.saving).removeClass('alert success').fadeIn();
	self.savingTimer[1] = setTimeout(function(){
		var manageLibrariesForme = new formeSubmit(false,self.onOrderChangeURL,{
			statusMsg: {
				elem: $(self.elem).find("[data-status-msg]")	//default: [data-status-msg]
			},
			callbackOnSuccess: function(e){
				self.onOrderChangeCallback(e);
			},
			extraFields: {
				fieldsOrder:elemsOrderArray
			}

		})
	}, 1000);

}

manageLibrariesConfig.prototype.removeMethod = function(methodId,submethodId,id){
	var self = this;

	clearTimeout(self.savingTimer[0]);
	var elem = self.getDOM(methodId,submethodId,id);
	$(self.elem).find("[data-status-msg]").html(self.strings.saving).removeClass('alert success').fadeIn();
	self.savingTimer[0] = setTimeout(function(){
		var manageLibrariesForme = new formeSubmit(false,self.onRemoveMethodURL,{
			statusMsg: {
				elem: $(self.elem).find("[data-status-msg]")	//default: [data-status-msg]
			},
			submitBt: {
				elem: $(elem).find('[data-remove]')
			},
			callbackOnSuccess: function(e){
				self.onRemoveMethodCallback(e);
				$(elem).remove();
			},
			extraFields: {
				id:id
			}

		})
	},1000);

}

manageLibrariesConfig.prototype.changeSelection = function(methodId,submethodId,id,value){


	var self = this;

	clearTimeout(self.savingTimer[2]);
	$(self.elem).find("[data-status-msg]").html(self.strings.saving).removeClass('alert success').fadeIn();

	self.savingTimer[1] = setTimeout(function(){
		var manageLibrariesForme = new formeSubmit(false,self.onSelectionChangeURL,{
			statusMsg: {
				elem: $(self.elem).find("[data-status-msg]")	//default: [data-status-msg]
			},
			callbackOnSuccess: function(e){
				self.onSelectionChangeCallback(e);
			},
			extraFields: {
				id:id,
				value:value
			}

		})
	}, 1000);
}



function payPanelEvents(){

	$('#addCash_tabs').on('change.zf.tabs',function(){
		var elem = new Foundation.Equalizer($('[data-equalizer]'), { });
	});

	countersEvents({ 'elem':$('[data-cashsummary]'),'max':999999,'min':0,'decimals':2});
	$('[name="subscription"]').on('change',function(){
		var itemId=$(this).attr('id');
		itemId=itemId.substr(24,itemId.length-24);
		if($(this).prop('checked')){
			$('#rndSwitch_item_'+itemId).closest('[data-randomSwitch]').slideDown();
		}else{
			$('#rndSwitch_item_'+itemId).closest('[data-randomSwitch]').slideUp();
		}

	})
}

/***********************************/
/* FUNCIONES PARA CARRO */
/***********************************/

function launchCartScripts(options){
	var onSetAbonoCallback = function(){};
	var onUnsetAbonoCallback = function(){};
	var cartClearRedirectionURL = null;
	var strings = {
		abonoError: "No se ha podido modificar el abono.",
		fondoError: "No se ha podido modificar el modo de juego.",
		removeWarning: "Esta acción elimará todos los items del carro. ¿Está Seguro?"
	}

	if(typeof options != "undefined"){
		if (options.strings != "undefined"){
			if (options.strings.abonoError != "undefined") { strings.abonoError = options.strings.abonoError}
			if (options.strings.fondoError != "undefined") { strings.fondoError = options.strings.fondoError}
		}
		if(typeof options.onSetAbonoCallback != "undefined"){
			onSetAbonoCallback = options.onSetAbonoCallback;
		}
		if(typeof options.onUnsetAbonoCallback != "undefined"){
			onUnsetAbonoCallback = options.onUnsetAbonoCallback;
		}
		if(typeof options.cartClearRedirectionURL != "undefined"){
			cartClearRedirectionURL = options.cartClearRedirectionURL;
		}
	}

	var dataUrlFondo="/data/?action=modoItemCarro";
	var dataUrlAbono="/data/?action=abonoItemCarro";
	var dataUrlBorrarCarro="/data/?action=borrarItemCarro&item=0";
	$('[data-clearCart]').on('click',function(){
		clearCart(dataUrlBorrarCarro,$(this),cartClearRedirectionURL);
	})
	$('[data-cartlines] input[type=checkbox]').on('change',function(){
		var elem=$(this);
		var elemType=$(this).attr('name');
		var item=$(this).closest('[data-cart-item]').attr('data-cart-item');
		if(elemType=='fund'){
			if($(elem).prop('checked')){
				setCartFondo(item,"2",dataUrlFondo);
			}else{
				setCartFondo(item,"1",dataUrlFondo);
			}
		}
		if(elemType=='subscription' || elemType=='random'){
			var abono=0;
			var random=0;

			if($('#subscriptionSwitch_item_'+item).prop('checked')){
				abono=1
				if($('#rndSwitch_item_'+item).prop('checked')){
					random=1;
				}else{
					random=0;
				}
			}else{
				abono=0
				if($('#rndSwitch_item_'+item).prop('checked')){
					random=1;
				}else{
					random=0;
				}
			}
			setCartAbono(item,abono,random,dataUrlAbono);
		}
	})
	function setCartFondo(item,modo,dataUrl){
		var myForm = new formeSubmit(false,dataUrlFondo,{
			extraFields: { "item":item,"modo":modo},
			statusMsg: {
				elem: $("[data-status-msg='"+item+"']"),
				error: strings.fondoError
			},
			callbackOnSuccess: function(e){
				holdCartContent(item,false);
			},
			callbackOnFail: function(e){
				holdCartContent(item,false,true);
			},
			callbackOnError: function(){
				holdCartContent(item,false,true);
			}

		});
	}
	function setCartAbono(item,modoAbono,modoRandom,dataUrl){
		holdCartContent(item);
		var myForm = new formeSubmit(false,dataUrlAbono,{
			extraFields: { "item":item,"abono":modoAbono,"abonoRandom":modoRandom},
			statusMsg: {
				elem: $("[data-status-msg='"+item+"']"),
				error: strings.abonoError
			},
			callbackOnSuccess: function(e){
				holdCartContent(item,false);
				refreshCartContent(e.data.carro);
				if(modoAbono){
					onSetAbonoCallback(e.data.carro);
				}else{
					onUnsetAbonoCallback(e.data.carro);
				}
			},
			callbackOnFail: function(e){
				holdCartContent(item,false,true);
			},
			callbackOnError: function(e){
				holdCartContent(item,false,true);
			}
		});
	}
	function clearCart(dataUrl,elem,redirectionURL){
		if(confirm(strings.removeWarning)){
			holdCartContent(false,true);
			var myForm = new formeSubmit(false,dataUrl,{
				statusMsg: {
					elem: $("[data-status-msg='cartRemoval']"),
				},
				submitBt: {
					elem : $(elem)
				},
				callbackOnSuccess: function(e){
					if(typeof redirectionURL != "undefined" && redirectionURL != null){
						window.location.href = cartClearRedirectionURL;
					}else{
						location.reload();
					}

				},
				callbackOnFail: function(e){
					holdCartContent(false,false,true);
				},
				callbackOnError: function(e){
					holdCartContent(false,false,true);
				}
			});
		}
	}
}

function holdCartContent(itemId,mode,reset){
	if(itemId){
		var item = $('[data-cartLines] tr[data-cart-item="'+itemId+'"]');
		var price = $(item).find('[data-itemPrice]')
		var totalElem = $('[data-paymentarea] [data-purchasetotal] [data-counter]');
		var discount = $(item).find('[data-discountPrice]');
		if(typeof mode !="undefined" && mode === false){
			$(discount).add(price).add(totalElem).add(item).removeClass('onHold');
			if(typeof reset != "undefined" && reset === true){
				$(price).html($(price).data('previousValue')).removeClass('onHold');
				$(discount).html($(discount).data('previousValue')).removeClass('onHold');
				$(totalElem).html($(totalElem).data('previousValue')).removeClass('onHold');
			}
		}else{
			$(item).addClass('onHold');
			$(price).data('previousValue',$(price).html()).addClass('onHold');
			$(discount).data('previousValue',$(discount).html()).addClass('onHold');
			$(totalElem).data('previousValue',$(totalElem).html()).addClass('onHold');
		}
	}else{
		item = $('[data-cartLines] tr[data-cart-item]');
		$(item).each(function(k,v){

			var price = $(v).find('[data-itemPrice]')
			var totalElem = $('[data-paymentarea] [data-purchasetotal] [data-counter]');
			var discount = $(v).find('[data-discountPrice]');
			if(typeof mode !="undefined" && mode === false){
				$(discount).add(price).add(totalElem).add(item).removeClass('onHold');
				if(typeof reset != "undefined" && reset === true){
					$(price).html($(price).data('previousValue')).removeClass('onHold');
					$(discount).html($(discount).data('previousValue')).removeClass('onHold');
					$(totalElem).html($(totalElem).data('previousValue')).removeClass('onHold');
				}
			}else{
				$(item).addClass('onHold');
				$(price).data('previousValue',$(price).html()).addClass('onHold');
				$(discount).data('previousValue',$(discount).html()).addClass('onHold');
				$(totalElem).data('previousValue',$(totalElem).html()).addClass('onHold');
			}



		})
	}

}

function refreshCartContent(cartContentObj){
	var subtotal = 0;
	$.each(cartContentObj["carro"],function(k,v){

		var item = $('[data-cartLines] tr[data-cart-item="'+k+'"]');
		var price = $(item).find('[data-itemPrice]');
		var importe = parseFloat(v.importe).formatMoney(2, ',', '.')
		if(typeof global_currency == "undefined"){
			var ppp = importe + "<small>€</small>";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(v.importe),null,{wrapper:"small"});
		}
		var priceHTML = ppp;
		subtotal = subtotal + parseFloat(v.importe);

		$(price).html(priceHTML);
		if(typeof global_currency == "undefined"){
			var importeOriginal = parseFloat(v.importeOriginal).formatMoney(2, ',', '.')
		}else{
			var importeOriginal = global_currency.getMoneda(parseFloat(v.importeOriginal),null,{wrapper:"small"});
		}
		if(v.importe != v.importeOriginal && typeof(v.importeOriginal) != "undefined"){
			$(item).find('[data-discountPrice]').html(importeOriginal);
		}else{
			$(item).find('[data-discountPrice]').empty();
		}
	});
	if(typeof cartContentObj["promo"] != "undefined" && cartContentObj["promo"] != null){
		var item = $('[data-cartLines] tr[data-cart-item].discount');
		var importeDescuento = cartContentObj["promo"].importe;
		if(typeof global_currency == "undefined"){
			var ppp = importeDescuento + "<small>€</small>";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(importeDescuento),null,{wrapper:"small"});
		}
		var importeDescuentoHTML = ppp;
		$(item).find('[data-itemPrice]').html(importeDescuentoHTML);
	}else{
		var item = $('[data-cartLines] tr[data-cart-item].discount');
		$(item).fadeOut('fast',function(){
			$(this).remove();
		})
	}
	if(typeof cartContentObj["envio"] == undefined || cartContentObj["envio"] == null ){
		$('tr[data-cart-item][data-delivery]').fadeOut('fast',function(){
			$(this).remove();
		})
	}
	if(subtotal == cartContentObj.importe){
		$('[data-cartLines] tr[data-subtotal]').fadeOut('fast',function(){ $(this).remove()})
	}else{
		if(typeof global_currency == "undefined"){
			var ppp = parseFloat(subtotal).formatMoney(2, ',', '.')+"<small>€</small>";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(subtotal),null,{wrapper:"small"});
		}
		$('[data-cartLines] td[data-subtotal]').html(ppp);
	}
	//var totalElem = $('[data-paymentarea] [data-purchasetotal] [data-counter]');
	var totalElem = $('[data-cartLines] td[data-total]');
	if(typeof global_currency == "undefined"){
		var ppp = parseFloat(cartContentObj.importe).formatMoney(2, ',', '.')+"<small>€</small>";
	}else{
		var ppp = global_currency.getMoneda(parseFloat(cartContentObj.importe),null,{wrapper:"small"});
	}
	var importeTotal = ppp;
	var importeTotalHTML = importeTotal;
	$(totalElem).html(importeTotalHTML);

}

function enablePayMethod(state,paymentsManagerObj,paymentsObjOptions,methodsObj,methodToBlock,submethodToBlock){
	//Función que parsea los métodos de pago y deshabilita los que designemos
	//State: true habilita el método, false lo desbloquea

		$(methodsObj).each(function(k,v){
			if(v.id == methodToBlock){
				$(v.limits).each(function(j,m){
					if(m.id == submethodToBlock){
						if(state == true){
							m.enabled = true;
						}else{
							m.enabled = false;
						}
					}
				})
			}
		})

	paymentsObjOptions["payMethodObj"] = methodsObj;
	var currentAmount = parseFloat(paymentsManagerObj.paymentsObj.getCurrentAmount());
	var currentVoucher = parseFloat(paymentsManagerObj.paymentsObj.getVoucherValue());
	paymentsObjOptions.cart.purchaseValue = currentAmount;
	paymentsObjOptions.cart["voucherValue"] = currentVoucher;
	paymentObj = new paymentsObj(paymentsManagerObj.paymentsObj.purchaseURL,paymentsObjOptions);
	paymentsManagerObj.attachPayMethodsObj(paymentObj)
}
function enableOnlyPayMethod(state,paymentsManagerObj,paymentsObjOptions,methodsObj,methodToAllow,submethodToAllow,forceState){
	//Función que parsea los métodos de pago y habilita sólo los que designemos, el resto los deshabilita
	//State: true habilita sólo el método elegido, false vuelve a habilitar todos los métodos
	//ForceState: si el método tiene opción para guardar en agenda, este parámetro a 'true' fuerza que independientemente
	//si el control esté disabled, que el valor interno de guardar en agenda se mantenga a true en setSavingForMethodState;
	const savingState = forceState ?? !state;

		$(methodsObj).each(function(k,v){
			if(v.id == methodToAllow){
				$(v.limits).each(function(j,m){
					if(m.id == submethodToAllow){
						m.enabled = true;
					}else{
						if(state == true){
							m.enabled = false;
						}else{
							m.enabled = true;
						}
					}
				})
			}else{
				if (v.id != "sv"){ //Ignoramos Saldo virtual
					$(v.limits).each(function(j,m){
						if(state == true){
							m.enabled = false;
						}else{
							m.enabled = true;
						}
					})
				}
			}
		})

	paymentsObjOptions["payMethodObj"] = methodsObj;
	var currentAmount = parseFloat(paymentsManagerObj.paymentsObj.getCurrentAmount());
	var currentVoucher = parseFloat(paymentsManagerObj.paymentsObj.getVoucherValue());
	paymentsObjOptions.cart.purchaseValue = currentAmount;
	paymentsObjOptions.cart["voucherValue"] = currentVoucher;
	paymentObj = new paymentsObj(paymentsManagerObj.paymentsObj.purchaseURL,paymentsObjOptions);
	paymentsManagerObj.attachPayMethodsObj(paymentObj)
	paymentsManagerObj.setSavingForMethodState(!state,methodToAllow,submethodToAllow,savingState);
}



function unblockFundsCompensation(methodToUnBlock,subMethodToUnBlock,paymentsManagerObj,paymentsObjToRestoreFrom){
	//unblockFundsCompensation("ccard","card_redsys_dir",payments,paymentObj)
	paymentsManagerObj.attachPayMethodsObj(paymentsObjToRestoreFrom);
	paymentsManagerObj.showUsePreviousBalance(methodToUnBlock);
	paymentsManagerObj.showUsePreviousBalance(methodToUnBlock,subMethodToUnBlock);
}
function blockFundsCompensation(methodToBlock,subMethodToBlock,paymentsManagerObj){
	//blockFundsCompensation("ccard","card_redsys_dir",payments)
		const clonedPayments = $.extend(true,{},paymentsManagerObj.paymentsObj);
		paymentsManagerObj.attachPayMethodsObj(clonedPayments);
		const method = clonedPayments.getMethod(methodToBlock);
		$(method.limits).each(function(k,v){
			v.allowFundsCompensation = false;
		});
		paymentsManagerObj.hideUsePreviousBalance(methodToBlock);
		paymentsManagerObj.hideUsePreviousBalance(methodToBlock,subMethodToBlock);
}
function getPayMethodState(methodsObj,methodToBlock,submethodToBlock){
	//Función que devuelve si el método de pago esta habilitado o no
	//Devuelve: true si está habilitado el método, false de lo contrario

		$(methodsObj).each(function(k,v){
			if(v.id == methodToBlock){
				$(v.limits).each(function(j,m){
					if(m.id == submethodToBlock){
						if(state == true){
							return true;
						}else{
							returnValue = false;
						}
					}
				})
			}
		})
}
function getAbonos(cartItems){
	//Devuelve el número de items con "ABONOS" marcado en el objeto carro
	var counter = 0;
	$.each(cartItems,function(k,v){
		if(v.abono != null && v.abono == "1"){
			counter ++;
		}
	})
	return counter;
}
function getPeticiones(cartItems){
	//Devuelve el número de items que son peticiones de Lotería Nacional, del objeto carro
	var counter = 0;
	$.each(cartItems,function(k,v){
		if(typeof v.peticion != "undefined" && v.peticion === true){
			counter ++;
		}
	})
	return counter;
}

function purchaseSuccessCallback(e,payments,redirectionURL,options){
	var popUpSelector = "[data-paymentsPopup]";

	var extraFields = null;
	var gatewayStrings = {}
	var gatewayMechantURL = "data/?action=paymentManager&mode=continuePayment";
	var openExternalsInPopup = true; 	//para SDK
	var openGatewayInPopup = false;		//para GATEWAY
	var isDebug = false;
	if(typeof $zopim != "undefined" && typeof $zopim.livechat != "undefined") {
		$zopim.livechat.removeTags('paymentError');
		$zopim.livechat.removeTags('creditCardDirectLimit');
		$zopim.livechat.removeTags('creditCardGatewayLimit');
	}

	on_success_functions(e,payments);

	if(typeof options != "undefined"){
		if(typeof options.extraFields != "undefined"){
			extraFields = options.extraFields;
		}
		if(typeof options.gatewayErrorStrings != "undefined"){
			gatewayStrings = options.gatewayErrorStrings;
		}

		if(typeof options.gatewayMechantURL != "undefined"){
			gatewayMechantURL = options.gatewayMechantURL;
		}

		if(typeof options.openExternalsInPopup != "undefined" && options.openExternalsInPopup === false){
			openExternalsInPopup = false;
		}
		if(typeof options.openGatewayInPopup != "undefined" && options.openGatewayInPopup === false){
			openGatewayInPopup = false;
		}
	}
	//Valores de vuelta en el caso de pasarelas

	//type: sdk|url|formGateway
	//sdk: "paysafe_card_3ds"|...|...
	if(payments.isDebug()){
		isDebug = true;
	}
	performActions(e,payments,redirectionURL,options);

	function getPaymentFormSelector(){
		var usedMethods = payments.paymentsObj.getLastPaymentResult();
		if(usedMethods.method != null || usedMethods.submethod != null){
			//Si alguno de los métodos/submétodos existe, paymentsManager se está usando
			if(usedMethods.submethod != null){
				var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
			}else{
				var domElem = payments.getMethodDOMelem(usedMethods.method);
			}
			var el = $(domElem).find('form[data-payment-storage].is-active');
		}else{
			//Si no, buscamos si quickPayments se está usando
			if($("[data-quickpaymanager]").length > 0){
				var el = $("[data-quickpaymanager] form[data-payment-storage]");
			}
		}
		return el;
	}

	function performActions(e,payments,redirectionURL,options){
		switch(e.type){
			case "gateway":
				if(typeof e.params.url != "undefined" && e.params.url.length != 0){
					window.location.href = e.params.url;
				}
			break;
			case "formGateway":
				//Pasarela en la que haya que enviar un formulario formado
				var el = getPaymentFormSelector();
				pgw = new paymentsGatewayManager(payments,el);

				//$('form[data-payment-storage]:visible [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting)
				pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting);
				$('#formGateway').attr("action",e.params.action);
				$('#formGateway').empty();
				$.each(e.params.var,function(key,val){
					if(Array.isArray(val)) {
						$.each(val,function(key2,val2){
							$('<input>').attr({
								type: 'hidden',
								name: key,
								value: val2
							}).appendTo('#formGateway');
						});
					} else {
						$('<input>').attr({
							type: 'hidden',
							name: key,
							value: val
						}).appendTo('#formGateway');
					}
				});
				if(openGatewayInPopup){
					var selectorToInject = '[data-payment-externals]';

					var callbackOnClosePopup = function(){
						payments.refresh();
					}
					var callbackOnLoad = function(){
						$(popUpSelector).find('[data-core_reveal-close]').remove();
					}

					var width = false;
					var height = false;
					var iframeDom = popUpSelector+" "+selectorToInject;
					$(popUpSelector).attr('data-iframed','')

					if( $(iframeDom).find('iframe').length > 0 ){
						$(iframeDom).find('iframe').remove();
					}
					$(iframeDom).append("<iframe name='gateway' id='gateway'></iframe>");
					var prevStyle = "";
					if(width){
						if(typeof $(popUpSelector).attr('style') != "undefined"){
							var prevStyle = $(popUpSelector).attr('style');
						}
						$(popUpSelector).attr('style',prevStyle + " ;max-width:"+width+"!important");
					}
					if(height){
						if(typeof $(popUpSelector).attr('style') != "undefined"){
							var prevStyle = $(popUpSelector).attr('style');
						}
						$(popUpSelector).attr('style',prevStyle + " ;max-height:"+height+"!important");
					}
					$(document).on('open.zf.reveal',popUpSelector,function(){
						if(!Foundation.MediaQuery.atLeast('medium') && typeof $(popUpSelector).attr('data-iframed') != "undefined"){
							$(iframeDom).css('padding-top',$(popUpSelector).find('[data-modal-title]').outerHeight()+"px")
						}
						callbackOnLoad();
					})
					$(document).off('closed.zf.reveal',popUpSelector).on('closed.zf.reveal',popUpSelector,function(){
						$(iframeDom).removeAttr('style');
						$(popUpSelector).removeAttr('data-iframed')
						callbackOnClosePopup();
						$(iframeDom).find('iframe').remove();
					})

					$(popUpSelector).core_reveal('open')
					$('#formGateway').prop('target','gateway');
				$('#formGateway').submit();
				}else{
					$('#formGateway').submit();
				}
			break;

			case "externalValidation":
				//Se usa cuando la plataforma se ejecuta en otro dispositivo, y en nuestra plataforma
				//sirve como enlace para ir viendo como se desarrolla el pago
				var usedMethods = payments.paymentsObj.getLastPaymentResult();
				if(usedMethods.submethod != null){
					var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
				}else{
					var domElem = payments.getMethodDOMelem(usedMethods.method);
				}

				var cancelBt = $(domElem).find('[data-cancel-payment="externalvalidation"]');
				var dataStatusMsg = $(domElem).find('[data-payment-storage].is-active [data-status-msg]');
				var previousAnimationState = payments.getAnimation();
				$(domElem).find('[data-payment-externalvalidation]').addClass('is-active');
				payments.setAnimation(false);

				payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
				payments.blockAllMethods(false);
				payments.unblockMethod(usedMethods.method,false);
				payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
				payments.hideInfoArea(usedMethods.method,usedMethods.submethod);
				payments.hidePaymentsMethods(usedMethods.method,usedMethods.submethod);
				$(dataStatusMsg).removeClass('success').html(payments.paymentsObj.strings.redirecting);
				var formx = new formeSubmit(false,"");
				$(cancelBt).off('click').on('click',function(){
					$(dataStatusMsg).hide();
					payments.refresh(false);
					payments.setDefaultMethod(usedMethods.method);
					$(domElem).find('[data-payment-externalvalidation]').removeClass('is-active');
					payments.showPaymentsMethods(usedMethods.method,usedMethods.submethod);
					payments.showInfoArea(usedMethods.method,usedMethods.submethod);
					payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);
					formx.getXHR().abort();
					payments.setAnimation(previousAnimationState);
					payments.unblockAllMethods();
				})
			break;

			case "iframe":
				var options = {}
				var el = getPaymentFormSelector();
				pgw = new paymentsGatewayManager(payments,el);

				if(e.environment == "sandbox"){
					options["debug"] = true;
				}

				var callbackOnPaymentFailure = function(e,scope){
					if(typeof e.type != "undefined"){
						performActions(e,payments,redirectionURL,options);
					}else{
						payments.unblockAllMethods();
					}
				}
				var paymentParams = {
					url: 		e?.params?.action ?? null,
					authParams:	e?.params?.var ?? null,
					domain:		e?.params?.domain ?? null
				}
				let pluginObj = new plugin_iframe(pgw,paymentParams,e.refPago,callbackOnPaymentFailure,options);
			break;

			case "requestAdditionalInfo":
				pgw = new paymentsGatewayManager(payments,el);
				var paymentParams = {
					paymentsObj: payments,
					fieldsObj: e?.params?.askFor,
					actionsObj: e?.params?.actions,
					stringsObj: e?.params?.string
				}
				var requestInfoObj = new plugin_requestInfo(pgw,paymentParams,e.refPago,callbackOnPaymentFailure,options);
			break;
			case "sdk":
	// 			var sdk = "neteller";

				var el = getPaymentFormSelector();
				pgw = new paymentsGatewayManager(payments,el);

				switch(e.params.sdk){

					case "threeDS_iframeAuth":
						var options = {}

					   	if(e.environment == "sandbox"){
							options["debug"] = true;
					   	}

					   var callbackOnPaymentFailure = function(e,scope){
						   if(typeof e.type != "undefined"){
							   performActions(e,payments,redirectionURL,options);
						   }else{
							   payments.unblockAllMethods();
						   }
					   }
					   var paymentParams = {
							url: 		e?.params?.action ?? null,
							authParams:	e?.params?.var ?? null,
							domain:		e?.params?.domain ?? null
					   }
					   var threeDS_obj = new threeDSPlugin_iframeAuth(pgw,paymentParams,e.refPago,callbackOnPaymentFailure,options);
					break;

					case "apple_pay":
						var options = {}
						if(e.environment == "sandbox"){
							options["debug"] = true;
						}

						var callbackOnPaymentFailure = function(e,scope){
							payments.unblockAllMethods();
						}
						var paymentParams = {
							sessionToken: 	e.params.sessionToken,
							paymentOption:	e.params.paymentOption,
							company:		e.params.label,
							currency:		e.params.currency,
							country:		e.params.country,
							amount:			e.params.amount
						}
						e?.params?.language ? options["language"] = e.params.language : "EN";
						var threeDS_obj = new threeDSPlugin_applepay(pgw,e.params.merchantId,e.params.merchantSiteId,paymentParams,e.refPago,callbackOnPaymentFailure,options);
					break;

					case "threeds_paysafe":
						var options = {}
						if(e.environment == "sandbox"){
							options["debug"] = true;
						}
						var callbackOnPaymentFailure = function(e){
							if(typeof e.type != "undefined"){
								performActions(e,payments,redirectionURL,options);
							}else{
								payments.unblockAllMethods();
							}
						}
						var threeDS_obj = new threeDSPlugin_paysafe(pgw,e.params.accountId,e.params.card,e.params.apiKey,e.refPago,callbackOnPaymentFailure,options)

					break;

					case "trustpay_google_pay":
						var options = {}
						if(e.environment == "sandbox"){
							options["debug"] = true;
						}
						var callbackOnPaymentFailure = function(e){
							if(typeof e.type != "undefined"){
								performActions(e,payments,redirectionURL,options);
							}else{
								payments.unblockAllMethods();
							}
						}
						var paymentParams = {
							allowedCards: 	e.params.allowedCardNetworks,
							currency:		e.currency,
							amount:			e.params.amount,
							gwMerchantId:	e.params.sitereference,
							gpMerchantId:	e.params.gpay_merchantId
						}
						var threeDS_obj = new threeDSPlugin_trust_googlePay(pgw,e.params.jwt,e.refPago,paymentParams,callbackOnPaymentFailure,options);
					break;

					case "threeds_trustpay":
						var options = {}
						if(e.environment == "sandbox"){
							options["debug"] = true;
						}
						var callbackOnPaymentFailure = function(e){
							if(typeof e.type != "undefined"){
								performActions(e,payments,redirectionURL,options);
							}else{
								payments.unblockAllMethods();
							}
						}
						var threeDS_obj = new threeDSPlugin_trustpayments(pgw,e.params.jwt,"",e.refPago,callbackOnPaymentFailure,options);
					break;


					case "threeds_nuvei": //Safecharge
						var options = {}
						if(e.environment == "sandbox"){
							options["debug"] = true;
						}

						var callbackOnPaymentFailure = function(e,scope){
							if(typeof e.type != "undefined"){
								performActions(e,payments,redirectionURL,options);
							}else{
								payments.unblockAllMethods();
							}
						}
						var paymentParams = {
							sessionToken: 	e.params.sessionToken,
							clientUID: 		e.refPago,
							paymentOption:	e.params.paymentOption,
							cardHolderName:	e.params.cardHolderName,
						}
						var threeDS_obj = new threeDSPlugin_nuvei(pgw,e.params.merchantId,e.params.merchantSiteId,paymentParams,e.refPago,callbackOnPaymentFailure,options);
					break;

					case "paysafe_card_3ds":
						//var usedMethods = payments.paymentsObj.getLastPaymentResult();
/* 						var subM = payments.getSelectedLimitId();
						var m = payments.getSelectedMethodId();
						var usedMethods = {}
						usedMethods["method"] = m;
						usedMethods["submethod"] = subM;

						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						} */




						pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting)
						//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting);
/* 						payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
 */						pgw.setSubmitBtState(false);
						var gwOptions = {
							card: {
								merchantAccountID:e.params.sdk_params.merchantAccountID,
								cardHolderName:e.params.sdk_params.cardHolderName,
								usePreviousBalance:payments.paymentsObj.isUsingPreviousBalance(),
								key:e.params.sdk_params.key,
								zip:e.params.sdk_params.zip,
								country:e.params.sdk_params.country,
								state:e.params.sdk_params.state,
							},
							company: {
								name: e.params.sdk_params.companyName,
								logoURL : e.params.sdk_params.logoURL,
								color: e.params.sdk_params.companyColor
							},
							currency:e.currency,

							onErrorCallback: function(e,error){
								pgw.setSubmitBtState(true);
/* 								payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);
 */								pgw.setAsyncMsgElem(error,"alert")
								//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').addClass('alert').html(error);
								payments.unblockAllMethods();
							},
							onCloseCallback: function(stage){
								if(stage == "BeforePayment"){
									$(pgw.getAsyncMsgsElem()).removeClass().html("").hide();
									pgw.clearAsyncMsg();

									//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass().html("").hide();
								}
								pgw.setSubmitBtState(true);
								/* payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod); */
								payments.unblockAllMethods();
							},
							onSuccessCallback: function(e){
								if(typeof e.data.url != "undefined" && e.data.url.length > 0){
									window.location.href = e.data.url;
								}
							},
							gatewayErrorStrings: gatewayStrings
						}
	/*
						if(typeof e.debug != "undefined" && e.debug === false){
							gwOptions["debug"] = false;
						}
	*/
						if(e.environment == "sandbox"){
							gwOptions["debug"] = true;
						}

						var amount = payments.paymentsObj.getCurrentAmount() * 100;
						if(typeof e != "undefined" && typeof e.params.sdk_params.amount != "undefined"){
							amount = e.params.sdk_params.amount;
						}
						var gw = new cardGateway(gatewayMechantURL,amount,e.refPago,gwOptions);
						gw.open();
					break;
					case "adyen":
						var usedMethods = payments.paymentsObj.getLastPaymentResult();
						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						}
						pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting);
						pgw.setSubmitBtState(false);
						/* $(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting); */
						/* payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod); */
						var gwOptions = {
							paymentMethodsResponse: e.params,
							clientKey: e.clientKey,
							locale: e.locale,
							environment: e.enviroment,
							onSubmit: (state, dropin) => {
								// Your function calling your server to make the `/payments` request
								myForm = new formeSubmit(false,"/data/?action=adyenPayment",
								{
									extraFields: { "state":JSON.stringify(state.data),"mode":"pay"},
									callbackOnSuccess: function(response) {
										console.log("onSubmit, response", response);
										if (response.action) {
											dropin.handleAction(response.action);
										} else {
											location.href = response.url;
										}
									}
								})
							},
							onAdditionalDetails: (state, dropin) => {
								console.log("addDetails",state);
								// Your function calling your server to make a `/payments/details` request
								myForm = new formeSubmit(false,"/data/?action=adyenPayment",
								{
									extraFields: { "state":JSON.stringify(state.data),"mode":"details"},
									callbackOnSuccess: function(response) {
										console.log("onAdditionalDetails, response", response);
										if (response.action) {
											dropin.handleAction(response.action);
										} else {
											location.href = response.url;
										}
									}
								})
							},
							onError: (error) => {
								console.log("error",error);
							},
							paymentMethodsConfiguration: e.paymentMethodsConfiguration
						};

						if(typeof isDebug){
							gwOptions["debug"] = true;
						}

						$('<link/>', {
							rel: 'stylesheet',
							type: 'text/css',
							href: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/3.18.1/adyen.css'
						 }).appendTo('head');
						$.getScript("https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/3.18.1/adyen.js",function(){
							const checkout = new AdyenCheckout(gwOptions);
							if(openExternalsInPopup){
								var selectorToInject = '[data-payment-externals]';
								$(popUpSelector).core_reveal("open");
								const dropin = checkout.create('dropin').mount(popUpSelector+" "+selectorToInject);
								$(document).off('closed.zf.reveal',popUpSelector).on('closed.zf.reveal',popUpSelector,function(){
									payments.refresh();
									$(popUpSelector+" "+selectorToInject).empty();
								})

							}else{
								if(typeof usedMethods.submethod != "undefined" && usedMethods.submethod != null){
									var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"]';
								}else{
									var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"]';
								}
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"]';
								const dropin = checkout.create('dropin').mount(selectorToInject);
								$(pgw.getAsyncMsgsElem()).hide();
								//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').hide();
							}

						})



					break;
					case "neteller":
	/*
						var usedMethods = payments.paymentsObj.getLastPaymentResult();
						var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						$(domElem).find('[data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting);
						payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
						var gwOptions = {
							neteller: {
								consumerId:"neteller.account@example.org",
								merchantRefNum: "111111",
								detail1Description:"Details 1 description",
								detail1Text:"Details 1 text"
							},
							company: {
								name: e.companyName,
								logoURL : e.logoURL,
								color: e.companyColor
							},
							onErrorCallback: function(e,error){
								 payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);
								 $(domElem).find('[data-status-msg]').removeClass('success').addClass('alert').html(error);
							},
							onCloseCallback: function(stage){
								if(stage == "BeforePayment"){
									 $(domElem).find('[data-status-msg]').removeClass().html("").hide();
								}
								payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);

							},
							onSuccessCallback: function(e){
								if(typeof e.url != "undefined" && e.url.length > 0){
									window.location.href = e.url;
								}
							},
							gatewayErrorStrings: gatewayStrings
						}
						if(typeof e.debug != "undefined" && e.debug === false){
							gwOptions["debug"] = false;
						}
						if(typeof e.billingCycle != "undefined"){ //Si existe un pago recurrerente:
							var billingCycleObj = {}
							if(typeof e.billingCycle.endDate != "undefined"){
								billingCycleObj["endDate"] = e.billingCycle.endDate;
							}
							if(typeof e.billingCycle.frequency != "undefined"){
								billingCycleObj["frequency"] = e.billingCycle.frequency;
							}
							gwOptions["billingCycle"] = billingCycleObj;
						}
						var amount = payments.paymentsObj.getCurrentAmount() * 100;
						if(typeof e != "undefined" && typeof e.importe != "undefined"){
							amount = e.importe;
						}
						var gw = new cardGateway(gatewayMechantURL,amount,e.refPago,e.key,e.zip,e.country,gwOptions);
						gw.open();
	*/

					break;

					case "skrill":
						//var usedMethods = payments.paymentsObj.getLastPaymentResult();
						var subM = payments.getSelectedLimitId();
						var m = payments.getSelectedMethodId();
						var usedMethods = {}
						usedMethods["method"] = m;
						usedMethods["submethod"] = subM;

						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						}
						pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting);
						//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting);
						pgw.setSubmitBtState(false);
						//payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);


						var gwOptions = {
							skrill: {
								sid:e.params.sid
							},
							onErrorCallback: function(e,error){
								pgw.setSubmitBtState(true);
								 //payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);
								 payments.unblockAllMethods();
								 pgw.setAsyncMsgElem(error,"alert");
								 //$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').addClass('alert').html(error);
							},
							onCloseCallback: function(stage){
								if(stage == "BeforePayment"){
									pgw.clearAsyncMsg();

									// $(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass().html("").hide();
								}
								pgw.setSubmitBtState(true);
								//payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);

							},
							onSuccessCallback: function(e){
								if(typeof e.url != "undefined" && e.url.length > 0){
									window.location.href = e.url;
								}
							},
							onGatewayLoadCallback: function(e){
								$(pgw.getAsyncMsgsElem()).remove();
								//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').remove();
								if(!openExternalsInPopup){
									$(pgw.getSubmitBtElem()).remove();
									/* $(domElem).find('[data-payment-storage].is-active [data-submit-payment]').remove(); */
								}
							},
							gatewayErrorStrings: gatewayStrings,

							render:{
	/*
								openInPopup:{
									method:usedMethods.method,
									submethod:usedMethods.submethod,
									injectionMethod: iframe|html,
									callbackOnClosePopup:function(){}
								},
								selectorToInject: selectorToInject,
	*/
							}

						}
						if(typeof isDebug){
							gwOptions["debug"] = true;
						}

						if(!openExternalsInPopup){
							if(typeof usedMethods.submethod != "undefined" && usedMethods.submethod != null){
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"]';
							}else{
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"]';
							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;
						}else{
							var selectorToInject =  '[data-payment-externals]';
							gwOptions["render"]["openInPopup"] = {
								method:usedMethods.method,
								submethod:usedMethods.submethod,
								callbackOnClosePopup:function(){
									payments.refresh();
								}
							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;
						}

						if(typeof e.environment != "undefined" && e.environment === "production"){
							gwOptions["debug"] = false;
						}else{
							gwOptions["debug"] = true;
						}
	/* 					var amount = payments.paymentsObj.getCurrentAmount();
						if(typeof e != "undefined" && typeof e.importe != "undefined"){
							amount = e.importe;
						} */
						var gw = new cardGateway(gatewayMechantURL,amount,e.refPago,gwOptions);
						gw.open();
					break;

					case "nuvei_gateway":
						var usedMethods = payments.paymentsObj.getLastPaymentResult();
						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						}
						pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting);
						Pgw.setSubmitBtState(false);
						//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting);
						//payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
						var gwOptions = {
							nuvei_gateway: e.params.data /*{


								sessionToken: e.data.sessionToken,
								merchantId: e.data.merchantId,
								merchantSiteId: e.data.merchantSiteId,
								userTokenId: e.data.userTokenId,
								country: e.country,
								currency: e.currency,
								renderTo:"",
								env:"prod",
								locale:e.locale,
								email:e.email,
								fullName: e.fullname,
								pmWhitelist: ["cc_card"],
								showResponseMessage: true

							}*/,
							gatewayErrorStrings: "",
							render:{
	/*
								openInPopup:{
									method:usedMethods.method,
									submethod:usedMethods.submethod,
									injectionMethod: iframe|html,
									width:"100px|100%...",	//opcional
									height:"100px|100%...",	//opcional
									callbackOnClosePopup:function(){}
								},
								selectorToInject: selectorToInject,
	*/
							}

						}

						if(e.environment == "sandbox"){
							gwOptions["debug"] = true;
						}


						if(!openExternalsInPopup){
							if(typeof usedMethods.submethod != "undefined" && usedMethods.submethod != null){
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"]';
							}else{
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"]';
							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;

						}else{
							var selectorToInject =  '[data-payment-externals]';
							gwOptions["render"]["openInPopup"] = {
								method:usedMethods.method,
								submethod:usedMethods.submethod,
								injectionMethod:"iframe",
								width:"720px",
								callbackOnClosePopup:function(){
									payments.refresh();
								}
							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;
						}
						var gw = new cardGateway(gatewayMechantURL,e.params.data.total_amount,e.params.id,gwOptions);
						gw.open();
					break;

					case "nuvei_sdk":
						var stage = null;
						var usedMethods = payments.paymentsObj.getLastPaymentResult();
						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						}
						pgw.setAsyncMsgElem(payments.paymentsObj.strings.redirecting);
						pgw.setSubmitBtState(false);
						//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').removeClass('success').html(payments.paymentsObj.strings.redirecting);
						//payments.setPurchaseButtonAvailability(false,usedMethods.method,usedMethods.submethod);
						var refPago = e.refPago;
						var gwOptions = {
							nuvei_sdk: {
								sessionToken: e.data.sessionToken,
								merchantId: e.data.merchantId,
								merchantSiteId: e.data.merchantSiteId,
								userTokenId: e.data.userTokenId,
								country: e.country,
								currency: e.currency,
								renderTo:"",
								env:"prod",
								locale:e.locale,
								email:e.email,
								fullName: e.fullname,
								pmWhitelist: ["cc_card"],
								showResponseMessage: false
							},
							onErrorCallback: function(e,error){},
							onCloseCallback: function(){
								if(stage == null){
									payments.unblockAllMethods();
									payments.refresh();
								}
								if(stage == "completeWithErrors"){
									pgw.setSubmitBtState(true);
									//payments.setPurchaseButtonAvailability(true,usedMethods.method,usedMethods.submethod);
									payments.unblockAllMethods();
								}
							},
							onSuccessCallback: function(params){
								var myForm = new formeSubmit(false,"/data/?action=updatePaymentStatus",
								{
									extraFieldsAsPost: params,
									callbackOnSuccess: function(response) {
										if(typeof response.url != "undefined"){
											location.href = response.url;
										}
									}
								})
								if(params.status == "ok"){
									pgw.setAsyncMsgElem(payments.paymentsObj.strings.paymentDone,"success");
									//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').addClass('success').html(payments.paymentsObj.strings.paymentDone);
									stage = "completeWithoutErrors";
								}else{
									pgw.setAsyncMsgElem(params.error,"alert");

									//$(domElem).find('[data-payment-storage].is-active [data-status-msg]').addClass('alert').html(params.error);
									stage = "completeWithErrors";
									if(openExternalsInPopup){
										gwOptions["render"]["openInPopup"]["callbackOnClosePopup"] = function(){}
									}
								}
							},
							onGatewayLoadCallback: function(e){
								if(!openExternalsInPopup){
									$(pgw.getSubmitBtElem()).remove();
									//$(domElem).find('[data-payment-storage].is-active [data-submit-payment]').remove();
								}
							},
							onResultCallback: function(e){
								if(e.result.toUpperCase() == "APPROVED"){
									gwOptions.onSuccessCallback({
										transactionID: refPago,
										status: "ok"
									})
								}else{
									gwOptions.onSuccessCallback({
										transactionID: refPago,
										status: "error",
										error: e.errorDescription + "(" + e.errCode+ ")"
									})
									gwOptions.callbackOnClosePopup = function(){

									}
								}
							},
							gatewayErrorStrings: gatewayStrings,

							render:{
	/*
								openInPopup:{
									method:usedMethods.method,
									submethod:usedMethods.submethod,
									injectionMethod: iframe|html,
									width:"100px|100%...",	//opcional
									height:"100px|100%...",	//opcional
									callbackOnClosePopup:function(){}
								},
								selectorToInject: selectorToInject,
	*/
							}

						}

						gwOptions.nuvei_sdk["onResult"] = function(e){
							gwOptions.onResultCallback(e);
						}


						if(typeof isDebug){
							gwOptions["debug"] = true;
							gwOptions.nuvei_sdk.env = "int"
						}


						if(!openExternalsInPopup){
							if(typeof usedMethods.submethod != "undefined" && usedMethods.submethod != null){
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"]';
							}else{
								var selectorToInject = '[data-payment-externals][data-method="'+usedMethods.method+'"]';
							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;
						}else{
							var selectorToInject =  '[data-payment-externals]';
							gwOptions["render"]["openInPopup"] = {
								method:usedMethods.method,
								submethod:usedMethods.submethod,
								injectionMethod:"html",
								callbackOnClosePopup:function(){
									gwOptions.onCloseCallback();
								},
								allowClose: true

							}
							gwOptions["render"]["selectorToInject"] =  selectorToInject;
						}

						if(typeof e.debug != "undefined" && e.debug === false){
							gwOptions["debug"] = false;
						}
	// 					var amount = payments.paymentsObj.getCurrentAmount();
						if(typeof e != "undefined" && typeof e.importe != "undefined"){
							amount = e.importe;
						}
						gwOptions.nuvei_sdk["amount"] = amount / 100; //Caso explícito para NUVEI.
						var gw = new cardGateway(gatewayMechantURL,amount,e.refPago,gwOptions);
						gw.open();
					break;
					case "astropay":
/* 						var usedMethods = payments.paymentsObj.getLastPaymentResult();
						if(usedMethods.submethod != null){
							var domElem = payments.getLimitDOMelem(usedMethods.method,usedMethods.submethod);
						}else{
							var domElem = payments.getMethodDOMelem(usedMethods.method);
						}
						var statusMsg = $(domElem).find('[data-payment-storage].is-active [data-status-msg]');
						var submitBt = $(domElem).find('[data-payment-storage].is-active [data-submit-payment]');
						 */
						var statusMsg = pgw.getAsyncMsgsElem();
						var depositId = e.params.depositId;
						var refPago = e.refPago;
						if(typeof window.AstropaySDK == "undefined"){
							$.getScript("https://js.astropay.com/v1/sdk.js",function(){
								window.AstropaySDK.init(e.params.appId, {
									"environment": e.environment
								});
								window.AstropaySDK.showDeposit(depositId);
								pgw.clearAsyncMsg();
								pgw.setAsyncMsgElem(payments.paymentsObj.strings.wait);
								$(statusMsg).show();
								pgw.setSubmitBtState(false);
/* 								$(statusMsg).hide().empty().removeClass("success");
								$(statusMsg).html(payments.paymentsObj.strings.wait).show(); */
							})
						}else{
							window.AstropaySDK.showDeposit(depositId);
							pgw.clearAsyncMsg();
							pgw.setAsyncMsgElem(payments.paymentsObj.strings.wait);
							pgw.setSubmitBtState(false);
							$(statusMsg).show();
/* 							$(statusMsg).hide().empty().removeClass("success");
							$(statusMsg).html(payments.paymentsObj.strings.wait).show(); */
						}
						var style = "<style>#astro-container {z-index:999} </style>";
						$('head').append(style);
						$(document).off('DOMNodeRemoved').on('DOMNodeRemoved', function(e) {

								if(e.target.localName=="div" && typeof $(e.target).attr('id') != "undefined" && $(e.target).attr('id') == "astro-container"){
									var elem = e.target
									/* $(submitBt).attr('disabled','disabled'); */
									pgw.setSubmitBtState(false);

									var checkTransactionStatus = new formeSubmit(false,"/data/?action=checkPaymentStatus",{
										sendDataAsJSON: true,
										extraFields: {
											refPago: refPago
										},
										statusMsg: {
											elem: $(statusMsg),
											hold: payments.paymentsObj.strings.wait
										},
										callbackOnSuccess: function(j){
											if(typeof j.data.pagado != "undefined" && j.data.pagado === true){
												if(typeof j.data.url != "undefined"){
													window.location.href = j.data.url;
													pgw.setAsyncMsgElem(payments.paymentsObj.strings.paymentDone,"success")
													$(statusMsg).show();
													/* $(statusMsg).html(payments.paymentsObj.strings.paymentDone).show(); */
												}
											}else{
												payments.unblockAllMethods();
												pgw.clearAsyncMsg();
												pgw.setSubmitBtState(true);
/* 												$(submitBt).removeAttr('disabled');
												$(statusMsg).hide().empty(); */
											}
										},
										callbackOnFail: function(j){
											payments.unblockAllMethods();
											pgw.setSubmitBtState(true);
											/* $(submitBt).removeAttr('disabled'); */
										}
									})
								};
						});
					break;
				}

			break;

			default:
				//console.log(e)
				if(typeof e.type == "undefined"){
					if(typeof e.data.url == "undefined" || (typeof e.data.url != "undefined" && e.data.url.length == 0)){
						window.location.href = redirectionURL;
					}else{
						window.location.href = e.data.url;
					}
				}
		}
	}




	//Pasarela PAYSAFE


}

function purchaseFailCallback(e,payments,redirectionURL){
	if(typeof $zopim != "undefined" && typeof $zopim.livechat != "undefined") { $zopim.livechat.addTags('paymentError'); }
	payments.unblockAllMethods();
	on_fail_functions(e,payments);

}


/********************************/
/* 1-CLICK-PURCHASE				*/
/********************************/
var oneClickPurchase = function (toCartURL, tramos, tramosArray, currentCartItems,options){ 	//toCartURL: Url para añadir al carro para la petición,
																						//tramos:	 Objeto dtos por tramos,
																						//tramosArray: Array con instancias de objetos tramos para cada uno de los juegos
																						//currentCartItems:  Snapshot de los items del carro (para ver si hay elementos en él, para recalcular tramos
	this.URL = toCartURL;
	this.tramos = false;
	this.tramosArray = {};
	this.currentCartItems = null;
	this.strings = {
		"wait":"{t}Espere{/t}"
	}
	this.elem = $('[data-oneclickpurchase]:visible');
	this.min = 0;
	this.max = 99;
	if(typeof tramos != "undefined" && tramos != false){
		this.tramos = tramos;
	}
	if(typeof tramosArray != "undefined" && tramosArray != false){
		this.tramosArray = tramosArray;
	}
	if(typeof currentCartItems != "undefined" && currentCartItems != false){
		this.currentCartItems = {};
		this.parseCartItems(currentCartItems);
	}
	if(typeof options != "undefined" ){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.wait != "undefined"){ this.strings.wait = options.strings.wait }
		}
		if(typeof options.min != "undefined"){
			this.min = options.min;
		}
		if(typeof options.max != "undefined"){
			this.max = options.max;
		}
	}

	this.typeGameTabs = { boleto:"1",club:"4",decimo:"1",fondo:"2"};
	this.typeBets = {};

	this.refresh();

}
oneClickPurchase.prototype.parseCartItems = function(cartItemsObj){
	var self = this;
	$.each(cartItemsObj,function(k,v){
		if(typeof self.currentCartItems[v.tipo] != "undefined"){
			if(typeof v.tipoSorteoLoteria != "undefined"){
				//Si hay subtipo, y no existe, se añade
				//Si existe, se acumula
				if(typeof self.currentCartItems[v.tipo]["subTipos"][v.tipoSorteoLoteria] != "undefined"){
					self.currentCartItems[v.tipo]["subTipos"][v.tipoSorteoLoteria] = self.currentCartItems[v.tipo]["subTipos"][v.tipoSorteoLoteria] + parseFloat(v.apuestas*v.semanas)
				}else{
					self.currentCartItems[v.tipo]["subTipos"][v.tipoSorteoLoteria] = parseFloat(v.apuestas*v.semanas)
				}

			}else{
				//Si no hay subtipos, se inserta tal cual
				self.currentCartItems[v.tipo]["subTipos"][0] = self.currentCartItems[v.tipo]["subTipos"][0] + parseFloat(v.apuestas*v.semanas);
			}
		}else{
			self.currentCartItems[v.tipo] = {}
			self.currentCartItems[v.tipo]["subTipos"] = {}
			if(typeof v.tipoSorteoLoteria != "undefined"){
				self.currentCartItems[v.tipo]["subTipos"][v.tipoSorteoLoteria] = parseFloat(v.apuestas*v.semanas)
			}else{
				self.currentCartItems[v.tipo]["subTipos"][0] = parseFloat(v.apuestas*v.semanas)
			}
		}
	})
}

oneClickPurchase.prototype.getCartBets = function(game,subtype){
	var self = this;
	var subtipo = false;
	//Es posible que los tramos vengan recalculados para que no haya que obtener los items del carro y no sea necesario llamar a esta funcion

	if(self.currentCartItems == null){
		return 0;
	}

	if(typeof subtype != "undefined" && subtype !== false){
		subtipo = subtype;
	}else{
		subtipo = 0;
	}
	var self = this;
	if(typeof self.currentCartItems[game] != "undefined"){
		return self.currentCartItems[game]["subTipos"][subtipo];
	}else{
		return 0;
	}
}

oneClickPurchase.prototype.refresh = function(){
	var self = this;
	var calculatePurchaseOptionsAdd = function(object,val,counterElem,counterClass) {
		var valor = null;
		var counterElem = $(object).closest("[data-purchase-gametype]").find("[data-counter]");
		if($(counterElem)[0].nodeName == 'INPUT'){
			valor = parseInt($(counterElem).val());
		}else{
			valor = parseInt($(counterElem).text());
		}
		if((valor) <= self.max){
			var typeGame = $(object).closest("[data-purchase-gametype]").attr("data-purchase-gametype");
			var subtype = false;
			if(typeof $(object).closest("[data-purchase-gamesubtype]").attr("data-purchase-gamesubtype") != "undefined"){
				subtype = $(object).closest("[data-purchase-gamesubtype]").attr("data-purchase-gamesubtype");
			}
			var game = $(object).closest("[data-purchase-game]").attr("data-purchase-game");
			var price = $(object).closest("[data-purchase-price]").attr("data-purchase-price");
			var min = $(object).closest("[data-purchase-min]").attr("data-purchase-min");
			if(typeof(self.typeBets[self.typeGameTabs[typeGame]])=="undefined") self.typeBets[self.typeGameTabs[typeGame]] = {};
			if(typeof(self.typeBets[self.typeGameTabs[typeGame]][game])=="undefined") self.typeBets[self.typeGameTabs[typeGame]][game] = 0;

			if(min>1 && valor == 1) {
				self.typeBets[self.typeGameTabs[typeGame]][game] += 1;
				if($(counterElem)[0].nodeName == 'INPUT'){
					$(counterElem).val(min);
				}else{
					$(counterElem).text(min);
				}
			}
			self.typeBets[self.typeGameTabs[typeGame]][game] += 1;
			if(self.tramos && typeof self.tramos[game] != "undefined"){
				if(typeof self.tramosArray[game].descuentosObj !="undefined"){
					var currentTramo = self.tramosArray[game].getCurrentTramo(self.getAllBetsFromGame(game)+self.getCartBets(game,subtype)) //Si hay self.tramos para este juego
				}else{
					var currentTramo = false;	//Si no hay self.tramos definidos
				}
				if(currentTramo !== false){
					$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].descuentosObj.tramos[currentTramo-1].precioPorApuesta);
				}else{
					$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].precioPorDefecto);
				}
			}
			refreshPrice();
		}
	}
	var calculatePurchaseOptionsRem = function(object,val,counterElem,counterClass) {
		var valor = null;
		console.log()
		var counterElem = $(object).closest("[data-purchase-gametype]").find("[data-counter]");
		if($(counterElem)[0].nodeName == 'INPUT'){
			valor = parseInt($(counterElem).val());
		}else{
			valor = parseInt($(counterElem).text());
		}
		valor = parseInt(val)
		if(valor >= counterClass.min){
			var typeGame = $(object).closest("[data-purchase-gametype]").attr("data-purchase-gametype");
			var subtype = false;
			if(typeof $(object).closest("[data-purchase-gametype]").attr("data-purchase-gamesubtype") != "undefined"){
				subtype = $(object).closest("[data-purchase-gamesubtype]").attr("data-purchase-gamesubtype");
			}
			var game = $(object).closest("[data-purchase-game]").attr("data-purchase-game");
			var price = $(object).closest("[data-purchase-price]").attr("data-purchase-price");
			if(typeof(self.typeBets[self.typeGameTabs[typeGame]])=="undefined") self.typeBets[self.typeGameTabs[typeGame]] = {};
			if(typeof(self.typeBets[self.typeGameTabs[typeGame]][game])=="undefined") self.typeBets[self.typeGameTabs[typeGame]][game] = 0;

			if(counterClass.min>valor) {
				self.typeBets[self.typeGameTabs[typeGame]][game] = 1;
				if($(counterElem)[0].nodeName == 'INPUT'){
					$(counterElem).val(counterClass.min);
				}else{
					$(counterElem).text(counterClass.min);
				}
			}else{
				if(valor >= counterClass.min || counterClass.min == 0){
					if(self.typeBets[self.typeGameTabs[typeGame]][game] > counterClass.min){
						self.typeBets[self.typeGameTabs[typeGame]][game] -= 1;
					}
				}
			}


			if(self.tramos && typeof self.tramos[game] != "undefined"){

				if(typeof self.tramosArray[game].descuentosObj !="undefined"){
					var currentTramo = self.tramosArray[game].getCurrentTramo(self.getAllBetsFromGame(game)+self.getCartBets(game,subtype)) //Si hay self.tramos para este juego
				}else{
					var currentTramo = false;	//Si no hay self.tramos definidos
				}
				if(currentTramo !== false){
					$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].descuentosObj.tramos[currentTramo-1].precioPorApuesta);
				}else{
					$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].precioPorDefecto);
				}
			}

			refreshPrice();
		}
	}




	function refreshPrice() {
		var totalPrice = 0;
		var totalDefaultPrice = 0;

		for(var dataInfo in self.typeBets) {
			for(var dataInfoType in self.typeBets[dataInfo]) {
				var price = $(self.elem).find("[data-purchase-game="+dataInfoType+"]").attr("data-purchase-price");
				var bets = self.typeBets[dataInfo][dataInfoType];
				myDecimoPurchaseOptionsRefresh = new purchaseOptions(0,0);
				totalPrice += myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,price);
				if(self.tramos && typeof self.tramos[dataInfoType] != "undefined"){
					var defaultPrice = self.tramosArray[dataInfoType].precioPorDefecto;
					totalDefaultPrice += myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,defaultPrice);
				}else{
					var defaultPrice = price;
					totalDefaultPrice += myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,price);
				}
			}
		}
		if(totalPrice < totalDefaultPrice){
			myDecimoPurchaseOptionsRefresh.priceWithoutDiscount = parseFloat(totalDefaultPrice).toFixed(2);
			updatePriceLabels(myDecimoPurchaseOptionsRefresh,true);
		}else{
			updatePriceLabels(null,true,true);
		}

		if(totalPrice>0) {
			myDecimoPurchaseOptionsRefresh.setCanBuy(true);
		} else {
			myDecimoPurchaseOptionsRefresh.setCanBuy(false);
		}
		totalPrice = Math.round(totalPrice*100)/100;
		if(typeof global_currency == "undefined"){
			var ppp = totalPrice.toFixed(2).replace(".", ",")+"€";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(totalPrice.toFixed(2)),null,{wrapper:"small"});
		}
		$(self.elem).find("[data-purchase-total]").html(ppp);
	}
	const countersArray = new Array();
	$(self.elem).find('[data-gametype]').each(function(){
		let min = $(this).attr('data-purchase-min');
		countersArray.push(	new countersEvents({ 'elem':$(this),'max':self.max,'min':min,'calculatePurchaseOptionsAfterAddCallback':calculatePurchaseOptionsAdd,'calculatePurchaseOptionsAfterRemCallback':calculatePurchaseOptionsRem }) )
	})
	//countersEvents({ 'elem':$(self.elem).find('[data-gametype]'),'max':self.max,'min':self.min,'calculatePurchaseOptionsAfterAddCallback':calculatePurchaseOptionsAdd,'calculatePurchaseOptionsAfterRemCallback':calculatePurchaseOptionsRem });

	$(self.elem).find('[data-purchase-button]').off('click').on('click',function(){
		var urlCart = self.URL;
		myForm = new formeSubmit(false,"/data/?action=toCart",
		{
			extraFields: { "bets":JSON.stringify(self.typeBets),"fastMode":1},
			redirectURL: urlCart,
			submitBt: {
				elem : $(this),
				holdMsg: self.strings.wait
			},
			statusMsg: {
				elem: $(this).closest("[data-oneClickPurchase]").find("[data-status-msg]")
			}
		});
	});
}

oneClickPurchase.prototype.getAllBetsFromGame = function(gameId){
	var self = this;
	var totalBets = 0;
	$.each(self.typeBets,function(){
		if(typeof this[gameId] != "undefined"){
			totalBets += this[gameId];
		}
	})
	return totalBets;
}

oneClickPurchase.prototype.setCartItems = function(newCart){
	if(typeof newCart != "undefined" && newCart != false){
		this.cartItems = newCart;
		this.currentCartItems = {}
		this.parseCartItems(newCart);
	}

}
oneClickPurchase.prototype.recalculateTramos = function(){
	var self = this;
	$(self.elem).find("[data-purchase-game]").each(function(){
		var game = $(this).attr("data-purchase-game");
		var subtype = $(this).attr("data-purchase-gamesubtype");
		if(self.tramos && typeof self.tramos[game] != "undefined"){
			if(typeof self.tramosArray[game].descuentosObj !="undefined"){
				var currentTramo = self.tramosArray[game].getCurrentTramo(self.getAllBetsFromGame(game)+self.getCartBets(game,subtype)) //Si hay self.tramos para este juego
			}else{
				var currentTramo = false;	//Si no hay self.tramos definidos
			}
			if(currentTramo !== false){
				$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].descuentosObj.tramos[currentTramo-1].precioPorApuesta);
			}else{
				$(self.elem).find("[data-purchase-game="+game+"]").attr("data-purchase-price",self.tramosArray[game].precioPorDefecto);
			}
		}
	})
}


oneClickPurchase.prototype.refreshPrice = function() {
	var self = this;
	var totalPrice = 0;
	var totalDefaultPrice = 0;
	if(Object.keys(self.typeBets).length > 0){
		for(var dataInfo in self.typeBets) {
			for(var dataInfoType in self.typeBets[dataInfo]) {
				var price = $(self.elem).find("[data-purchase-game="+dataInfoType+"]").attr("data-purchase-price");
				var bets = self.typeBets[dataInfo][dataInfoType];
				self.myDecimoPurchaseOptionsRefresh = new purchaseOptions(0,0);
				totalPrice += self.myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,price);
				if(self.tramos && typeof self.tramos[dataInfoType] != "undefined"){
					var defaultPrice = self.tramosArray[dataInfoType].precioPorDefecto;
					totalDefaultPrice += self.myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,defaultPrice);
				}else{
					var defaultPrice = price;
					totalDefaultPrice += self.myDecimoPurchaseOptionsRefresh.calculatePrice(bets,false,price);
				}
			}
		}

		if(totalPrice < totalDefaultPrice){
			self.myDecimoPurchaseOptionsRefresh.priceWithoutDiscount = parseFloat(totalDefaultPrice).toFixed(2).replace(".", ",");
			updatePriceLabels(self.myDecimoPurchaseOptionsRefresh,true);
		}else{
			updatePriceLabels(null,true,true);
		}

		if(totalPrice>0) {
			self.myDecimoPurchaseOptionsRefresh.setCanBuy(true);
		} else {
			self.myDecimoPurchaseOptionsRefresh.setCanBuy(false);
		}
		totalPrice = Math.round(totalPrice*100)/100;
		if(typeof global_currency == "undefined"){
			var ppp = totalPrice.toFixed(2).replace(".", ",")+"€";
		}else{
			var ppp = global_currency.getMoneda(parseFloat(totalPrice.toFixed(2)),null,{wrapper:"small"});
		}
		$(self.elem).find("[data-purchase-total]").html(ppp);
	}
}


/*********************************/
/* FUNCIONES PARA LOGIN/REGISTRO */
/*********************************/

function launchLoginScripts(){
	var login = new loginProObject;
}

function recoverScript(formElem,actionURL,options){
	var formElem = $(formElem);
	var actionURL=actionURL;
	var ajaxObjParams=false;
	if(typeof options!="undefined"){
		if (typeof options.ajaxObjParams!="undefined") { ajaxObjParams=options.ajaxObjParams}
	}
	$(formElem).on("submit",function(ev){ ev.preventDefault();});
	$(formElem).off('formvalid.zf.abide.bam').on('formvalid.zf.abide.bam', function() {
		ajaxObjParams.callbackOnSuccess = function() {
		$('#recoverFields').addClass("hide");}
		myForm = new formeSubmit($(formElem),"/data/?action=recover",ajaxObjParams);
	})
}

function setNewPassword(formElem,actionURL,options){
	var formElem=$(formElem);
	var actionURL=actionURL;
	var ajaxObjParams=false;
	if(typeof options!="undefined"){
		if (typeof options.ajaxObjParams!="undefined") { ajaxObjParams=options.ajaxObjParams}
	}
	$(formElem).on("submit",function(ev){ ev.preventDefault();});
	$(formElem).off('formvalid.zf.abide.bam').on('formvalid.zf.abide.bam', function() {
		myForm = new formeSubmit($(formElem),actionURL,ajaxObjParams);
	})
}


function launchDoubleFactorScripts(elemForCounter,timerInSeconds){
		function setTimeoutCounter(secondsToTimeout,callbackPerIteration,callbackAtEnd){
			var finishSeconds 	= secondsToTimeout;
			var currentSeconds	= secondsToTimeout;
			var intervalo = setInterval(function(){
					currentSeconds--;
					if(currentSeconds > 0){
						callbackPerIteration(currentSeconds);
					}else{
						callbackAtEnd();
						clearInterval(intervalo);
					}
			}, 1000)

		}

		function showAlernate(state){
			var elem = $('[data-alternativeMethods]');
			if(state === true){
				$(elem).addClass('is-active');
				$(elem).find('button').removeAttr('disabled')
			}else if (state === false){
				$(elem).removeClass('is-active');
				$(elem).find('button').attr('disabled','disabled')
			}
		}

		function isAlternateVisible(){
			if($('[data-alternativeMethods]').hasClass("is-active")){
				return true;
			}else{
				return false;
			}

		}

		var btElem = $(elemForCounter)
		var btText = $(btElem).text();
		setTimeoutCounter(timerInSeconds,function(counterValue){
			$(btElem).text(btText + " ("+counterValue+")")
		},function(){
			$(btElem).text(btText);
			showAlernate(true);
		})

		$('[data-validationform]').on('submit',function(e){
			e.preventDefault();
			myForm = new formeSubmit($('[data-validationForm]'),"/data/?action=deviceValidation",
			{
				extraFields: { "lv-code":$('[name="lv-code"]').val() },
				callbackOnSuccess: function(e) {
					window.location.href=e.panel;

				},
				callbackOnFail: function(e){
					if(!isAlternateVisible){
						showAlernate(true);
					}
				}
			});
		})

		function resendCode(mode) {
			function bloqueosTodo(modoBloqueo){
				var btElem = $('[data-validationForm] [data-submitSMS]');
				var prevText = $(btElem).html();
				if(modoBloqueo === true){
					holdBt($('[data-validationForm] [data-submitSMS]'),prevText);
				}else if (modoBloqueo === false){
					unholdBt($('[data-validationForm] [data-submitSMS]'));
				}

				var btElem = $('[data-validationForm] [data-submitEmail]');
				var prevText = $(btElem).html();
				if(modoBloqueo === true){
					holdBt($('[data-validationForm] [data-submitEmail]'),prevText);
				}else if (modoBloqueo === false){
					unholdBt($('[data-validationForm] [data-submitEmail]'));
				}

			}
			bloqueosTodo(true);
			myForm = new formeSubmit(false,"/data/?action=deviceValidationResendCode",
			{
				extraFields: { "mode": mode },
				statusMsg: {
					elem: $('[data-validationForm] [data-status-msg]')
				},
				callbackOnSuccess: function(e) {
					bloqueosTodo(false);
				},
				callbackOnFail: function(e){
					bloqueosTodo(false);
				},
				callbackOnError: function(){
					bloqueosTodo(false);
				}
			});
		}

		$('[data-submitEmail]').on('click',function(){resendCode('email')})
		$('[data-submitSMS]').on('click',function(){resendCode('sms')})
		$('[data-explanatoryBt]').on('click',function(){
			$('[data-explanatory]').addClass('is-active');
		})
}





function launchSignUpScripts(){
	var login = new signUpObject;
}

var signUpObject = function(options){
	this.onStep1BeforeSubmit_callback=function(){};
	this.onStep1Success_callback=function(){};
	this.onStep1Fail_callback=function(){};
	this.onStep2Success_callback=function(){};
	this.onFail_callback=function(){}
	this.onUserNotApplicable_callback=function(){};
	this.onLoad_callback=function(){};
	this.disabledFinishOnLoad=false;
	this.loginObj = false;
	this.onValidatePhoneCode_callback = function(){}
	this.onValidateMailCode_callback = function(){}
	this.onValidatePhone_callback = function(){}
	this.onValidateMail_callback = function(){}

	this.useSingleStep = false;
	this.strings = {
		holdOn: options?.strings?.holdOn ?? "Espere...",
		creating: options?.strings?.creating ?? "Creando tu cuenta ...",
		unknownError: options?.strings?.unknownError ?? "Error desconocido",
		confirm: options?.strings?.confirm ?? "¿Deseas cancelar? Tendrás que volver a introducir todos los datos de nuevo{/t}"

	}
	//SUBMIT
	this.reloadOnSuccess = options?.reloadOnSuccess ?? true;
	this.serverSideRedirectDataSrc = options?.serverSideRedirectDataSrc ?? "panel";
	this.redirectToURLOnSuccess=	options?.redirectToURLOnSuccess ?? null;
	this.additionalParams = 		options?.extraFields ?? null;
	this.ignoreRedirectOnSuccess = 	options?.ignoreRedirectOnSuccess ?? false;
	//MODAL SYSTEM
	this.defaultModalElem= options?.defaultModalElem ?? "#signUp";
	this.defaultModalSrc= options?.defaultModalSrc ?? "signUp";
	this.closeModalOnSuccess=true;	//Si se lanza en modal, lo cerrará en success

	var parentObj=this;
	if(typeof options!="undefined"){
		if( typeof options.onStep1Success_callback != "undefined" ){ this.onStep1Success_callback = options.onStep1Success_callback }
		if( typeof options.onStep1BeforeSubmit_callback != "undefined" ){ this.onStep1BeforeSubmit_callback = options.onStep1BeforeSubmit_callback }
		if( typeof options.onStep1Fail_callback != "undefined" ){ this.onStep1Fail_callback = options.onStep1Fail_callback }
		if( typeof options.onStep2Success_callback != "undefined" ){ this.onStep2Success_callback = options.onStep2Success_callback }
		if( typeof options.onFail_callback != "undefined" ){ this.onFail_callback = options.onFail_callback }
		if( typeof options.onUserNotApplicable_callback != "undefined" ){ this.onUserNotApplicable_callback = onUserNotApplicable_callback }
		if( typeof options.onLoad_callback != "undefined" ){ this.onLoad_callback = options.onLoad_callback }
		if( typeof options.disabledFinishOnLoad != "undefined" ){ this.disabledFinishOnLoad = options.disabledFinishOnLoad }
		if( typeof options.loginObj != "undefined" ){ this.loginObj = options.loginObj }
		if( typeof options.onValidatePhoneCode_callback != "undefined" ){ this.onValidatePhoneCode_callback = options.onValidatePhoneCode_callback }
		if( typeof options.onValidateMailCode_callback != "undefined" ){ this.onValidateMailCode_callback = options.onValidateMailCode_callback }
		if( typeof options.onValidatePhone_callback != "undefined" ){ this.onValidatePhone_callback = options.onValidatePhone_callback }
		if( typeof options.onValidateMail_callback != "undefined" ){ this.onValidateMail_callback = options.onValidateMail_callback }
		if( typeof options.useSingleStep != "undefined" ){
			if(options.useSingleStep === false || options.useSingleStep === true){
				this.useSingleStep = options.useSingleStep
			}
		}

	}
	$('form[data-abide][data-signupForm]').off('submit.bam').on('submit.bam', function(ev,frm) {
		ev.preventDefault();
	})


// 	launchEventListeners();
	customLabelEvents();

// 	Foundation.Abide.defaults.patterns['plus_only'] = /^\+?[0-9]{0,3}?\s?[0-9\s\.\-]{9,}$/;
	//
	//Foundation.Abide.defaults.patterns["passwordReset"] = /(.){8,}/;

	Foundation.Abide.defaults.patterns['phoneNumber'] = /^[0-9\s\.\-]{9,}$/;
	Foundation.Abide.defaults.patterns['dni_passport'] = /^[A-Za-z]?[0-9\.?\s?]*\-?[A-Za-z]$/;

	var parentObj=this;
	this.init();
}

signUpObject.prototype.init = function(){
	var parentObj = this;
	parentObj.onLoad_callback();
	if(this.disabledFinishOnLoad){
		this.setButtonAvailability(false)
	}else{
		this.setButtonAvailability(true)
	}

	$('[data-pepSubmit]').off('click').on('click',function(){
		$(this).slideUp(function(){ $(this).remove()});
		$('[data-pepDetails]').addClass('is-active')
	})

	$('#emailValidation-step2 [data-resend]').off('click').on('click',function(){
		new formeSubmit( false,"/data/?action=resendValidateMail",{
			submitBt: {
				elem : $(this),
				enableOnSuccess: true
			},
			statusMsg: {
				elem: $('#emailValidation-step2 [data-status-msg3]')
			}
		} );
	})

	if(!this.useSingleStep){
			//REGISTRO EN DOS PASOS

			$('#signup-form-step1').off('formvalid.zf.abide.bam').on('formvalid.zf.abide.bam', function() {
				/*
		var =$(this);
				var submitBt=$().find('[data-submit]');
				holdBt($(submitBt),"...espere",{"showClockIcon":false});
				var statusMsg=$().find('[data-status-msg]');
				$.ajax({
					type: "POST",
					url: "/data/?action=signup",
					dataType: 'json',
					data: $("#signup-form-step1").serialize(), // serializes the form's elements.
					success: function(data)	{
						if(data.status == "ok") {
							$('#check-email-step1').text($('[name=signup_email]').val());
							$('#signup-form-step1').find('.registrationPanel').fadeOut(function(){
								$(this).removeClass('is-active');
								$('#registerStep2').fadeIn(function(){ $(this).addClass('is-active')});
							})
							$('#signup-form-step1').data('success',true);
							parentObj.onStep1Success_callback();
						}
						else {
							if($(statusMsg).html()!=""){
								$(statusMsg).fadeOut(function(){ $(this).fadeIn()});
							}
							$(statusMsg).html("<p>"+data.error+"</p>").removeClass('success').addClass('alert').show();
						}
						unholdBt($(submitBt));
					},
					error: function() {
							if($(statusMsg).html()!=""){
								$(statusMsg).fadeOut(function(){ $(this).fadeIn()});
							}
							$(statusMsg).html("<p>Error desconocido</p>").removeClass('success').addClass('alert').show();
							unholdBt($(submitBt));
					}
				});
		*/
				parentObj.onStep1BeforeSubmit_callback();
				var key = $('#signup-form-step1 [data-recaptcha]').attr('data-key')
				$('#signup-form-step1 [data-submit]').attr('disabled','')

				$.getScript('https://www.google.com/recaptcha/api.js?render='+key).done(function(){
					grecaptcha.ready(function() {
						grecaptcha.execute(key, { action: 'login'}).then(function(token) {
							$('#signup-form-step1 [data-recaptchaResponse]').val(token)
							$('#signup-form-step1 [data-submit]').removeAttr('disabled')
							const formeOptions = {
								submitBt: {
									elem : $('#signup-form-step1 [data-submit]'),
									holdMsg: parentObj.strings.holdOn
								},
								statusMsg: {
									elem: $("#signup-form-step1 [data-status-msg]"),
									error: parentObj.strings.unknownError
								},
								callbackOnSuccess: function(e) {
									$('#signup-form-step1').find('.registrationPanel').fadeOut(function(){
										$(this).removeClass('is-active');
										$('#registerStep2').fadeIn(function(){ $(this).addClass('is-active')});
									})
									parentObj.onStep1Success_callback(e);
								},
								callbackOnFail: function(e){
									parentObj.onStep1Fail_callback(e);
								}
							}
							if(parentObj.additionalParams) formeOptions["extraFields"] = parentObj.additionalParams;
							var step1forme = new formeSubmit( $('#signup-form-step1'),"/data/?action=signup",formeOptions );
						})
		  			})
		  		})
			});



			$('#signup-form-step2').off('formvalid.zf.abide.bam').on('formvalid.zf.abide.bam', function() {
// 				var =$(this);
// 				var submitBt=$().find('[data-submit]');
// 				holdBt($(submitBt),parentObj.strings.holdOn,{"showClockIcon":false});

// 				var statusMsg=$().find('[data-status-msg]');
				var key = $('#signup-form-step2 [data-recaptcha]').attr('data-key')
				$('#signup-form-step2 [data-submit]').attr('disabled','')

				grecaptcha.ready(function() {
					grecaptcha.execute(key, { action: 'login'}).then(function(token) {
						$('#signup-form-step2 [data-recaptchaResponse]').val(token)
						$('#signup-form-step2 [data-submit]').removeAttr('disabled')

						const formeOptions = {
							submitBt: {
								elem : $('#signup-form-step2 [data-submit]'),
								holdMsg: parentObj.strings.holdOn
							},
							statusMsg: {
								elem: $("#signup-form-step2 [data-status-msg]"),
								ok: parentObj.strings.creating,
								error: parentObj.strings.unknownError
							},
							callbackOnSuccess: function(e) {
								parentObj.onStep2Success_callback();
								const redirectTo = e?.[parentObj.serverSideRedirectDataSrc] ?? (parentObj?.redirectToURLOnSuccess ? parentObj.redirectToURLOnSuccess : null);
								if(!parentObj.ignoreRedirectOnSuccess){
									if(redirectTo == null && parentObj.reloadOnSuccess){
										window.location.reload();
									}else{
										window.location.href = redirectTo;
									}
								}
								$('body').attr('data-logged','');

							},
							callbackOnFail: function(e){
								parentObj.onFail_callback();
							}
						}
						if(parentObj.additionalParams) formeOptions["extraFields"] = parentObj.additionalParams;
						var step2forme = new formeSubmit( $('#signup-form-step2'),"/data/?action=signup",formeOptions );
					})
				})



/*
		  		function submitAJAX(){
			  		$.ajax({
						type: "POST",
						url: "/data/?action=signup",
						dataType: 'json',
						data: $("#signup-form-step2").serialize(),
						success: function(data)	{
							if(data.status == "ok") {
								$(statusMsg).html("<p>"+parentObj.strings.creating+"</p>").removeClass('alert').addClass('success').show();
								parentObj.onStep2Success_callback();
								if(parentObj.redirectToPanelOnSuccess){
									window.location.href = data.panel;
								}
								$('body').attr('data-logged','');
								//checkSocialOnIOS(4, data.data.id);
							}
							else {
								if($(statusMsg).html()!=""){
									$(statusMsg).fadeOut(function(){ $(this).fadeIn()});
								}
								$(statusMsg).html("<p>"+data.error+"</p>").removeClass('success').addClass('alert').show();
								parentObj.onFail_callback();
							}
							unholdBt($(submitBt));
						},
						error: function() {
								if($(statusMsg).html()!=""){
									$(statusMsg).fadeOut(function(){ $(this).fadeIn()});
								}
								$(statusMsg).html("<p>"+parentObj.strings.unknownError+"</p>").removeClass('success').addClass('alert').show();
								parentObj.onFail_callback();
								unholdBt($(submitBt));
						}
					});
		  		}
*/

			});

	}else{
		//REGISTRO EN UN SÓLO PASO
		$('#signup-form-step1').off('formvalid.zf.abide.bam').on('formvalid.zf.abide.bam', function() {
			var key = $('#signup-form-step1 [data-recaptcha]').attr('data-key')
			$('#signup-form-step1 [data-submit]').attr('disabled','')

			$.getScript('https://www.google.com/recaptcha/api.js?render='+key).done(function(){
				grecaptcha.ready(function() {
					grecaptcha.execute(key, { action: 'login'}).then(function(token) {
						$('#signup-form-step1 [data-recaptchaResponse]').val(token)
						$('#signup-form-step1 [data-submit]').removeAttr('disabled')
						var step1forme = new formeSubmit( $('#signup-form-step1'),"/data/?action=signup",
						{
							submitBt: {
								elem : $('#signup-form-step1 [data-submit]'),
								holdMsg: parentObj.strings.holdOn
							},
							statusMsg: {
								elem: $("#signup-form-step1 [data-status-msg]"),
								ok: parentObj.strings.creating,
								error: parentObj.strings.unknownError
							},
							callbackOnSuccess: function(e) {
								parentObj.onStep2Success_callback(); //EN EL REGISTRO EN 1 PASO, SE LANZA EL CALLBACK DEL PASO 2 PARA COMPATIBILIDAD
								const redirectTo = e?.panel ?? (parentObj?.redirectToURLOnSuccess ? parentObj.redirectToURLOnSuccess : null);
								if(redirectTo == null && parentObj.reloadOnSuccess){
									window.location.reload();
								}else{
									window.location.href = redirectTo;
								}
								$('body').attr('data-logged','');
							},
							callbackOnFail: function(e){
								parentObj.onFail_callback();
							}
						} );
					})
				})
			})

		});
	}


	$('[data-submitValidate]').off('click').on('click',function(){
		var elToValidate='#'+$(this).attr('data-submitValidate');
		var myForm=$(this).closest('form[data-abide]');

		if(	isValidField($(myForm),$('[data-baseForm] [required]').add('#signup_email')) ){		//Validamos si los campos bases son correctos

			var id=$(elToValidate).attr('id');

			if(id=="signup_email"){
				var formElem=$(this).closest('[data-validationBoxes]');
				var statusMsg=$(formElem).find('[data-status-msg2]');
				var submitBt2=$(this);

				//holdBt($(submitBt2),"...",{"showClockIcon":false});
				//Validamos el abide de email
				$(myForm).foundation('validateInput',$('#signup_email'));
				var errors=false;
				if( typeof $('#signup_email').attr('data-invalid') != "undefined") {
					errors=true;
					unholdBt($(submitBt2));
				}
				if (!errors){

					//console.log(objectifyForm($(myForm).serializeArray()))
					var formValidateEmail = new formeSubmit( false,"/data/?action=signup",
					{
						extraFields:objectifyForm($(this).closest("form").serializeArray()),
						submitBt: {
							elem : $('[data-submitvalidate="signup_email"]'),
							holdMsg: "...",
							enableOnSuccess:true
						},
						statusMsg: {
							elem: $(statusMsg)
						},
						callbackOnSuccess: function(e) {
							$('[data-form-email-helper]').text($('#signup_email').val());
							$('#emailValidation-step1').fadeOut(function(){
								$(this).removeClass('is-active');
								$('#emailValidation-step2').fadeIn(function(){$(this).addClass('is-active')})

							})
							parentObj.onValidateMail_callback()
						},
						callbackOnFail: function(e) {
							$('#signup_email').attr('data-invalid',"");
							checkButtonAvailability();
							parentObj.onFail_callback();
							if(parentObj.loginObj){
								$(statusMsg).find("a").replaceWith("<button data-loginSignUp>"+$(statusMsg).find("a").html()+"</button>")
								$("[data-loginSignUp]").on("click",function(){
									parentObj.loginObj.open()
								})
							}
						}
					} );

/*
					$.ajax({
						type: "POST",
						url: "/data/?action=signup",
						dataType: 'json',
						data: $(this).closest("form").serialize(), // serializes the form's elements.
						success: function(data)	{
							if(data.status == "ok") {
								$('[data-form-email-helper]').text($('#signup_email').val());
								$('#emailValidation-step1').fadeOut(function(){
									$(this).removeClass('is-active');
									$('#emailValidation-step2').fadeIn(function(){$(this).addClass('is-active')})

								})
								unholdBt($(submitBt2));

							} else {
								if($(statusMsg).html()!=""){
									$(statusMsg).fadeOut(function(){ $(this).fadeIn()});
								}
								$(statusMsg).html("<p>"+data.error+"</p>").removeClass('success').addClass('alert').show();
								$('#signup_email').attr('data-invalid',"");
								checkButtonAvailability();
								unholdBt($(submitBt2));
							}
						}
					});
*/
				}
			}

			if(id=="signup_phone"){

				if (isValidField($(myForm),new Array( $('#signup_phoneCountry'),$('#signup_phone') ) )){ //Validamos el abide de código de País y teléfono

					//Todo correcto, procedemos
					var formElem=$(myForm);
					var statusMsg=$(formElem).find('[data-status-msg3]');
					requestValCodePhone = new formeSubmit( false,"/data/?action=validatePhone",
					{
						extraFields: objectifyForm($(formElem).serializeArray()),
						submitBt: {
							elem : $('[data-submitvalidate="signup_phone"]'),
							holdMsg: "...",
							enableOnSuccess:true
						},
						statusMsg: {
							elem: $(statusMsg)
						},
						callbackOnSuccess: function(e) {
							validationRequestSuccess("phone");
							$(formElem).find('#validate_signup_email').attr('required','')
							checkButtonAvailability();
							parentObj.onValidatePhone_callback()
						},
						callbackOnFail: function(e) {
							$('#signup_phone').attr('data-invalid',"");
							parentObj.onFail_callback();
							checkButtonAvailability();
						}
					} );

				}
			}

			if(id=="validate_phoneCode"){
				if (isValidField( $(myForm),$('#validate_phoneCode') )) {
					var codeVal = $('#validate_phoneCode').val();
					var extraFieldsVal= objectifyForm($(formElem).serializeArray());
					extraFieldsVal["validate_phoneCode"]=codeVal;

					checkValCodePhone = new formeSubmit( false,"/data/?action=validatePhoneCode",
					{	extraFields: extraFieldsVal,
						submitBt: {
							elem : $(this),
							holdMsg: "...",
							enableOnSuccess:true
						},
						statusMsg: {
							elem: $('#phoneValidation-step2 [data-status-msg3]')
						},
						callbackOnSuccess: function(e) {
							validationCodeSuccess("phone");
							parentObj.setButtonAvailability(true);
							parentObj.onValidatePhoneCode_callback()
						},
						callbackOnFail: function(e) {
							parentObj.onFail_callback();
						}
					} );

				}
			}

			if(id=="validate_signup_email"){
				if (isValidField( $(myForm),$('#validate_signup_email') )) {
					var codeVal = $('#validate_signup_email').val();
					var extraFieldsVal= objectifyForm($(formElem).serializeArray());
					extraFieldsVal["validate_signup_email"]=codeVal;


					checkValCodeMail = new formeSubmit( false,"/data/?action=validateMailCode",
					{	extraFields: extraFieldsVal,
						submitBt: {
							elem : $(this),
							holdMsg: "...",
							enableOnSuccess:true
						},
						statusMsg: {
							elem: $('#emailValidation-step2 [data-status-msg3]')
						},
						callbackOnSuccess: function(e) {
							//$('#emailValidation-step1').remove();
							validationCodeSuccess("email");
							parentObj.onValidateMailCode_callback()
						},
						callbackOnFail: function(e) {
							parentObj.onFail_callback();
						}
					} );

				}
			}
		}

		function checkButtonAvailability(){
			var submitBt=$('#signup-form-step1').find('[data-submit]');
			if( typeof $('#signup_phoneCountry').attr('data-invalid') == "undefined" && typeof $('#signup_phone').attr('data-invalid') == "undefined"  && typeof $('#signup_email').attr('data-invalid') == "undefined"){
				$(this).find('#validate_signup_phone').attr('required','')
				$(submitBt).removeAttr('disabled');
				$('#registerStep1 > [data-abide-error][data-status-msg').hide()

			}else{
				$(this).find('#validate_signup_phone').removeAttr('required','')
				$(submitBt).attr('disabled','disabled');
			}
		}


	})



	$('[data-validationBoxesBack]').off('click').on('click',function(){
		var validationStep1Elem=$('#'+$(this).attr('data-validationBoxesBack'))
		var validationStep2Elem=$(this).closest('[data-validationBoxes]')
		var validationStep1MsgElem=$(validationStep1Elem).find('[data-status-msg2]')
		validationRollback($(validationStep1Elem),$(validationStep2Elem),$(validationStep1MsgElem),true);
		var submitBt=$('#signup-form-step1').find('[data-submit]');
		$(submitBt).attr('disabled','disabled');
		$('#registerStep1 > [data-abide-error][data-status-msg').hide()
	})
	$('[data-stepBack]').on('click',function(){
		$('#registerStep2').fadeOut(function(){
			$(this).removeClass('is-active');
			$('#registerStep1').fadeIn()
		})
	})
}

signUpObject.prototype.open = function(callbackOnOpen = function(){}){
	let self = this;
	const currentFailCB = self.onStep1Fail_callback;
	const currentBeforeSubmitCB = self.onStep1BeforeSubmit_callback;
	const fnCb = () => {
		self.init();
		customLabelEvents();
		this.onStep1Fail_callback = function(){
			currentFailCB();
			$(self.defaultModalElem).find('#signup-form-step1 [data-cancel]').removeAttr('disabled')
		}
		this.onStep1BeforeSubmit_callback = function(){
			currentBeforeSubmitCB();
			$(self.defaultModalElem).find('#signup-form-step1 [data-cancel]').attr('disabled','disabled')
		}
		$(self.defaultModalElem).find('#signup-form-step1 [data-cancel]').off('click').on('click',function(){
			self.close();
		})
		callbackOnOpen(self);
	}

	$(self.defaultModalElem).attr('data-reveal-source',self.defaultModalSrc)
 	$(self.defaultModalElem).attr('data-reveal-params','{"noTitle":"true","noClose":"true"}')
 	$(self.defaultModalElem).data('callback',fnCb);
	//self.beforeOpen_callback();
	$(self.defaultModalElem).core_reveal("open");
	//this.isModal=true;
}
signUpObject.prototype.close = function (options){
	let self = this;
	if(confirm(self.strings.confirm)){
		$(self.defaultModalElem).core_reveal("close");
	}
	//parentObj.afterClose_callback();
}
signUpObject.prototype.setUrlRedirection = function (URL){
	this.redirectToURLOnSuccess = URL;
}
signUpObject.prototype.setReloadOnSuccess = function (value){
	this.reloadOnSuccess = value;
}
signUpObject.prototype.setButtonAvailability = function(mode){
	var submitBt=$('#signup-form-step1').find('[data-submit]');
	if(mode){
		$(submitBt).removeAttr('disabled');
	}else{
		$(submitBt).attr('disabled','disabled');
	}
}
signUpObject.prototype.clone = function(){
	return new signUpObject(this.options);
}
signUpObject.prototype.setExtraFields = function (extraFieldsDictionary,cleanPrevValues = false){
	if(this.additionalParams == null){
		this.additionalParams = extraFieldsDictionary;
	}else{
		if(cleanPrevValues){
			this.additionalParams = {};
			this.additionalParams = extraFieldsDictionary;
		}else{
			Object.assign(this.additionalParams,extraFieldsDictionary);
		}
	}
}


var loginProObject = function(options,signUpObj = null){
	///*************************************************************************//
	/// ATENCION: OBJETO INCOMPATIBLE CON LANZAMIENTO MODAL POR DATA-OPEN		//
	/// Instanciar y llamar siempre a milogin.open() si queremos abrir un modal //
	///*************************************************************************//

	this.loginFormElem="#loginForm";

	//CALLBACKS
	this.onSuccess_callback=function(){};
	this.onFail_callback=function(){};
	this.beforeOpen_callback=function(){};
	this.afterOpen_callback=function(){};
	this.afterClose_callback=function(){};
	this.delayCallbackOnSuccess=2000;
	this.delayCallbackOnFail=2000;

	//RECOVER SYSTEM
	this.recoveryLinkElem="[data-recoverLink]";
	this.recoveryLinkURL="/recuperar/";

	//SIGNUP SYSTEM
	this.signupLink=true;
	this.signupLinkElem="[data-signUpLink]";
	this.signupLinkURL= false; //false, usa valor por defecto del TPL
	this.onSignupClick_callback = function(){}
	this.signUpObj = signUpObj;

	//MODAL SYSTEM
	this.defaultModalElem="#loginModal";
	this.defaultModalSrc="login";
	this.defaultModalRecoverElem="#recoverModal";
	this.defaultRecoverySrc="recoverModal";
	this.isModalOpened = true;
	this.closeModalOnSuccess=true;	//Si se lanza en modal, lo cerrará en success

	//REDIRECTIONS
	//Por defecto, si hay redirección de servidor, se ejecuta. Si no, se lanzan las redirecciones manuales con redirectOnSuccessURL, y si no y si reloadOnSuccess=true, se recarga la url actual
	this.redirectOnSuccessURL = 		options?.redirectOnSuccessURL ?? false;
	//this.autoRedirectOnSuccess = 		options?.autoRedirectOnSuccess ?? false; //Redirige automáticamente en success, al valor autoRedirectOnSuccessDataSrc devuelto por el ajax
	this.serverSideRedirectDataSrc = 	options?.serverSideRedirectDataSrc ?? "panel";	//Dato de ajax que contendrá la URL para la redirección automática
	this.reloadOnSuccess = 				options?.reloadOnSuccess ?? true;
	this.ignoreRedirectOnSuccess = 		options?.ignoreRedirectOnSuccess ?? false;

	//AJAX CALLS
	this.actionURL="/data/?action=login";

	//FORME OBJPARAMS
	this.ajaxObjParams=false;
	this.additionalParams = options?.extraFields ?? null;

	//PRIVATE
	this.isModal=false;
	this.loginUserData=false	//Retorno de los datos del login

	//RECAPTCHA
	this.recaptchaKey = false;	//Si no es false, entonces se usa recaptcha
	this.recaptchaValue = false;//Valor que devuelve recaptcha y que se envía con el formulario
	this.recaptchaValueDefaultFieldName = "g-recaptcha-response" //Valor del formulario con el que se enviará al servidor

	//Se obtiene con getUserData()
	this.options = options ? options : undefined;

	if(typeof options != "undefined"){
		if( typeof options.loginFormElem != "undefined" )		{ this.loginFormElem = options.loginFormElem }
		if( typeof options.onSuccess_callback != "undefined" )	{ this.onSuccess_callback = options.onSuccess_callback }
		if( typeof options.onFail_callback != "undefined" )		{ this.onFail_callback = options.onFail_callback }
		if( typeof options.beforeOpen_callback != "undefined" )	{ this.beforeOpen_callback = options.beforeOpen_callback }
		if( typeof options.afterOpen_callback != "undefined" )	{ this.afterOpen_callback = options.afterOpen_callback }
		if( typeof options.afterClose_callback != "undefined" )	{ this.afterClose_callback = options.afterClose_callback }
		if( typeof options.delayCallbackOnSuccess != "undefined" )	{ this.delayCallbackOnSuccess = options.delayCallbackOnSuccess }
		if( typeof options.delayCallbackOnFail != "undefined" )	{ this.delayCallbackOnFail = options.delayCallbackOnFail }

		if( typeof options.recoveryLinkElem != "undefined" )	{ this.recoveryLinkElem = options.recoveryLinkElem }
		if( typeof options.recoveryLinkURL != "undefined" )		{ this.recoveryLinkURL = options.recoveryLinkURL }
		if( typeof options.signupLink != "undefined" )			{ this.signupLink = options.signupLink }
		if( typeof options.signupLinkElem != "undefined" )		{ this.signupLinkElem = options.signupLinkElem }
		if( typeof options.signupLinkURL != "undefined" )		{ this.signupLinkURL = options.signupLinkURL }
		if( typeof options.onSignupClick_callback != "undefined" )	{ this.onSignupClick_callback = options.onSignupClick_callback }

		if( typeof options.defaultModalElem != "undefined" ){ this.defaultModalElem = options.defaultModalElem }
		if( typeof options.defaultModalSrc != "undefined" ){ this.defaultModalSrc = options.defaultModalSrc }
		if( typeof options.defaultModalRecoverElem != "undefined" ){ this.defaultModalRecoverElem = options.defaultModalRecoverElem }
		if( typeof options.defaultRecoverySrc != "undefined" ){ this.defaultRecoverySrc = options.defaultRecoverySrc }
		if( typeof options.closeModalOnSuccess != "undefined" ){ this.closeModalOnSuccess = options.closeModalOnSuccess }

		if( typeof options.actionURL != "undefined" ){ this.actionURL = options.actionURL }
		if( typeof options.ajaxObjParams != "undefined" ){ this.ajaxObjParams = options.ajaxObjParams }
		if( typeof options.enableFBlogin != "undefined" ){ this.enableFBlogin = options.enableFBlogin }
		if( typeof options.FBLoginIOS != "undefined" ){ this.FBLoginIOS = options.FBLoginIOS }
		if( typeof options.iOSfBLoginToken != "undefined" ){ this.iOSfBLoginToken = options.iOSfBLoginToken }

		if( typeof options.recaptchaKey != "undefined" ){
			var self = this
			this.recaptchaKey = options.recaptchaKey


		}
		if( typeof options.recaptchaValue != "undefined" ){ this.recaptchaValue = options.recaptchaValue }
		if( typeof options.recaptchaValueDefaultFieldName != "undefined" ){ this.recaptchaValueDefaultFieldName = options.recaptchaValueDefaultFieldName }

	}
	this.loginProccessInProgress = false;			//Evitamos dobles peticiones de login, dando un tiempo entre acción y acción
	this.loginProccessInProgressInterval = false;
	var parentObj=this;


	//Eventos para el control del submit
		$(this.loginFormElem).off("submit").on("submit",function(e){
		e.preventDefault();
		if(!parentObj.loginProccessInProgress){
			parentObj.loginProccessInProgress = true;
			parentObj.send(parentObj.ajaxObjParams);
			clearInterval(parentObj.loginProccessInProgressInterval);
			parentObj.loginProccessInProgressInterval = setTimeout(function(){
				parentObj.loginProccessInProgress = false;
			}, 1000);
		}
		return false;
	})


	this.attachRecovery();
	if (this.enableFBlogin){
		if($('[data-btFBLogin]').length>0){
			$('[data-btFBLogin]').off('click').on('click',function(){
				parentObj.fBLogin(FB);
			})
		}
	}

	//Attach del objeto en el LoginForm
	if($(this.loginFormElem).length>0){
		$(this.loginFormElem).data('loginObj',this);
	}

}
loginProObject.prototype.isModal = function(){
	return this.isModalOpened;
}
loginProObject.prototype.clone = function(){
	return new loginProObject(this.options,this.signUpObj);
}
loginProObject.prototype.manageRecaptcha = function(callbackOnSuccess){
	//***************************************************************************************
	//DESACTIVAMOS EL ENVIO SI HAY RECAPTCHA Y AÚN NO SE HA CARGADO, ACTIVAMOS CUANDO LO HAGA
	//***************************************************************************************
	var btElem = false
	var cb = function(){}
	var self = this;
	if(typeof callbackOnSuccess != "undefined"){
		cb = callbackOnSuccess
	}
	if(self.ajaxObjParams){
		if(typeof self.ajaxObjParams.submitBt != "undefined" && typeof self.ajaxObjParams.submitBt.elem != "undefined"){
			btElem = self.ajaxObjParams.submitBt.elem
		}else if(self.loginFormElem){
			if($(self.loginFormElem).find("[data-submit]").length > 0 ){
				btElem = $(self.loginFormElem).find("[data-submit]")
			}
		}
	}else{
		if(self.loginFormElem){
			if($(self.loginFormElem).find("[data-submit]").length > 0 ){
				btElem = $(self.loginFormElem).find("[data-submit]")
			}
		}
	}
	$(btElem).attr('disabled','disabled')
	bamQueue.loadScript('https://www.google.com/recaptcha/api.js?render='+this.recaptchaKey,function(){
		grecaptcha.ready(function() {
/* 			if(btElem){
				$(btElem).removeAttr('disabled')
			}  */
			cb();
			//() => cb();
		})
	})
	//***************************************************************************************
}
loginProObject.prototype.open = function (options){
	parentObj=this;
	this.isModalOpened = true;
	//Pasamos este objeto al modal para poder ejecutar los eventos y tenerlo accesible dsde el callback
	var callbackEvents=function (){
		var loginObj=parentObj;
		var loginFormElem=loginObj.loginFormElem;
		loginFormElem=$(parentObj.loginFormElem);
		$(loginFormElem).data('loginObj',parentObj)

		//Eventos para el control del submit
		$(loginFormElem).off("submit").on("submit",function(){
			loginObj.send(parentObj.ajaxObjParams);
			return false;
		})

		//Eventos para el control del botón de recuperar contraseña
		loginObj.attachRecovery();
		if(!loginObj.signUpObj){
			if(loginObj.signupLink){
				if(loginObj.signupLinkURL){
					$(loginObj).find(loginObj.signupLinkElem).attr('href',loginObj.signupLinkURL);
				}
				$(loginObj).find(parentObj.signupLinkElem).on('click',function(){
					loginObj.onSignupClick_callback();
				})
			}
		}else{
			$(parentObj.defaultModalElem).find(parentObj.signupLinkElem).replaceWith(function(){
				return this.outerHTML.replace("<a", "<button type='button' ").replace("</a", "</button");
			})
			$(parentObj.defaultModalElem).find(parentObj.signupLinkElem).off('click').on('click',function(){

				let success_step1_cb = parentObj.signUpObj.onStep1Success_callback;
				let success_step2_cb = parentObj.signUpObj.onStep2Success_callback;
				let fail_step1_cb = parentObj.signUpObj.onStep1Fail_callback;
				let fail_step2_cb = parentObj.signUpObj.onStep2Fail_callback;

				var successCallbackFn = parentObj?.onSuccess_callback ?? function(){};
				var failCallbackFn = parentObj?.onFail_callback ?? function(){};


				let new_ss_cb = function(){}
				let new_fs_cb = function(){}


				if(parentObj.signUpObj.useSingleStep){
					new_ss_cb = function(){
						success_step1_cb();
						successCallbackFn();
					}
					new_fs_cb = function(){
						fail_step1_cb();
						failCallbackFn();
					}
					parentObj.signUpObj.onStep1Success_callback = new_ss_cb;
					parentObj.signUpObj.onStep1Fail_callback = new_fs_cb;
				}else{
					new_ss_cb = function(){
						success_step2_cb();
						successCallbackFn();
					}
					new_fs_cb = function(){
						fail_step2_cb();
						failCallbackFn();
					}
					parentObj.signUpObj.onStep1Success_callback = new_ss_cb;
					parentObj.signUpObj.onStep1Fail_callback = new_fs_cb;
				}

				parentObj.signUpObj.reloadOnSuccess = 			parentObj.reloadOnSuccess;
				parentObj.signUpObj.serverSideRedirectDataSrc = parentObj.serverSideRedirectDataSrc ?? "panel";
				parentObj.signUpObj.redirectToURLOnSuccess= 	parentObj.redirectToURLOnSuccess ?? null;
				parentObj.signUpObj.ignoreRedirectOnSuccess = 	parentObj.ignoreRedirectOnSuccess ?? false;

				parentObj.signUpObj.additionalParams = parentObj.extraFields ?? null;

				parentObj.signUpObj.open();
			}).removeAttr('href')
		}

		//***************************************************************************************
		$(loginObj.defaultModalElem).off('closed.zf.reveal').on('closed.zf.reveal',function(loginObj){
			parentObj.afterClose_callback(loginObj);
		})
	}

	//Los eventos se mandan al modal por el $(...).data("callback")
	//para que pueda almacenarse toda la lógica
	$(parentObj.defaultModalElem).attr('data-reveal-source',parentObj.defaultModalSrc)
 	$(parentObj.defaultModalElem).attr('data-reveal-params',"{\"showSignUp\":"+parentObj.signupLink+"}")
 	$(parentObj.defaultModalElem).data('callback',callbackEvents);
	parentObj.beforeOpen_callback();
	$(parentObj.defaultModalElem).core_reveal("open");
	this.isModal=true;
}
loginProObject.prototype.close = function (options){
	var parentObj=this;
	if(this.isModal){
		$(parentObj.defaultModalElem).core_reveal("close");
		parentObj.afterClose_callback();
	}
}
loginProObject.prototype.send = function (ajaxObjOptions){

	var parentObj =this;
	var ajaxObjOpt = ajaxObjOptions ?? false;
	var ajaxCallbackFn = ajaxObjOptions?.callbackOnSuccess ?? function(){};
	var ajaxCallbackFailFn = ajaxObjOptions?.callbackOnFail ?? function(){};

	var successCallbackFn = parentObj?.onSuccess_callback ?? function(){};
	var failCallbackFn = parentObj?.onFail_callback ?? function(){};

	function defaultSuccessCallbackFn(ajaxData = null,formeObj = null){
		setTimeout(function(){
			ajaxCallbackFn(ajaxData,formeObj);
			successCallbackFn(ajaxData,formeObj);
			$('body').attr('data-logged','');
			if (parentObj.closeModalOnSuccess) parentObj.close();
			if (ajaxData.data != "undefined") parentObj.loginUserData=ajaxData.data;
			const redirectTo = ajaxData?.[parentObj.serverSideRedirectDataSrc] ?? (parentObj?.redirectOnSuccessURL ? parentObj.redirectOnSuccessURL : null);
			if(!parentObj.ignoreRedirectOnSuccess){
				(redirectTo == null && parentObj.reloadOnSuccess) ?	window.location.reload() : window.location.href = redirectTo;
			}
		}, parentObj.delayCallbackOnSuccess)
	}

	function defaultFailCallbackFn(ajaxData = null,formeObj = null){
		setTimeout(function(){
			ajaxCallbackFailFn(ajaxData,formeObj);
			failCallbackFn(ajaxData,formeObj);
		}, parentObj.delayCallbackOnFail)
	}


	const paramRedirectURL =	parentObj.redirectOnSuccessURL;
	const paramSucessCallback =	function(e,j){ defaultSuccessCallbackFn(e,j)};
	const paramFailCallback =	function(e,j){ defaultFailCallbackFn(e,j)};

	if(ajaxObjOptions){
		ajaxObjOpt=ajaxObjOptions;
		ajaxObjOpt.callbackOnSuccess=paramSucessCallback;
		ajaxObjOpt.callbackOnFail=paramFailCallback;
		if(parentObj.additionalParams){
			if(ajaxObjOpt?.extraFields){
				ajaxObjOpt.extraFields = Object.assign(ajaxObjOpt.extraFields,parentObj.additionalParams);
			}else{
				ajaxObjOpt["extraFields"] = parentObj.additionalParams;
			}
		}
	}else{
		ajaxObjOpt={
			callbackOnSuccess:paramSucessCallback,
			callbackOnFail:paramFailCallback
		}
		if(parentObj.additionalParams) ajaxObjOpt["extraFields"] = parentObj.additionalParams;

	}

	if(parentObj.recaptchaKey){
		function runRecaptchaScript(){
			grecaptcha.execute(parentObj.recaptchaKey, { action: 'login'}).then(function(token) {
				parentObj.recaptchaValue = token
				if(typeof ajaxObjOpt.extraFields == "undefined"){
					ajaxObjOpt["extraFields"] = {}
				}
				ajaxObjOpt.extraFields[parentObj.recaptchaValueDefaultFieldName] = parentObj.recaptchaValue
				myForm = new formeSubmit($(parentObj.loginFormElem),parentObj.actionURL,ajaxObjOpt);
			})
		}
		if(typeof grecaptcha == "undefined"){
			if(typeof ajaxObjOpt["statusMsg"] != "undefined" && typeof ajaxObjOpt["statusMsg"]["hold"] != "undefined"){
				$(parentObj.loginFormElem).find('[data-status-msg]').html(ajaxObjOpt["statusMsg"]["hold"]).removeClass('alert success').show();
			}
			parentObj.manageRecaptcha(runRecaptchaScript);
		}else{
			runRecaptchaScript();
		}
	}else{
		myForm = new formeSubmit($(parentObj.loginFormElem),parentObj.actionURL,ajaxObjOpt);
	}
}
loginProObject.prototype.setExtraFields = function (extraFieldsDictionary,cleanPrevValues = false){
	if(this.additionalParams == null){
		this.additionalParams = extraFieldsDictionary;
	}else{
		if(cleanPrevValues){
			this.additionalParams = {};
			this.additionalParams = extraFieldsDictionary;
		}else{
			Object.assign(this.additionalParams,extraFieldsDictionary);
		}
	}
}
loginProObject.prototype.attachRecovery=function(options){

	var parentObj=this;

	$(parentObj.defaultModalRecoverElem).attr('data-reveal-source',parentObj.defaultRecoverySrc)

	//Bloqueamos acciónes del botón de recuperar contraseña para establecerlo nosotros
	$(parentObj.recoveryLinkElem).on("click",function(e){
		e.preventDefault();
	})

	//Cambiamos las propiedades y reestablecemos funcionalidad
	if(parentObj.isModal){ //Si estamos en un modal
		$(parentObj.recoveryLinkElem).on("click",function(){
			$(parentObj.defaultModalRecoverElem).core_reveal("open");
			parentObj.close();
		})
	}else{ //Si es una pantalla normal
		$(parentObj.recoveryLinkElem).on("click",function(){
			window.location.href = parentObj.recoveryLinkURL;
		})
	}
}

loginProObject.prototype.getLoginUserData=function(){
	return this.loginUserData;
}

function launchFBLoginIosFromAPP(loginFormElemSelector,token){
	var loginInstance=$(loginFormElemSelector).data('loginObj');
	loginInstance.fBLoginIOS(token);
}
function IOS_sendLoginAppMsg(loginStatus){ //Envía un mensaje a la app, indicando que se está logeado
	var message;
	if(loginStatus){
		message=loginStatus;
	}else{
		message="ko"
	}
	try {
		webkit.messageHandlers.loginListener.postMessage(message);
	} catch(err) {
		console.log('The native context does not exist yet');
	}
}
function IOS_sendMenuContent(menuContentJSON,avatarURL){ //Envía un mensaje a la app, indicando que se está logeado
	message=menuContentJSON;
	try {
		webkit.messageHandlers.menuContent.postMessage(message);
		if(typeof avatarURL != "undefined" && avatarURL!=null && avatarURL!=""){
			webkit.messageHandlers.avatar.postMessage(avatarURL);
		}


	} catch(err) {
		console.log('The native context does not exist yet');
	}
}

function IOS_sendCartContent(cartContent,cartURL){
	try {
		webkit.messageHandlers.cartContent.postMessage(cartContent);
		if(typeof cartURL != "undefined" && cartURL!=null){
			webkit.messageHandlers.cartURL.postMessage(cartURL);
		}
	} catch(err) {
		console.log('The native context does not exist yet');
	}

}

function IOS_sendAboutToLoginAppMsg(){ //Envía un mensaje a la app, indicando que se está logeado
	try {
		webkit.messageHandlers.loginInProgressListener.postMessage("true");
	} catch(err) {
		console.log('The native context does not exist yet');
	}
}
function IOS_sendAppDomain(domainName){
	try {
		webkit.messageHandlers.appDomain.postMessage(domainName);
	} catch(err) {
		console.log('The native context does not exist yet');
	}
}
function IOS_sendGlobals(globalsJSON){
	try {
		webkit.messageHandlers.globals.postMessage(globalsJSON);
	} catch(err) {
		console.log('The native context does not exist yet');
	}
}
function IOS_toggleNotifications(){
	if(typeof core_reveal != "undefined"){
		$('[data-open="myNotifications"]').core_reveal('open')
	}

}

function IOS_toggleAlerts(){
	if(typeof Foundation != "undefined"){
		$('#notifications').toggleClass('is-active');
		openNotificationsBox();
	}
}
function IOS_checkBiometricCapabilities(){
	try {
		webkit.messageHandlers.checkBiometricCapabilities.postMessage(true);
	} catch(err) {
		console.log('The native context does not exist yet',err);
	}
}
function IOS_checkBiometricCapabilitiesCallback(value){
	if(value === true){
		$('body').attr('data-canUseBiometrics',true);
	}else{
		$('body').attr('data-canUseBiometrics',false);
	}
}
function areBiometricsUsable(){
	if(typeof $('body').attr('data-canUseBiometrics') != "undefined" && $('body').attr('data-canUseBiometrics') == "true"){
		return true
	}else{
		return false
	}
}

function APP_fetchContacts(deviceType,callbackOnSuccess,callbackOnError){
	switch(deviceType){
		case "iOS":
			try {
				webkit.messageHandlers.retrieveContactsJSON.postMessage(true);
			} catch(err) {
				console.log('The native context does not exist yet',err);
			}
		break;
		case "android":
		break;
	}
	bamQueue.waitForExistance("APP_contactsObj",function(){
		if(APP_contactsObj.status){
			if(typeof callbackOnSuccess != "undefined"){
				callbackOnSuccess(APP_contactsObj);
			}
		}else if(!APP_contactsObj.status & APP_contactsObj.error != null){
			if(typeof callbackOnError != "undefined"){
				callbackOnError(APP_contactsObj);
			}
		}
	},1000,10)
}

function APP_retrieveContactsCallback(contactsAsJSON,error){
	if(typeof error != "undefined"){
		APP_contactsObj = {
			status: false,
			contacts: null,
			error: error
		}
	}else{
		APP_contactsObj = {
			status: true,
			contacts: contactsAsJSON,
			error: null
		}
		//alert(JSON.stringify(contactsAsJSON));
		return contactsAsJSON;
	}
	return false;
}


/***************************************************************************/
/* FUNCIONES PARA VALIDACIÓN DE TELEFONO/MAIL (PARA SIGNUP E INDEPENDIENTES*/
/***************************************************************************/

function validationRollback(step1ContainerElem,step2ContainerElem,step1MsgElem,clearState){ //Función que regresa al estado de solicitud de código de validación
	//step1ContainerElem = elem contenedor que pide los datos de validacion
	//step2ContainerElem = elem contenedor que pide el codigo devuelto
	//isStandAlone==true cuando se utiliza el módulo de forma independiente del signup
	//				false (si viene sde un formulario signup completo, deshabilita el botón global de submit al volver a solicitar el codigo)

	var elRollBackTo=step1ContainerElem;
	var currentBox=step2ContainerElem;
	var statusMsg=step1MsgElem;
	//Limpiamos caja del código y mensajes de estado
	if(clearState){
		$(currentBox).find('input[type="text"]').val('');
	}
	$(statusMsg).hide();
	//Volvemos atrás
	$(currentBox).fadeOut(function(){
		$(this).removeClass('is-active');
		$(elRollBackTo).fadeIn(function(){
			$(this).addClass('is-active');
		})
	})
}
function validationRequestSuccess(type){ //Funciones de interfaz para solicitud de código para mail/telefono
	switch (type){
		case "phone":
			$('[data-form-phone-helper]').text("+"+$('#signup_phoneCountry').val()+" "+$('#signup_phone').val());
			$('#validate_phoneCode').attr('required','');

			$('#phoneValidation-step1').fadeOut(function(){
				$(this).removeClass('is-active');
				$('#phoneValidation-step2').fadeIn(function(){
					$(this).addClass('is-active');
				})
			})
		break;
		case "email":
			$('[data-form-email-helper]').text($('#signup_email').val());
			$('#emailValidation-step1').fadeOut(function(){
				$(this).removeClass('is-active');
				$('#emailValidation-step2').fadeIn(function(){$(this).addClass('is-active')})
			})
		break;
		case "loggedUserEmail":
			$('[data-form-email-helper]').text($('#signup_email').val());
			$(this).removeClass('is-active');
			$('[data-validationboxesback="emailValidation-step1"]').remove()
		break;
	}
}
function validationCodeSuccess(type){ //Funciones de interfaz para validación exitosa de mail/telefono
	switch (type){
		case "phone":
			$('#phoneValidation-step1 [data-validationboxesinfo] p').html($('#phoneValidation-step2 [data-status-msg3]').html())
			$('#phoneValidation-step1 input#signup_phone').attr('readonly','readonly');
			$('#phoneValidation-step1 #validatePhoneSMS').add("#phoneValidation-step1 #validatePhoneCall").add("#phoneValidation-step1 #signup_phoneCountry").attr('disabled','disabled');
			$('#phoneValidation-step1 #validatePhoneSMS').parent().addClass('disabled');
			$("#phoneValidation-step1 #validatePhoneCall").parent().addClass('disabled');
			$('#phoneValidation-step1 .input-group-button').remove();
			$('#phoneValidation-step2 [data-validationboxesback]').remove()
			if($("#phoneValidation-step2").closest('[data-reveal]').length == 0){
				validationRollback( $('#phoneValidation-step1'), $('#phoneValidation-step2'),$('#validatePhone [data-status-msg2]'),false)
			}
			$('.form-error').removeClass('is-visible');
			$('#registerStep1 [data-abide-error]').hide();
			//$("#phoneValidation-step2").remove();
		break;
		case "email":
			if($("#emailValidation-step2").closest('[data-reveal]').length == 0){
				validationRollback($("#emailValidation-step1"),$("#emailValidation-step2"),$("#emailValidation-step1").find('[data-status-msg2]'),false);
			}
			$('#emailValidation-step1 [data-validationboxesinfo] p').html($('#emailValidation-step2 [data-status-msg3]').html())
			$('#emailValidation-step1 input#signup_email').attr('readonly','readonly');
			$('#emailValidation-step1 .input-group-button').remove();
			$('#emailValidation-step2 [data-validationboxesback]').remove()
			$('#phoneValidation-step1[data-validationboxes]').removeClass('disabled')
			$('#phoneValidation-step1[data-validationboxes] input').add('#phoneValidation-step1[data-validationboxes] select').add('#phoneValidation-step1[data-validationboxes] button').removeAttr('disabled')
			$('[data-accountsMethods]').fadeOut(function(){$(this).remove()})
			$('.form-error').removeClass('is-visible');
			$('#registerStep1 [data-abide-error]').hide();
		break;

		case "facebook":
			$('.form-error').removeClass('is-visible');
			$('#registerStep1 [data-abide-error]').hide();
			validationCodeSuccess("email");
			$('#emailValidation-step1 [data-validationboxesinfo]').hide();
			$('#signup_email').add('#validate_signup_email').attr('disabled','disabled').removeAttr('required');
		break;

		case "facebookPhone":
			$('.form-error').removeClass('is-visible');
			$('#registerStep1 [data-abide-error]').hide();
			validationCodeSuccess("phone");
			$('#phoneValidation-step1 [data-validationboxesinfo]').hide();
			$('#signup_phone').add('#signup_phoneCountry').add('#validate_phoneCode').attr('disabled','disabled').removeAttr('required');
		break;

	}
}
function launchPhoneValidationScript(options){ //Función que valida el teléfono fuera del form. de registro
	var callbackOnSuccessValidation = null;

	if(typeof options != "undefined"){
		if(typeof options.callbackOnSuccess != "undefined"){
			callbackOnSuccessValidation = options.callbackOnSuccess;
		}

	}

	Foundation.Abide.defaults.patterns['phoneNumber'] = /^[0-9\s\.\-]{9,}$/;
	$('#validatePhone [data-submitValidate="signup_phone"]').off('click').on("click",function(){
		if (isValidField( $('#validatePhone form'),new Array($('#signup_phone'),$('#signup_phoneCountry')))) {
			requestValCodePhone = new formeSubmit( $('#validatePhone [data-signupForm] form'),"/data/?action=validatePhone",
			{
				submitBt: {
					elem : $('[data-submitvalidate="signup_phone"]'),
					holdMsg: "...",
					enableOnSuccess: true
				},
				statusMsg: {
					elem: $('#validatePhone [data-status-msg2]')
				},
				callbackOnSuccess: function(e) {
					validationRequestSuccess('phone');
				}
			} );
		}
	})
	//Click en solicitud de código
	$('#validatePhone [data-validationBoxesBack]').off('click').on('click',function(){
		validationRollback( $('#validatePhone #phoneValidation-step1'), $('#validatePhone [data-validationBoxes]'),$('#validatePhone [data-status-msg2]'),true)
	})
	//Acción de volver a pedir código
	$('#validatePhone [data-submitValidate="validate_phoneCode"]').off('click').on('click',function(){ //Click en validación del código
		if (isValidField( $('#validatePhone form'),$('#validate_phoneCode') )) {
			var statusMsgElem = $('#validatePhone [data-status-msg3]');
			var checkValCodePhone = new formeSubmit( $('#validatePhone [data-signupForm] form'),"/data/?action=validatePhoneCode",
			{
				submitBt: {
					elem : $(this),
					holdMsg: "..."
				},
				statusMsg: {
					elem: statusMsgElem
				},
				callbackOnSuccess: function(e) {
					if(callbackOnSuccessValidation == null){
						validationCodeSuccess("phone");
						$('[data-verifyPhoneStatus]').remove();
					}else{
						callbackOnSuccessValidation(e, statusMsgElem);
					}
				}
			} );
		}
	})
}
function launchEMailValidationScript(options){ //Función que valida el email fuera del form. de registro
	var callbackOnSuccessValidation = null;

	if(typeof options != "undefined"){
		if(typeof options.callbackOnSuccess != "undefined"){
			callbackOnSuccessValidation = options.callbackOnSuccess;
		}

	}
	$('#validateEmail [data-resend]').off('click').on('click',function(){
			new formeSubmit( $('#validateEmail [data-signupForm] form'),"/data/?action=resendValidateMail",
			{
				submitBt: {
					elem : $(this),
					enableOnSuccess: true
				},
				statusMsg: {
					elem: $('#validateEmail [data-status-msg3]')
				}
			} );
	})
	$('#validateEmail [data-validationBoxesBack]').remove();
	$('#validateEmail [data-submitValidate="validate_signup_email"]').off('click').on('click',function(){ //Click en validación del código

		if (isValidField( $('#validateEmail form'),$('#validate_signup_email') )) {
			var statusMsgElem = $('#validateEmail [data-status-msg3]');
			var checkValCodeMail = new formeSubmit( $('#validateEmail [data-signupForm] form'),"/data/?action=validateMailCode",
			{
				submitBt: {
					elem : $(this),
					holdMsg: "..."
				},
				statusMsg: {
					elem: statusMsgElem
				},
				callbackOnSuccess: function(e) {
					if(callbackOnSuccessValidation == null){
						validationCodeSuccess("email");
						$('[data-verifyMailStatus]').remove();
					}else{
						callbackOnSuccessValidation(e, statusMsgElem);
					}
				}
			} );
		}
	})
}

function sendValidateEmail(feedbackElem,submitBtElem,options){
	//feedbackElem se mantiene para compatibilidad y se convierte en el statusMsg del forme
	//submitBtElem es el botón que se pasa al forme para que bloquee y desbloquee al hacer el submit

	var validationMethod = "code" //code||link
	var callbackOnSuccess = function(){}
	var callbackOnError = function(e){
		alert(e.error);
		return false;
	}
	var callbackOnFail = function(e,j,k){
		alert(j);
		return false;
	}


	var submitElement = false;
	var strings = {
		sending: "Enviando un email de activación a tu cuenta... Espera por favor"
	}

	if(typeof submitBtElem != "undefined" && submitBtElem != null && submitBtElem){
		submitElement = submitBtElem;
	}

	if(typeof options != "undefined"){
		if(typeof options.callbackOnSuccess != "undefined"){ callbackOnSuccess = options.callbackOnSuccess }
		if(typeof options.callbackOnError != "undefined"){ callbackOnError = options.callbackOnError }
		if(typeof options.callbackOnFail != "undefined"){ callbackOnFail = options.callbackOnFail }

		if(typeof options.strings != "undefined"){
			if(typeof options.strings.sending != "undefined"){ strings.sending = options.strings.sending }
		}
		if(typeof options.validationMethod !="undefined"){
			if(options.validationMethod == "code"){
				validationMethod = "code";
			}else if(options.validationMethod == "link"){
				validationMethod = "link";
			}
		}
	}

	var formeOptions = 	{
		callbackOnSuccess: function(e){
			callbackOnSuccess(e);
		},
		callbackOnFail: function(e){
			callbackOnError(e);
		},
		callbackOnError: function(e,j,k){
			callbackOnFail(e,j,k);
		}
	}

	if(typeof feedbackElem != "undefined" && feedbackElem != null && feedbackElem != false){
		formeOptions["statusMsg"] = {
										elem: $(feedbackElem),
										hold: strings.sending,
										okClasses: "",
										koClasses: ""
									}
	}
	if(typeof submitElement){
			formeOptions["submitBt"] = {
										elem: $(submitElement),
										enableOnSuccess: true,
										showClockIcon: false
									}
	}
	if(validationMethod == "code"){
		var url = "/data/?action=resendValidateMail";
	}
	if(validationMethod == "link"){
		var url = "/data/?action=sendValidateEmail";
	}
	new formeSubmit( false,url, formeOptions);
}

function renderDataFromFB(FBDataObj){
	//{"id":"739277718","name":"xxx","first_name":"xxx","last_name":"xxx","email":"xxx@xxx.xxx","gender":"xxx","telefono":{phone":"xxxxxxxxx","phoneCountry":"xxx"}}
	$('[name=signup_name]').val(FBDataObj.first_name);
	$('[name=signup_lastname]').val(FBDataObj.last_name);
	$('[name=signup_email]').val(FBDataObj.email);
	if(typeof FBDataObj.telefono != "undefined"){
		$('[name=signup_phone]').val(FBDataObj.telefono.phone);
		$('[name=signup_phoneCountry] option').removeAttr('selected');
		$('[name=signup_phoneCountry] option[value='+FBDataObj.telefono.phoneCountry+']').attr('selected','selected');
	}
	validationCodeSuccess("facebook")
}
/***********************************/

function decimoImgShow(decImgUrl,findDraw){ //Función que muestra emergente con décimo de lotería y número
		var decDetail = new core_dropdown();
		var decURL ="";
		$('[data-coreToggle="tenthDetail"]').on('afterShow',function(){
			if(typeof findDraw != "undefined"){
				if(findDraw){
					var sorteoNumber=$(this).closest('tr').attr('data-decimo-sorteo');
					decURL = decImgUrl+"/"+sorteoNumber+".jpg";
				}
			}else{
				decURL = decImgUrl;
			}
			var tenthNumber=$(this).closest('tr').attr('data-decimo-full')
			$('#tenthDetail').find('img').attr('src',decURL);
			$('#tenthDetail').find('[data-number]').html(tenthNumber);
			$('#tenthDetail [data-close]').on('click',function(){
				decDetail.closeall();
			})
		})
	}

/***********************************/
function videoPlay(playlistArray,videoPath,playRandom){
	var videoQueue=0;
	var video = document.getElementById('video');
	var source = document.createElement('source');
	var playRandomFile = true;
	if(typeof playRandom != "undefined"){
		playRandomFile = playRandom;
	}
	if(playRandomFile){
		shuffle(playlistArray);
	}
	source.setAttribute('src',videoPath+playlistArray[videoQueue])
	video.appendChild(source);
	video.play();
	$(video).on('ended',function(){
		videoQueue++;
		if(videoQueue>=playlistArray.length){
			videoQueue=0;
		}
		source.setAttribute('src',videoPath+playlistArray[videoQueue])
		video.load();
		video.play();
	})

	function shuffle(a) {
	    var j, x, i;
	    for (i = a.length - 1; i > 0; i--) {
	        j = Math.floor(Math.random() * (i + 1));
	        x = a[i];
	        a[i] = a[j];
	        a[j] = x;
	    }
	    return a;
	}
}
/***********************************/

bamQueue.addToQueue(function(){
	floatingCartVisibility();
	$(document).on('ajaxComplete',function(){
		floatingCartVisibility();
	})
})

function floatingCartVisibility(){
	bamQueue.waitForExistance("$.appear",() => {
		if($('[data-purchase-options]').length>0){
			$('.focusableFloatingCart').add('[data-purchase-options]').appear();

			$('.focusableFloatingCart').on('appear', function(event, $all_appeared_elements) {
				$('#floatingCart').addClass('is-active');
				$('[data-bonusesperpurchase]').addClass('is-active');
			});
			$('.focusableFloatingCart').on('disappear', function(event, $all_appeared_elements) {
				$('#floatingCart').removeClass('is-active');
				$('[data-bonusesperpurchase]').removeClass('is-active');
			});

			$('[data-purchase-options]').on('appear', function(event, $all_appeared_elements) {
				if($('#usersClubsRedeem').length==0){
					$('#floatingCart').removeClass('is-active');
					$('[data-bonusesperpurchase]').removeClass('is-active');
				}
			});
		}
	});
}


function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}



/************************************************************/
/* GESTIÓN DE DÉCIMOS CON SELECCIÓN DE NÚMERO PERSONALIZADA */
/************************************************************/

var launchDecimosChooserEvents = function(options){

	this.randomizerRouletteSoundURL = "//cdn.inicium.com/sounds/common/roulette.mp3";
	this.randomizerStartSoundURL = "//cdn.inicium.com/sounds/common/start.wav";
	this.purchaseOptionObj = null;
	this.decimoChooser = null;
	this.tramosObj= null;
	this.strings = {
		noAvailability: 	options?.strings?.noAvailability ?? 	"{t}No hay disponibilidad{/t}",
		noAvailabilityDraw: options?.strings?.noAvailabilityDraw ?? "{t}No hay disponibilidad para el sorteo{/t}",
		number: 			options?.strings?.number ?? 			"{t}Número{/t}",
		tenths: 			options?.strings?.tenths ?? 			"{t}Décimos{/t}",
		shares:				options?.strings?.shares ?? 			"{t}Participaciones{/t}",
		addTenth: 			options?.strings?.addTenth ?? 			"{t}Añadir décimo{/t}",
		remTenth: 			options?.strings?.remTenth ?? 			"{t}Descontar décimo{/t}",
		addShare:			options?.strings?.addShare ?? 			"{t}Añadir participación{/t}",
		remShare:			options?.strings?.remShare ?? 			"{t}Descontar participación{/t}"
	}
	this.hasShares = options?.hasShares ? Boolean(options?.hasShares) : false;	//Si va a haber selector de participaciones, hay que pasearle este parámetro a la clase "decimosUserChoosable"
	this.defaultValue = options?.defaultValue ?? 1;																						//Consultar en decimosUserChoosable el protocolo del objeto
	this.sharesValue = 4;

	if (typeof options != "undefined"){
		if (typeof options.purchaseOptionObj != "undefined"){
			this.purchaseOptionObj = options.purchaseOptionObj;
		}
		if (typeof options.tramosObj != "undefined"){
			this.tramosObj = options.tramosObj;
		}
		if (typeof options.randomizerRouletteSoundURL != "undefined"){
			this.randomizerRouletteSoundURL = options.randomizerRouletteSoundURL;
		}
		if (typeof options.randomizerStartSoundURL != "undefined"){
			this.randomizerStartSoundURL = options.randomizerStartSoundURL;
		}
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.noAvailability != "undefined"){
				this.strings.noAvailability = options.strings.noAvailability;
			}
			if(typeof options.strings.noAvailabilityDraw != "undefined"){
				this.strings.noAvailabilityDraw = options.strings.noAvailabilityDraw;
			}
		}
	}
	var self = this
	$('[data-counter-vert-number]:eq(0)').focus();
	$("[data-counter-vert-number]").keypress(function(e) {
	    if ( isNaN(String.fromCharCode(e.which)) || e.keyCode == 13 || e.keyCode == 32) {
		    e.preventDefault();
		}else{
			if($(this).text().length > 0){
				$(this).text("");
			}
		}

	}).on("blur keyup paste input",function(){
		if( isNaN($(this).text()) || $(this).text().length > 1 ){
			$(this).text("?");
		}
	});

	$("[data-counter-vert-number]").keyup(function(e) {
		e.preventDefault();
		if( $(this).text().trim().length < 1 ){
			$(this).text("?");
		}
		var parsedKey = e.keyCode || e.which;//Necesario para parsear teclado numerico
		if (parsedKey >= 96 && parsedKey <= 105) {
        	// Numpad keys
			parsedKey -= 48;
		}
		if(e.keyCode != 9 && e.keyCode != 16 && e.keyCode != 32 && e.keyCode != 38 && e.keyCode != 40 && isNaN(parseInt(String.fromCharCode(parsedKey))) == false ){ 	//ignoramos tabulaciones, enter, espacio y mayusculas para el salto del foco
			var nextNumber = $(this).closest('[data-counter-vert]').next('[data-counter-vert]').find('[data-counter-vert-number]')
			if( $(nextNumber).length != 0){
				$(nextNumber).focus()
			}else{
				var firstNumber = $(this).closest('div').find('[data-counter-vert-number]:eq(0)')
				if( $(firstNumber).length != 0){
					$(firstNumber).focus()
				}
			}
// 			console.log(checkNumbersValidity())
		}
		if(e.keyCode == 38){
			$(this).prev('[data-counter-vert-up]').click()
		}
		if(e.keyCode == 40){
			$(this).next('[data-counter-vert-down]').click()
		}
		self.checkNumbersValidity()

	});
	this.init();

}
launchDecimosChooserEvents.prototype.init = function(){
	var self = this;
	// Buscador de décimos
	$("[data-counter-vert] button").off("click").on("click", function() {

		var val = $(this).closest("[data-counter-vert]").find("[data-counter-vert-number]").html();
		if (typeof $(this).attr("data-counter-vert-up") !== "undefined") {
			if (val == "9") {
				val = 0;
			} else if(val == "?") {
				val = 0;
			} else {
				val = parseInt(val)+1;
			}
		} else if (typeof $(this).attr("data-counter-vert-down") !== "undefined") {
			if (val == "0") {
				val = 9;
			} else if(val == "?") {
				val = 9;
			} else {
				val = parseInt(val)-1;
			}
		}
		$(this).closest("[data-counter-vert]").find("[data-counter-vert-number]").html(val);
		var number = $("[data-counter-vert-number]:eq(0)").html() + $("[data-counter-vert-number]:eq(1)").html() + $("[data-counter-vert-number]:eq(2)").html() + $("[data-counter-vert-number]:eq(3)").html() + $("[data-counter-vert-number]:eq(4)").html();
		self.checkNumbersValidity()
	});



		function setRandomizer(elem,timer,fromNumber,toNumber,playSound,callback){
			if(playSound){
				var snd = new Audio(self.randomizerRouletteSoundURL);
				snd.currentTime = 0;
				snd.play();
			}
			var interval = setInterval(function(){
				var number = Math.floor((Math.random() * (toNumber+1))) + fromNumber;
				$(elem).html(number)

			}, 20)
			setTimeout(function(){
				clearInterval(interval);
				if(playSound){
					snd.currentTime = 0;
					snd.pause();
				}

				if(typeof callback != "undefined" && callback != null){
					callback();
				}
			}, timer)
		}
		const {number,tenths,shares,addTenth,remTenth,addShare,remShare} = self.strings;
		const str = {number,tenths,shares,addTenth,remTenth,addShare,remShare};

		if(this.purchaseOptionObj != null){
			var decimoChooser = new decimosUserChoosable({
				callbackOnCalculatePurchaseOptionsAdd:function(e){
					if(self.tramosObj != null){
						var totalUnits = decimoChooser.totalUnits();
						self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
						self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
					}else{
						self.purchaseOptionObj.updatePrice(decimoChooser.totalUnits())
					}
					if(decimoChooser.totalUnits() > 0){
						self.purchaseOptionObj.setCanBuy(true);
					}else{
						self.purchaseOptionObj.setCanBuy(false);
					}
				},
				callbackOnCalculatePurchaseOptionsRem:function(e){
					if(self.tramosObj != null){
						var totalUnits = decimoChooser.totalUnits();
						self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
						self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
					}else{
						self.purchaseOptionObj.updatePrice(decimoChooser.totalUnits())
					}
					if(decimoChooser.totalUnits() > 0){
						self.purchaseOptionObj.setCanBuy(true);
					}else{
						self.purchaseOptionObj.setCanBuy(false);
					}
				},
				callbackOnCalculatePurchaseOptionsAddShare: function(e){
					decimoChooser.callbackOnCalculatePurchaseOptionsAdd(e)
				},
				callbackOnCalculatePurchaseOptionsRemShare: function(e){
					decimoChooser.callbackOnCalculatePurchaseOptionsRem(e)
				},
				strings: str,
				hasShares: self.hasShares,
				defaultValue: self.defaultValue
			});
			this.decimoChooser = decimoChooser;
		}else{
			var decimoChooser = new decimosUserChoosable({
				strings: str,
				hasShares: self.hasShares,
				defaultValue: self.defaultValue
			});
			this.decimoChooser = decimoChooser;
		}
		self.decimoChooser.refreshList(true);

		$('[data-addtolist]').off('click').on('click',function(j){
			self.resetMsgs();
			$(this).addClass('onHold');
			var numberToAdd = self.checkNumbersValidity();
			if(numberToAdd!==false) {
				var formSubmit = new formeSubmit( false,"/data/?action=numbersDisponibility", {
					extraFields: { "numbers":numberToAdd,"draw":self.purchaseOptionObj.drawSelect},
					statusMsg: {
						elem: $('[data-addtolist]').parent().find("div[data-status-msg]"),	//default: [data-status-msg]
						ko: self.strings.noAvailability
					},
					submitBt: {
						elem: $(this),
						enableOnSuccess: true
					},
					callbackOnSuccess: function(e) {
						$(formSubmit.submitBt.elem).removeClass('onHold');
						var number = Object.keys(e.disponibility)[0];
						var disponibility = e.disponibility[number];
						if(disponibility > 0){
							if(self.decimoChooser.appendToList(numberToAdd,disponibility,self.getdefaultValue()) === false){
								$(j.target).closest('button').parent().find("div[data-status-msg]").html("<p>"+self.strings.noAvailability+"</p>");
								this.statusMsg.elem.css("display","block");
							}
							self.decimoChooser.refreshList();
							$('#boleto [data-lottery-ticket] tr[data-value="'+numberToAdd+'"]').addClass('is-active')
							var totalUnits = decimoChooser.totalUnits();

							if(self.tramosObj != null){
								self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
								self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
							}else{
								self.purchaseOptionObj.updatePrice(totalUnits)
							}
						}else{
							$(formSubmit.getStatusMsgElem()).html("<p>"+self.strings.noAvailability+"</p>");
							this.statusMsg.elem.css("display","block");
						}
						if(totalUnits > 0){
							self.purchaseOptionObj.setCanBuy(true);
						}else{
							self.purchaseOptionObj.setCanBuy(false);
						}
					},
					callbackOnFail: function(e) {
						$(formSubmit.submitBt.elem).removeClass('onHold');
						this.statusMsg.elem.css("display","block").html(self.strings.noAvailability);
					}
				});
			}
		})

		$('[data-randomchooser]').off('click').on('click',function(){
			var sndStop = new Audio(self.randomizerStartSoundURL);

			var remaining = 0;
			blockRandom();
			setRandomizer($('#boleto [data-counter-vert-number]:eq(0)'),1200,0,9,false,function(){remaining++;unblockRandom(remaining)})
			setRandomizer($('#boleto [data-counter-vert-number]:eq(1)'),1400,0,9,false,function(){remaining++;unblockRandom(remaining)})
			setRandomizer($('#boleto [data-counter-vert-number]:eq(2)'),1600,0,9,false,function(){remaining++;unblockRandom(remaining)})
			setRandomizer($('#boleto [data-counter-vert-number]:eq(3)'),1800,0,9,false,function(){remaining++;unblockRandom(remaining)})
			setRandomizer($('#boleto [data-counter-vert-number]:eq(4)'),2000,0,9,true,function(){remaining++;unblockRandom(remaining)})
			function unblockRandom(remaining){
				sndStop.play();

				if(remaining == 5){
					$('#boleto [data-randomchooser]').removeAttr('disabled');
					$('#boleto [data-counter-vert-up]').add('#boleto [data-counter-vert-down]').removeAttr('disabled');
					$('#boleto [data-counter-vert-number]').attr('contenteditable','true')

					self.checkNumbersValidity();
				}
			}
			function blockRandom(){
				$('#boleto [data-addtolist]').add('#boleto [data-randomchooser]').attr('disabled','disabled')
				$('#boleto [data-counter-vert-up]').add('#boleto [data-counter-vert-down]').attr('disabled','disabled')
				$('#boleto [data-counter-vert-number]').removeAttr('contenteditable')
			}
		})

		$(document).off("click.decimo",'[data-lottery-ticket] [data-remove-ticket]').on("click.decimo",'[data-lottery-ticket] [data-remove-ticket]',function(){
			var elemValue = $(this).closest('tr').attr('data-value')
			self.decimoChooser.removeFromList(elemValue,true);
			self.decimoChooser.refreshList();
			var totalUnits = self.decimoChooser.totalUnits();

			if(self.tramosObj != null){
				self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
				self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
			}else{
				self.purchaseOptionObj.updatePrice(totalUnits);
			}
			if(self.decimoChooser.totalUnits() > 0){
				self.purchaseOptionObj.setCanBuy(true);
			}else{
				self.purchaseOptionObj.setCanBuy(false);
			}

		})

		$('[data-curatedNumbers] button').off('click').on('click',function(j){

			self.resetMsgs();
			$(this).addClass('onHold');
			var value = $(this).attr('data-value');
			var formSubmit = new formeSubmit( false,"/data/?action=numbersDisponibility", {
				extraFields: { "numbers":value,"draw":self.purchaseOptionObj.drawSelect},
				submitBt: {
					elem: $(this),
					enableOnSuccess: true
				},
				statusMsg: {
					elem: $(this).parent().find("div[data-status-msg]"),	//default: [data-status-msg]
					ko: self.strings.noAvailability
				},
				callbackOnSuccess: function(e) {
					$(formSubmit.submitBt.elem).removeClass('onHold');
					var number = Object.keys(e.disponibility)[0];
					var disponibility = e.disponibility[number];
					if(disponibility > 0){
						if(self.decimoChooser.appendToList(value,disponibility,self.getdefaultValue()) === false){
							$(j.target).parent().find("div[data-status-msg]").html("<p>"+self.strings.noAvailability+"</p>");
							this.statusMsg.elem.css("display","block");
						}
						self.decimoChooser.refreshList();
						$('#boleto [data-lottery-ticket] tr[data-value="'+value+'"]').addClass('is-active')

						var totalUnits = decimoChooser.totalUnits();

						if(self.tramosObj != null){
							self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
							self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
						}else{
							self.purchaseOptionObj.updatePrice(totalUnits);
						}
					}else{
						$(formSubmit.getStatusMsgElem()).html("<p>"+self.strings.noAvailability+"</p>");
						this.statusMsg.elem.css("display","block");
					}
					if(self.decimoChooser.totalUnits() > 0){
						self.purchaseOptionObj.setCanBuy(true);
					}else{
						self.purchaseOptionObj.setCanBuy(false);
					}
				},
				callbackOnFail: function(e) {
					$(formSubmit.submitBt.elem).removeClass('onHold');
					this.statusMsg.elem.css("display","block").html(self.strings.noAvailability);
				}
			});
		})

}
launchDecimosChooserEvents.prototype.getHasShares = function(){
	return this.hasShares;
}
launchDecimosChooserEvents.prototype.getdefaultValue = function(){
	return this.defaultValue;
}
launchDecimosChooserEvents.prototype.getShareValue = function(){
	return this.shares;
}
launchDecimosChooserEvents.prototype.checkNumbersValidity = function(){
			var number = "";
			$('[data-counter-vert-number]').each(function(){
				if( isNaN($(this).text().trim())){
					number = false;
					return false;
				}else{
					number = number+$(this).text().trim()
				}
			})
			if(number.length > 0 && number){
				$('[data-addtolist]').removeAttr('disabled');
				return number;
			}else{
				$('[data-addtolist]').attr('disabled','disabled');
				return false;
			}
		}
launchDecimosChooserEvents.prototype.getDecimoChooserObj = function(){
	return this.decimoChooser;
}
launchDecimosChooserEvents.prototype.getPurchaseOptionsObj = function(){
	return this.purchaseOptionObj;
}
launchDecimosChooserEvents.prototype.setPurchaseOptionsObj = function(newPurchaseOptionsObj){
	this.purchaseOptionObj = newPurchaseOptionsObj;
}
launchDecimosChooserEvents.prototype.refresh = function(){
	var self = this
	if(this.purchaseOptionObj != null && this.decimoChooser != null && this.tramosObj != null){
		var totalUnits = self.decimoChooser.totalUnits();
		self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
		self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
	}
}
launchDecimosChooserEvents.prototype.reset = function(){
	var self = this
	if(this.decimoChooser != null){
		this.decimoChooser.reset();
	}
	if(this.purchaseOptionObj != null){
		if(self.tramosObj != null){
			self.tramosObj.setUITramo();
			self.tramosObj.updateTramoPrize(0,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
		}else{
			this.purchaseOptionObj.updatePrice(0);
		}
		this.purchaseOptionObj.setCanBuy(false);

	}
}
launchDecimosChooserEvents.prototype.setTramosObj = function(newTramosObj){
	this.tramosObj = newTramosObj;
	this.refresh();
}
launchDecimosChooserEvents.prototype.changeDrawCheck = function(){
	var self = this;
	self.resetMsgs();
	var numbersCheck = new Array();
	$(self.decimoChooser.numbersArray).each(function(e,v){
		numbersCheck.push(v.number);
	});
	var formSubmit = new formeSubmit( false,"/data/?action=numbersDisponibility", {
		extraFields: { "numbers":numbersCheck.join("-"),"draw":self.purchaseOptionObj.drawSelect},
		statusMsg: {
			elem: $('[data-curatedNumbers] button').parent().find("div[data-status-msg]"),	//default: [data-status-msg]
			ko: self.strings.noAvailabilityDraw
		},
		callbackOnSuccess: function(e) {
			var selfForm = this;
			self.decimoChooser.reset();
			$.each(e.disponibility, function(index, value) {
				var numberToAdd = index;
				var disponibility = value;
				if(disponibility > 0){
					if(self.decimoChooser.appendToList(numberToAdd,disponibility,self.getdefaultValue()) === false){
						selfForm.statusMsg.elem.html("<p>"+self.strings.noAvailabilityDraw+"</p>");
						selfForm.statusMsg.elem.css("display","block");
					}
					self.decimoChooser.refreshList();
					$('#boleto [data-lottery-ticket] tr[data-value="'+numberToAdd+'"]').addClass('is-active')
					var totalUnits = self.decimoChooser.totalUnits();
					if(self.tramosObj != null){
						self.tramosObj.setUITramo(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
						self.tramosObj.updateTramoPrize(totalUnits,self.purchaseOptionObj.dias,self.purchaseOptionObj.semanas);
					}else{
						self.purchaseOptionObj.updatePrice(totalUnits)
					}
				} else{
					selfForm.statusMsg.elem.html("<p>"+self.strings.noAvailabilityDraw+"</p>");
					selfForm.statusMsg.elem.css("display","block");
				}
				if(totalUnits > 0){
					self.purchaseOptionObj.setCanBuy(true);
				}else{
					self.purchaseOptionObj.setCanBuy(false);
				}
			});
		},
		callbackOnFail: function(e) {
			this.statusMsg.elem.css("display","block").html(self.strings.noAvailabilityDraw);
		}
	});
}
launchDecimosChooserEvents.prototype.resetMsgs = function(){
	$('[data-curatedNumbers] button').parent().find("div[data-status-msg]").css("display","none").html("");
	$('[data-addtolist]').parent().find("div[data-status-msg]").css("display","none").html("");
}

var decimosUserChoosable = function(options){
	this.tableElem ="[data-lottery-ticket]";
	this.tableHeadElem ="[data-lottery-ticket] thead";
	this.tableBodyElem ="[data-lottery-ticket] tbody";
	this.tableEmptyElem ="[data-ticket-tutorial]";
	this.currentSorteo = 0;
	this.shares = 4; //Número de participaciones por número
	this.numbersArray = new Array(
/*
		{number:49289,units:3},
		{number:01414,units:3},
		{number:15221,units:6},
		{number:69474,units:1}
*/
	);
	this.tenthsController;
	this.sharesController;
	this.callbackOnCalculatePurchaseOptionsAdd = options?.callbackOnCalculatePurchaseOptionsAdd ?? function(){};
	this.callbackOnCalculatePurchaseOptionsRem = options?.callbackOnCalculatePurchaseOptionsRem ?? function(){};
	this.strings = {
		number: 	options?.strings?.number ?? 	"{t}Número{/t}",
		tenths: 	options?.strings?.tenths ?? 	"{t}Décimos{/t}",
		shares:		options?.strings?.shares ?? 	"{t}Participaciones{/t}",
		addTenth: 	options?.strings?.addTenth ?? 	"{t}Añadir décimo{/t}",
		remTenth: 	options?.strings?.remTenth ?? 	"{t}Descontar décimo{/t}",
		addShare:	options?.strings?.addShare ?? 	"{t}Añadir participación{/t}",
		remShare:	options?.strings?.remShare ?? 	"{t}Descontar participación{/t}"
	}
	this.hasShares = options?.hasShares ? Boolean(options?.hasShares) : false;		//this.hasShares true|false	Si tiene participaciones
	this.defaultValue = options?.defaultValue ?? 1;																						//Consultar en decimosUserChoosable el protocolo del objeto
	this.callbackOnCalculatePurchaseOptionsAddShare = options?.callbackOnCalculatePurchaseOptionsAddShare ?? function(){}
	this.callbackOnCalculatePurchaseOptionsRemShare = options?.callbackOnCalculatePurchaseOptionsRemShare ?? function(){}
}

decimosUserChoosable.prototype.refreshList = function(renderHead = false){

	var self = this;
	var html = "";
	if(renderHead){
		const parts = this.getHasShares() ? `<th><span>${this.strings.shares}</span></th>` : ``;
		const thead = `
		<thead>
		<tr>
			<th><span>${this.strings.number}</span></th>
			<th class="spacer"></th>
			${parts}
			<th><span>${this.strings.tenths}</span></th>
			<th></th>
		</tr>
		</thead>`
		if($(this.tableHeadElem).length == 0){
			$(this.tableElem).prepend(thead)
		}else{
			$(this.tableHeadElem).empty()
		}
	}
	this.getHasShares() ? $(this.tableElem).addClass('hasShares') : $(this.tableElem).removeClass('hasShares');

	if($(this.tableBodyElem).length == 0){
		$(this.tableElem).append('<tbody></tbody>');
	}else{
		$(this.tableBodyElem).empty();
	}
	$(this.numbersArray).each(function(){
		let unitsToAdd = this.units;
		let sharesToAdd;
		if(self.getHasShares()){
			//Calculamos en base a las unidades seleccionadas, las que son participaciones y las que son décimos completos
			sharesToAdd = !Number.isInteger(this.units) ? (this.units % 1) * self.getShareValue() : 0;
			unitsToAdd = Math.trunc(this.units);
		}

		const partsCounter = self.getHasShares() ? 	`<td><span data-addrem="share">
												<button data-rem data-button-decimo aria-label="${self.strings.addShare}"></button>
												<span data-counter data-share aria-label="${self.strings.shares}">${sharesToAdd}</span>
												<button data-add data-button-decimo aria-label="${self.strings.remShare}"></button>
												</span></td>` : ``;
		const decimoCounter =	`<td><span data-addrem="tenth">
								<button data-rem data-button-decimo aria-label="${self.strings.addTenth}"></button>
								<span data-counter data-decimo aria-label="${self.strings.number}">${unitsToAdd}</span>
								<button data-add data-button-decimo aria-label="${self.strings.remTenth}"></button>
								</span></td>`;
		var tr = "";
		tr = '<tr data-value="'+this.number+'"><td>'+this.number+'</td><td class="spacer"></td>'+partsCounter+decimoCounter+'<td data-actions><button data-remove-ticket></button></td></tr>';
		html = html + tr;
	})
	if(html.length == 0){
		$(this.tableElem).removeClass('is-active')
		$(this.tableEmptyElem).addClass('is-active')
	}else{
		$(this.tableElem).addClass('is-active')
		$(this.tableEmptyElem).removeClass('is-active')
	}
	$(this.tableBodyElem).html(html);

	var calculatePurchaseOptionsAdd = function(e,val,counterElem){
		var number = $(e).closest('tr').attr('data-value');
		var disponibilidad = self.getDisponibility(number);
		if(self.getHasShares() && disponibilidad == 1 && val == 1){
			//Si acepta participaciones, y los décimos está a 0 y hay alguna participación,
			//forzamos a borrar participaciones y a meter el décimo entero para comodida del usuario
			const elem = self.retrieveNumbers().find( elem => parseInt(elem.number) == parseInt(number) );
			if(elem){
				elem.units = 0
			}
		}
		self.appendToList(number,disponibilidad)
		refreshCounters(number);
		self.callbackOnCalculatePurchaseOptionsAdd(e);
	}
	var calculatePurchaseOptionsRem = function(e,val,counterElem){
		var number = $(e).closest('tr').attr('data-value');
		var disponibilidad = self.getDisponibility(number);
		self.removeFromList(number)
		if(self.getHasShares() && disponibilidad == 1){
			const elem = self.retrieveNumbers().find( elem => parseInt(elem.number) == parseInt(number) );
			if(elem && elem.units == 0){
				elem.units = (disponibilidad / self.getShareValue())
			}
		}
		refreshCounters(number);
		self.callbackOnCalculatePurchaseOptionsRem(e);
	}
	var calculatePurchaseOptionsAddShare = function(e,val,counterElem){
		const number = $(e).closest('tr').attr('data-value');
		const disponibilidad = self.getDisponibility(number);
		const sharesToAdd = 1/self.getShareValue();
		if( disponibilidad == 1 && val == 1){
			//Si disponibilidad y décimos está a 1 y queremos alguna participación
			//forzamos a borrar décimos y a meter participaciones para comodida del usuario
			const elem = self.retrieveNumbers().find( elem => parseInt(elem.number) == parseInt(number) );
			if(elem){
				elem.units = 0
			}
		}

		self.appendToList(number,/* disponibility */disponibilidad,sharesToAdd)
		refreshCounters(number);
		self.callbackOnCalculatePurchaseOptionsAddShare(e);
	}

	var calculatePurchaseOptionsRemShare = function(e,val,counterElem){
		var number = $(e).closest('tr').attr('data-value');
		var disponibilidad = self.getDisponibility(number);
		const sharesToRem = 1/self.getShareValue();
		self.removeFromList(number,false,sharesToRem)
		refreshCounters(number);
		self.callbackOnCalculatePurchaseOptionsRemShare(e);
	}

	var refreshCounters = function(numberToCheck){
		const tenth = $(`tr[data-value="${numberToCheck}"] [data-counter][data-decimo]`);
		const share = $(`tr[data-value="${numberToCheck}"] [data-counter][data-share]`);
		const elem = self.numbersArray.find( item => parseInt(item.number) == parseInt(numberToCheck)) ?? false;
		if(elem){
			const units = elem.units;
			const disponibility = elem.disponibility;
			let shares;
			let tenths;
			if(self.getHasShares()){
				//Calculamos en base a las unidades seleccionadas, las que son participaciones y las que son décimos completos
				shares = !Number.isInteger(units) ? (units % 1) * self.getShareValue() : 0;
				tenths = Math.trunc(units);
				$(share).text(shares);
			}else{
				tenths = units;
				shares = 0;
				$(share).text(0);
			}
			$(tenth).text(tenths);
		}
	}

	var calculateMax = function(object) {
		const number = $(object).closest('tr').attr('data-value');
		const item = this.numbersArray.find( item => parseInt(item.number) == parseInt(number));
		const disponibility = item?.disponibility ?? null;
		const units = item?.units ?? 0
		if(this.getHasShares()){
			if(!Number.isInteger(units)){
				if(disponibility > 0){
					if(disponibility == 1){
						return 1;
					}else{
						return disponibility -1;
					}
				}else{
					return 0
				}
			}else{
				return Math.trunc(disponibility)
			}
			//return !Number.isInteger(units) ? (disponibility > 0 ? disponibility -1 : 0) : Math.trunc(disponibility);
		}else{
			return Math.trunc(disponibility);
		}
	}
	var calculateMaxShares = function(object) {
		const number = $(object).closest('tr').attr('data-value');
		const item = this.numbersArray.find( item => parseInt(item.number) == parseInt(number));
		const disponibility = item?.disponibility ?? null;
		const units = item?.units ?? 0
		const tenths = Math.trunc(units)
		const availableShares = !Number.isInteger(disponibility) ? (disponibility % 1) * self.getShareValue() : self.getShareValue() ;
		if(units >= disponibility){
			if(disponibility == 1 && units == 1){
				return availableShares;
			}else{
				return 0;
			}
		}else{
			if(tenths == disponibility -1){
				return availableShares ;
			}else{
				return this.getShareValue();
			}
		}
		//return units >= disponibility ? 0 : (tenths == disponibility -1 ? availableShares : this.getShareValue())

	}

	this.tenthsController = new CountersEvents({ 'elem':$(this.tableBodyElem).find('[data-addrem="tenth"]'),'max':99,'min':1,'calculatePurchaseOptionsAfterAddCallback':calculatePurchaseOptionsAdd,'calculatePurchaseOptionsAfterRemCallback':calculatePurchaseOptionsRem,'calculateMax':calculateMax.bind(this) });
	if(this.getHasShares()){
		this.sharesController = new CountersEvents({ 'elem':$(this.tableBodyElem).find('[data-addrem="share"]'),'max':3,'min':0,'calculatePurchaseOptionsAfterAddCallback':calculatePurchaseOptionsAddShare,'calculatePurchaseOptionsAfterRemCallback':calculatePurchaseOptionsRemShare,'calculateMax':calculateMaxShares.bind(this) });
	}
}
decimosUserChoosable.prototype.getHasShares = function(){
	return this.hasShares;
}
decimosUserChoosable.prototype.getDisponibility = function(numberToCheck){
	if(numberToCheck && !isNaN(parseInt(numberToCheck))){
		return this.numbersArray.find( item => parseInt(item.number) == parseInt(numberToCheck))?.disponibility ?? false
	}
	return false;
}
decimosUserChoosable.prototype.appendToList = function(numberToAdd,disponibility,unitsToAdd = 1){
	if(numberToAdd && !isNaN(parseInt(numberToAdd))){
		const elem = this.numbersArray.find( item => parseInt(item.number) == parseInt(numberToAdd)) ?? false;
		if(elem){
			elem.disponibility = disponibility;
			if(elem.units + unitsToAdd <= disponibility){
				elem.units = elem.units + unitsToAdd
			 }else{
				return false;
				//elem.units = disponibility;
			 }
		}else{
			this.numbersArray.unshift({
				number:numberToAdd,
				units:unitsToAdd,
				disponibility:disponibility
			})
		}
		return true;
	}
	return false;
}
decimosUserChoosable.prototype.removeFromList = function(numberToRemove,removeAllUnits=false,unitsToAdd = 1){
	var self = this;
	if(removeAllUnits === true){
		const elemIndex = this.numbersArray.findIndex( elem => parseInt(elem.number) == parseInt(numberToRemove) ) ?? false;
		if(elemIndex != -1){
			this.numbersArray.splice(elemIndex,1);
			return true
		}
	}else{
		const elem = this.numbersArray.find( elem => parseInt(elem.number) == parseInt(numberToRemove) ) ?? false;
		const minSharesUnit = 1/self.getShareValue();
		elem.units = (!self.getHasShares() && elem.units > 1) || (self.getHasShares() && elem.units > minSharesUnit) ? elem.units = elem.units - unitsToAdd : elem.units;
		return true;
	}
	return false;
}

decimosUserChoosable.prototype.retrieveNumbers = function(){
	return this.numbersArray;
}
decimosUserChoosable.prototype.totalUnits = function(){
	var units = 0;
	$(this.numbersArray).each(function(){
		units = units + this.units
	})
	return units;
}
decimosUserChoosable.prototype.reset = function(){
	var self = this;
	this.numbersArray = new Array();
	this.refreshList();
}
decimosUserChoosable.prototype.getShareValue = function(){
	return this.shares;
}
/************/
/*	NOTICIA */
/************/


function showMoreComments(obj,ref){
	if(!$(obj).hasClass("disabled")){
		$(obj).addClass("disabled");
		var page = $('[data-comments="'+ref+'"]').data("page")+1;
		$('[data-comments="'+ref+'"]').data("page",page);
		$.post( "/data/", { action: "getComments",source:ref,page: page }, function( data ) {
			if(page*$('[data-comments="'+ref+'"]').data("perpage") > $('[data-comments="'+ref+'"]').data("total")){
				$(obj).remove();
			} else {
				$(obj).removeClass("disabled");
			}
			$('[data-comments="'+ref+'"]').append(data.data);

			attachAllEvents();

		}, "json");
	}
}

/*************/
/* APP       */
/*************/
function defaultShare(){
	try {
		webkit.messageHandlers.defaultSocialShare.postMessage("true");

	} catch(err) {
	   console.log('The native context does not exist yet');
	}
}

function defaultShareRecommendToken(message){
	try {
		webkit.messageHandlers.recommendTokenShare.postMessage(message);
	} catch(err) {
	   console.log('The native context does not exist yet');
	}
}

function checkPushStatus(platform){
	if(platform == "ios"){
		try {
			webkit.messageHandlers.checkPushStatus.postMessage(true);
		} catch(err) {
			console.log('The native context does not exist yet');
		}
	}else if(platform == "android"){
		if(typeof Android.checkPushStatus == "undefined"){
			var androidPushStatus = true
		}else{
			var androidPushStatus=Android.checkPushStatus();
		}
		pushStatus(androidPushStatus)
	}
}
function setAlert(msgCount = null,platform){
	console.log(msgCount,platform)
	if(platform == "ios"){
		try {
			webkit.messageHandlers.setAlert.postMessage(msgCount);
		} catch(err) {
			console.log('The native context does not exist yet');
		}
	}else if(platform == "android"){
	}
}
function pushStatus(isPushEnabled){
	if(isPushEnabled){
		$('[data-pushStatus]').hide();
		$('[data-notification-settings]').show();
		window.pushState=true;
	}else{
		$('[data-pushStatus]').show();
		$('[data-notification-settings]').hide();
		window.pushState=false;
	}
}
function pushSyncStatus(isPushSyncingCapable){ //refresca la pantalla de configuración e muestra errores si el usuario no esta vinculado con el token de notifs
	if(isPushSyncingCapable){
		$('[data-pushSyncStatus]').hide();
	}else{
		$('[data-pushSyncStatus]').show();
	}
}

function confirmLogout(){
	$('#closeSession').core_reveal('open')
}

function loginWithFinger(platform){
	if(platform == "ios"){
		try {
			webkit.messageHandlers.loginWithTouchID.postMessage(true);
		} catch(err) {
			console.log('The native context does not exist yet');
		}
	}else if(platform == "android"){
		Android.loginWithFingerprint();
	}
}

function setPushToken(token,devicetype){
	var formSubmit=new formeSubmit( false,"/data/?action=registerMobileDevice", {
			extraFields: { "deviceId":token,"deviceType":devicetype,"retrieveNotificationsSettings":1},
			callbackOnSuccess: function(e) {
				if(e.status != "error"){
					$('body').attr('data-push_deviceId',e.deviceId)
					if(typeof e.notificaciones != "undefined"){
						pushSyncStatus(true)
						if(e.notificaciones){
							if(typeof refreshConfigPushData != "undefined"){
								refreshConfigPushData(e.notificaciones)
							}
						}
					}else{
						if(typeof refreshConfigPushData != "undefined"){
							pushSyncStatus(false)
						}
					}

				}
			}
		}
	);
}

function checkSessionStatus(interval,modalToShowElem,loginObj){
	var checkSessionFn = function(){
		var secondsInIDLE = 0;
		if(typeof window.inactivityTime == "number"){
			secondsInIDLE = window.inactivityTime;
		}
			new formeSubmit( false,"/data/?action=logged",
		{
			extraFields: {
				secondsInIDLE: secondsInIDLE
			},
			callbackOnFail: function(e) {
				clearInterval(window.mySessionTimeoutTimer)
				$(modalToShowElem).data('callback',function(){
					var loginObject = loginObj
					window.retrySessionFn = function(){
						loginObject.open()
						delete window.retrySessionFn
					}
					$(modalToShowElem).find('[data-core_reveal-close]').remove()
				})
				$(modalToShowElem).core_reveal("open");
			}
		} );
	}
	window.mySessionTimeoutTimer = setInterval(checkSessionFn, interval)
	return window.mySessionTimeoutTimer
}


var launchDocumentsManagerScripts = function(docLoad){
	var self = this;
	this.docLoad = docLoad;
	$('[data-addDoc]').on("click",function(){ docLoad.open() })
	$('[data-featuresBlock] button').on("click",function(){
		var docType = $(this).closest('[data-forDocument]').attr('data-forDocument');
		if(self.docLoad.getTypeFromID(docType)){
			self.docLoad.open(docType);
		}
	})
	$(document).on("click","#myConfig [data-docs-list] [data-remove]",function(){
		var tr = $(this).closest('tr[data-temp-id]')
		if( $(tr).length > 0){ 						//ID Es temporal
			var id= $(tr).attr('data-temp-id')
			self.docLoad.removeTmpDoc(id)
		} else{ 									//ID Es fichero previamente guardado y existente
			var tr = $(this).closest('tr[data-doc-id]')
			var id= $(tr).attr('data-doc-id')
		}
	})
// 	$(document).off('').
	this.updateStates()
}
launchDocumentsManagerScripts.prototype.updateStates = function(){
	var self = this;
	var typesObj = {} //array con tipos y el estado global de cada uno de ellos
	$(self.docLoad.getDocs()).each(function(){
		if(typeof typesObj[this.docType] != "undefined"){
			if(this.status < typesObj[this.docType].status){
				typesObj[this.docType].status = this.status
			}
		}else{
			typesObj[this.docType] = { status: this.status}
		}
	})
	var keys = Object.keys(typesObj)
	$('[data-featuresBlock] li[data-forDocument]').removeClass();
	$(keys).each(function(k,v){
		var elem = $('[data-featuresBlock] li[data-forDocument="'+v+'"]')
		var elemObj = typesObj[v]
		if(elemObj.status == 0){ $(elem).removeClass() }
		if(elemObj.status == 1){ $(elem).removeClass().addClass('is-active') }
		if(elemObj.status == 2){ $(elem).removeClass().addClass('on-hold') }
		if(elemObj.status == 3){ $(elem).removeClass().addClass('denied') }
		if(elemObj.status == 4){ $(elem).removeClass().addClass('denied') }

	})
}

function launchRealTimeForm(options){
	var watchForSubmitInterval=600;
	window.watchForSubmitTimer=false;

	var isMobileApp = false;
	var token = null;
	var strings = {
		saved: "Configuración guardada"
	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.saved != "undefined"){ strings.saved = options.strings.saved }
		}
	}

	initSlider();

	function initSlider(){
		var initEnd = false;
		var elem=$('[data-slider-handle]');
		$(elem).each(function(){
			var slider=$(this).attr('data-input')
			var inputElem=$("#"+slider);
			var value=parseInt($(this).attr('aria-valuenow'))
			var step=$(elem).attr('data-step')
			if(value<step){
				value=value*step
			}
			$(this).attr('aria-valuenow',value)
			$(inputElem).val(value.formatMoney(0, null, '.'))
		});
		setTimeout(function(){
			initEnd = true; //Pausamos para dar tiempo a los sliders a posicionarse
		}, 1000)

		$('.slider').on('changed.zf.slider', function(){
			var elem=$(this).find('[data-slider-handle]');
			var slider=$(elem).attr('data-input')
			var inputElem=$("#"+slider);
			var value=parseInt($(elem).attr('aria-valuenow'))
			var game=$(elem).attr('data-sliderFor')
			$('[data-switchFor="'+game+'"]').attr('data-value',value)
			if(initEnd) {
				if($('[data-switchFor="'+game+'"]').length>0 && $('[data-switchFor="'+game+'"]').prop('checked')==true){
					submitData();
				}
				else if($('[data-switchFor="'+game+'"]').length>0 && $('[data-switchFor="'+game+'"]').prop('checked')==false){
					$('[data-switchFor="'+game+'"]').trigger('click')
				}
			}
		})
		$('.slider').on('moved.zf.slider', function(){
			var elem=$(this).find('[data-slider-handle]');
			var slider=$(elem).attr('data-input')
			var inputElem=$("#"+slider);
			var value=parseInt($(elem).attr('aria-valuenow'))
			var step=$(elem).attr('data-step')
			if(value<step){
				value=value*step
			}
 			$(inputElem).val(value.formatMoney(0, null, '.'))
		})
	}

	$('input[data-switchfor]').add('.switch-input:not([data-value])').on('change',function(){
		submitData();
	})

	function submitData(){

		clearTimeout(window.watchForSubmitTimer);
		window.watchForSubmitTimer=setTimeout(function(){ submitForm()},watchForSubmitInterval)

		function submitForm(){
			var submitObj=new Array();
			$('[data-switchfor][data-value]').each(function(){
				var objElem = {};
				objElem["elem"]=$(this).attr('name');
				objElem["value"]=$(this).attr('data-value');
				objElem["checked"]=$(this).prop("checked");
				submitObj.push(objElem);
			})
			$('[data-switchfor]:not([data-value])').each(function(){
				var objElem = {};
				objElem["elem"]=$(this).attr('name');
				objElem["value"]=false;
				objElem["checked"]=$(this).prop("checked");
				submitObj.push(objElem);
			})
			$('.switch-input:not([data-value])').each(function(){
				var objElem = {};
				objElem["elem"]=$(this).attr('name');
				objElem["value"]=false;
				objElem["checked"]=$(this).prop("checked");
				submitObj.push(objElem);
			})

			if(typeof URLSearchParams != "undefined") {
				var searchParams = new URLSearchParams(window.location.search);
				if(searchParams.has('token')) {
					var extraFieldsOBJ = {
						"notifications":submitObj,
						"token":searchParams.get('token')
					}
				}
				else {
					var extraFieldsOBJ = {
						"notifications":submitObj
					}
				}
			}
			else {
				var extraFieldsOBJ = {
					"notifications":submitObj
				}
			}

			myForm = new formeSubmit(false,"/data/?action=setNotifications",
			{
				extraFields: extraFieldsOBJ,
				callbackOnSuccess: function (e) {
					newPopUp("<strong>"+strings.saved+"</strong>");
				},
				callbackOnFail: function(e) {
					newPopUp(e.error);
				}
			});
		}
	}



}

function refreshConfigPushData(pushData){ //refresca la pantalla de configuración
	$('[data-push-config] #notifyByApp .switch-input').prop('checked',false)
	for (var key in pushData) {
    	if (pushData.hasOwnProperty(key)) {
	    	var elem = $('[name="'+key+'"]')
	    	if(typeof $(elem).attr('data-switchfor') != "undefined"){
		    	$(elem).prop('checked',true)
		    	var slideId = $(elem).attr('data-switchfor')
		    	var sliderHandler = $('[data-sliderfor="'+slideId+'"]')
				var sliderElem = $(sliderHandler).closest('[data-slider]')
				var sliderInput = $(sliderElem).find('input')

		    	if($(sliderElem).length > 0){
					$(sliderElem).attr('data-initial-start',pushData[key])
					$(sliderHandler).attr('aria-valuenow',pushData[key])
					$(sliderInput).val(pushData[key])
					$(sliderElem).foundation('setHandles');
			    }
		    }else{
				$(elem).prop('checked',true)
			}
    	}
	}
	setTimeout(function(){
		$('[data-notification-settings]').show()
	}, 600)
}

//========================================================================================
// NOTIFICACIONES DE ESCRITORIO
//========================================================================================
function registerNotifications(options){
	var unableToRegisterCallback = function(){}
	var callbackOnRegistrationSuccess = function(){}
	if(typeof options != "undefined"){
		if(typeof options.unableToRegisterCallback != "undefined"){ unableToRegisterCallback = options.unableToRegisterCallback }
		if(typeof options.callbackOnRegistrationSuccess != "undefined"){ callbackOnRegistrationSuccess = options.callbackOnRegistrationSuccess }
	}
	notif_suscribe(false,false,{
		unableToRegisterCallback: function(mode){
			unableToRegisterCallback()
		},
		callbackOnRegistrationSuccess: function(data,mode){
			callbackOnRegistrationSuccess()
		},
		incompatibleCallback: function(){

		}
	})
}
function notif_suscribe(app,options){
	var unableToRegisterCallback = function(){}
	var callbackOnRegistrationSuccess = function(){}
	var callbackOnFail = function(){}
	var callbackOnError = function(){}
	var incompatibleCallback = function(){}
	var webPushAPIkey = null;
	var safariPushParameters = {
		serviceURL:null,//https://www.combinacionganadora.com/safaripush
		pushID:null,//"web.com.combinacionganadora"
		userData:null
	} //Si son push web en safari, tenemos que pasar datos del proyecto

	var sendFormeParams = {extraFields: {}}
	var formElement = false;
	var isSafari = false;

	var permissions = false

	if(typeof options != "undefined"){
		if(typeof options.unableToRegisterCallback != "undefined"){ unableToRegisterCallback = options.unableToRegisterCallback }
		if(typeof options.incompatibleCallback != "undefined"){ incompatibleCallback = options.incompatibleCallback }

		if(typeof options.callbackOnRegistrationSuccess != "undefined"){ callbackOnRegistrationSuccess = options.callbackOnRegistrationSuccess }
		if(typeof options.formElem != "undefined"){ formElem = options.formElement }
		if(typeof options.sendFormeParams != "undefined"){ sendFormeParams = options.sendFormeParams }
		if(typeof options.safariPushParameters != "undefined") { safariPushParameters = options.safariPushParameters }//Si son push web en safari, tenemos que pasar datos del proyecto
		if(typeof options.webPushAPIkey != "undefined") { webPushAPIkey = options.webPushAPIkey }//Si son push web en safari, tenemos que pasar datos del proyecto
	}

	if(typeof window.safari != "undefined"){
		isSafari = true
	}

	var continueRegistering = function(options){
		var isSafari = false;
		var safariToken = false;
		if(typeof window.safari != "undefined"){
			isSafari = true
		}
		var permissions = false
		if(typeof options != "undefined"){
			if(typeof options.safariToken != "undefined"){ safariToken = options.safariToken }
		}

// 		if(app || permissions == true){
			if(app || (getCookie("gcmEndpoint")) || isSafari){
				if(!isSafari){
					$.ajax({
						type: "POST",
						url: "/data/?action=gcmRegister",
						data: {},
						dataType: 'json',
						success: function(data)	{
							if(data.status == "ok"){
								callbackOnRegistrationSuccess(data,1)
							}else{
								unableToRegisterCallback(3)
							}
						}
					});
				}else{
					//Como en safari en cuanto aceptamos las notificaciones, existe el endpoint (token), enviamos directamente
					sendFormeParams.extraFields["userData"] = JSON.stringify({
						"endpoint":safariToken,
						"browser":"safari"
					});
					sendFormeParams.callbackOnSuccess = function(e){
						callbackOnRegistrationSuccess(e,1);
						setCookie("gcm_status",1,30);
					},
					sendFormeParams.callbackOnFail = function(e){
						unableToRegisterCallback(1);
					}
					var myForm = new formeSubmit($(formElement),"/data/?action=gcmRegister",sendFormeParams);
				}
			} else {
				if(!isSafari && typeof navigator.serviceWorker!="undefined"){
						navigator.serviceWorker.getRegistrations().then( function (reg) {
							if(reg.length > 0){
								reg[0].pushManager.subscribe({ userVisibleOnly: true,applicationServerKey: urlBase64ToUint8Array(webPushAPIkey)}).then(function(sub) {
									subscription = JSON.stringify(sub);
									setCookie("gcmEndpoint",sub.endpoint,30);
									sendFormeParams.extraFields["userData"] = subscription;
									sendFormeParams.callbackOnSuccess = function(e){
										callbackOnRegistrationSuccess(e,1);
										setCookie("gcm_status",1,30);
									},
									sendFormeParams.callbackOnFail = function(e){
										unableToRegisterCallback(1);
										//setCookie("gcm_status",1,30);
									}
									var myForm = new formeSubmit($(formElement),"/data/?action=gcmRegister",sendFormeParams);
								}).catch(function(error) {
									console.log('Service Worker error: ', error);
								});
							}else{
								console.log('No Service Workers Registered');
							}
							return reg;
						}).catch(function(error) {
							console.log('Service Worker error: ', error);
						});
						/*
						navigator.serviceWorker.register('/gcm.js').then(function() {
							return navigator.serviceWorker.ready;
						}).then(function(reg) { reg.pushManager.subscribe({ userVisibleOnly: true,applicationServerKey: urlBase64ToUint8Array(webPushAPIkey)}).then(function(sub) {
							subscription = JSON.stringify(sub);
							setCookie("gcmEndpoint",sub.endpoint,30);
							sendFormeParams.extraFields["userData"] = subscription;
							sendFormeParams.callbackOnSuccess = function(e){
								callbackOnRegistrationSuccess(e,1);
								setCookie("gcm_status",1,30);
							},
							sendFormeParams.callbackOnFail = function(e){
								unableToRegisterCallback(1);
								//setCookie("gcm_status",1,30);
							}
							var myForm = new formeSubmit($(ent),"/data/?action=gcmRegister",sendFormeParams);
						});
					}).catch(function(error) {
						console.log('Service Worker error: ', error);
					});
					*/

				}

			}
// 		}
	}

	//Todas las notificaciones en safari se gestionan desde la funcion notif_checkPermission
	//Puesto que todas las solicitudes al servidor son asíncronas
	//Los callback se pasan a traves del parámetro options de notif_checkPermission

	if(!app){
		if(!notif_checkSupport()){
			//Mostrar modal sin compatibilidad
			//unableToRegisterCallback(2)
			incompatibleCallback()
			return false;
		}

		if(!isSafari){
			permissions = notif_checkPermission({});
		}else{
			permissisons = notif_checkPermission({
				safariPushParameters:safariPushParameters,
				callbackOnSuccess:continueRegistering,
				callbackOnFail:unableToRegisterCallback
			})

		}



		if (permissions == -1 && !isSafari && typeof Notification != "undefined") {
			Notification.requestPermission(function (permission) {

				// If the user accepts, let's create a notification
				if (permission === "granted") {
					permissions = true;
					if(getCookie("gcmEndpoint").length == 0){
						continueRegistering();
					}
					console.log('granted');
				} else {
					console.log('denied');
				}
			});
		}else if(permissions == -2 && !isSafari){
			console.log('denied');
			//unableToRegisterCallback(3)
		}

	}

	if((permissions == true && !isSafari) || app){
		if(getCookie("gcmEndpoint").length == 0){
			continueRegistering()
		}
	}



}
function setCookieEndpoint() { //Para Webpush
	if(typeof window.safari == "undefined" && typeof navigator != "undefined"){
		if(notif_checkSupport()){
			navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
				if(typeof serviceWorkerRegistration != "undefined" && typeof serviceWorkerRegistration.pushManager != "undefined"){ //Para navegadores compatibles con webpush
					serviceWorkerRegistration.pushManager.getSubscription()
					.then(function(subscription) {
						if(subscription) {
							setCookie("gcmEndpoint",subscription.endpoint,30);
						}
					});
				}
			});
		}
	}
}
function notif_userDenied(){
	//Mostrar modal rechazo usuario/modo incógnito
	$('#subscribeModal').attr('data-reveal-params','{ "mode":"3"}');
	$('#subscribeModal').foundation('open');
	notifyDontRemember(90);
}
function notif_checkSupport(){
	if(typeof window.safari == "undefined"){ //Para otros navegadores que no sean safari
		if ('serviceWorker' in navigator) {
			return true;
		} else {
			return false;
		}
	}else{
		if ('safari' in window && 'pushNotification' in window.safari){
			return true;
		}else{
			return false;
		}
	}
}
function notif_checkPermission(options){
	var safariPushParameters = {
		serviceURL:null,
		pushID:null,
		userData:null
	}
	var callbackOnSuccess = function(){}
	var callbackOnFail = function(){}

	if(typeof options != "undefined"){
		if(typeof options.safariPushParameters != "undefined") { safariPushParameters = options.safariPushParameters;}
		if(typeof options.callbackOnSuccess != "undefined") { callbackOnSuccess = options.callbackOnSuccess;}
		if(typeof options.callbackOnFail != "undefined") { callbackOnFail = options.callbackOnFail;}
	}

	if(typeof window.safari == "undefined" && typeof Notification != "undefined"){
		if(Notification.permission == "granted"){
			return true;
		} else if (Notification.permission == "default"){
			return -1;
		} else if (Notification.permission == 'denied') {
			return -2;
		}
	}else{
		if(typeof window.safari != "undefined" && typeof window.safari.pushNotification != "undefined"){
			if(safariPushParameters["pushID"] != null){
		        var permissionData = window.safari.pushNotification.permission(safariPushParameters["pushID"]);
				return checkRemotePermission(permissionData,options)
			}else{
				return -1;
			}
		}else{
			return -1;
		}
	}
}
var checkRemotePermission = function (permissionData,options) {
	var safariPushParameters = {
		serviceURL:null,
		pushID:null,
		userData:null
	}
	var callbackOnSuccess = function(){}
	var callbackOnFail = function(){}
	if(typeof window.firstTimeSafariOptions != "undefined"){
		if(window.firstTimeSafariOptions != null){
			var options = window.firstTimeSafariOptions
		}
	}
	if(typeof options != "undefined"){
		window.firstTimeSafariOptions = options

		if(typeof options.safariPushParameters != "undefined") { safariPushParameters = options.safariPushParameters;}
		if(typeof options.callbackOnSuccess != "undefined") { callbackOnSuccess = options.callbackOnSuccess;}
		if(typeof options.callbackOnFail != "undefined") { callbackOnFail = options.callbackOnFail;}
	}

    if (permissionData.permission === 'default') {
        // This is a new web service URL and its validity is unknown.
        window.safari.pushNotification.requestPermission(
            safariPushParameters.serviceURL, 	// The web service URL.
            safariPushParameters.pushID,     	// The Website Push ID.
            {}, 								// Data that you choose to send to your server to help you identify the user.
            checkRemotePermission  				// The callback function.
        );

    }
    else if (permissionData.permission === 'denied') {
		callbackOnFail(3)
		delete window[firstTimeSafariOptions]
        return -2;
    }
    else if (permissionData.permission === 'granted') {
		setCookie("gcmEndpoint",permissionData.deviceToken,30);
		console.log("TOKEN:",permissionData.deviceToken)
		console.log(getCookie("gcmEndPoint"))
		callbackOnSuccess({safariToken:permissionData.deviceToken})
		delete window[firstTimeSafariOptions]
	    return permissionData.deviceToken
        // The web service URL is a valid push provider, and the user said yes.
        // permissionData.deviceToken is now available to use.
    }
};
function manageGcm(fieldsString){
	notif_suscribe(fieldsString)
	notifyDontRemember(30);
	return true;
}
function followingDontRemember() {
	setCookie("followingDontRemember",true,10);
	return true;
}
function notifyDontRemember(days) {
	setCookie("notifyDontRemember",true,days);
	return true;
}

var lottoFinder = function(urlToRetrieveData,options){
	this.availableNumbersObj = null;
	this.callbackOnSuccess = function(){};		//Cuando la petición AJAX contra los servidores de terminal es exitosa
	this.callbackOnFail = function(){};			//Cuando la peticion AJAX contra los servidores de terminal falla
/*
	this.availableNumbersObj = `
	4 ; 16
 	9162 ;  140
 	9180 ;  16
 	9221 ;  17
 	9222 ;  163
 	9229 ;  20
 `
*/
 this.availableNumbersObjArray = new Array();

 if(typeof options != "undefined"){
	 if(typeof options.callbackOnSuccess != "undefined"){ this.callbackOnSuccess = options.callbackOnSuccess}
	 if(typeof options.callbackOnFail != "undefined"){ this.callbackOnFail = options.callbackOnFail}
 }

 this.getCSV(urlToRetrieveData);
}

lottoFinder.prototype.retrieveCSV = function(urlToRetrieveData){
	//PRIVADA, NO USAR
	//REALIZA LA PETICIÓN AJAX DE LOS NÚMEROS DISPONIBLES POR TERMINAL
	var self = this;
	var selfLF = this;
	var forme = new formeSubmit(false,urlToRetrieveData,{
		callbackOnSuccess: function(e){
			self.availableNumbersObj = e.data;
			self.availableNumbersObjArray = selfLF.csvToArray(e.data,";");
			self.callbackOnSuccess(self,e);
		},
		callbackOnFail: function(e){
			self.callbackOnFail(self,e);
		},
		callbackOnError: function(){
			self.callbackOnFail(self);
		}
	})
}
lottoFinder.prototype.getCSV = function(urlToRetrieveData){
	//OBTIENE LOS NÚMEROS DE TERMINAL SI NO ESTUVIERAN YA CARGADOS
	//USAR ESTA FUNCIÓN Y NO RETRIEVECSV() PARA OBTENER LOS NÚMEROS
	var self = this;
	if(self.availableNumbersObj == null || typeof self.availableNumbersObj == "undefinded" || (typeof self.availableNumbersObj != "undefinded" && self.availableNumbersObj.length == 0)){
		self.retrieveCSV(urlToRetrieveData);
	}
}
lottoFinder.prototype.csvToArray = function(strData, strDelimiter){
		// Check to see if the delimiter is defined. If not,
		// then default to comma.
		strDelimiter = (strDelimiter || ",");

		// Create a regular expression to parse the CSV values.
		var objPattern = new RegExp(
			(
				// Delimiters.
				"(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

				// Quoted fields.
				"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

				// Standard fields.
				"([^\"\\" + strDelimiter + "\\r\\n]*))"
			),
			"gi"
			);


		// Create an array to hold our data. Give the array
		// a default empty first row.
		var arrData = [[]];

		// Create an array to hold our individual pattern
		// matching groups.
		var arrMatches = null;


		// Keep looping over the regular expression matches
		// until we can no longer find a match.
		while (arrMatches = objPattern.exec( strData )){

			// Get the delimiter that was found.
			var strMatchedDelimiter = arrMatches[ 1 ];

			// Check to see if the given delimiter has a length
			// (is not the start of string) and if it matches
			// field delimiter. If id does not, then we know
			// that this delimiter is a row delimiter.
			if (
				strMatchedDelimiter.length &&
				(strMatchedDelimiter != strDelimiter)
				){

				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push( [] );

			}


			// Now that we have our delimiter out of the way,
			// let's check to see which kind of value we
			// captured (quoted or unquoted).
			if (arrMatches[ 2 ]){

				// We found a quoted value. When we capture
				// this value, unescape any double quotes.
				var strMatchedValue = arrMatches[ 2 ].replace(
					new RegExp( "\"\"", "g" ),
					"\""
					);

			} else {

				// We found a non-quoted value.
				var strMatchedValue = arrMatches[ 3 ].trim();

			}


			// Now that we have our value string, let's add
			// it to the data array.
			arrData[ arrData.length - 1 ].push( strMatchedValue );
		}

		// Return the parsed data.
		// Para lotería: si tiene menos de 5 números, se completa con ceros
		var indexesToRemove = new Array();
		$(arrData).each(function(k,v){
			//Si los datos no son correctos (numerico:numerico)
			//Guardamos los índices para eliminarlos del array
			if( isNaN(parseFloat(v[0])) || isNaN(parseFloat(v[1])) ){
				indexesToRemove.push(k);
			}
			if(v[0].length < 5){
				var ceros = "";
				var cerosCount = 5 - v[0].length;

				for (i=0;i<cerosCount;i++){
					ceros = ceros + "0";
				}
				arrData[k][0] = ceros+v[0];
			}
		})
		//Limpiamos el objeto de posible basura y datos no válidos
		var tmpArray = new Array();
		$(arrData).each(function(k,v){
			if(indexesToRemove.indexOf(k) == -1){
				tmpArray.push(v);
			}
		})
		return( tmpArray );
	}
lottoFinder.prototype.findValue = function(numberWithWildcard){
	//Devuelve un array bidimensional con los números encontrados y las unidades disponibles
/*
	["09990", "10"],
	["09991", "20"],
	["09992", "166"],
	["09996", "15"],
	["09997", "1595"],
	["09998", "45"]
*/
	var self = this;
	var regExpression = "";
	//Creamos la expresión regular a partir del número con wildcards (ej: "993??")
	for(i=0;i<numberWithWildcard.length;i++){
		if(!isNaN(parseFloat(numberWithWildcard[i]))){
			regExpression = regExpression + numberWithWildcard[i];
		}else{
			regExpression = regExpression + ".";
		}
	}
	var reg = new RegExp(regExpression);


	return self.availableNumbersObjArray.filter(function(item){
		return item[0].match(reg)
	})


}
lottoFinder.prototype.getNumberStock = function(numberWithWildcard,callbackOnUnavailable,callbackOnAvailable){


	var self = this;
	var availableNumbers = self.findValue(numberWithWildcard);
	var availableUnits = 0;
	$(availableNumbers).each(function(k,v){
		availableUnits = availableUnits + parseInt(v[1]);
	})
	if(availableUnits == 0 && typeof callbackOnUnavailable != "undefined"){
		callbackOnUnavailable(numberWithWildcard,self);
	}
	if(availableUnits > 0 && typeof callbackOnAvailable != "undefined"){
		callbackOnAvailable(numberWithWildcard,availableUnits,self);
	}

	return availableUnits;
}
lottoFinder.prototype.getNumbersLength = function(){
	return this.availableNumbersObjArray.length;
}

//================================================================
// VALIDADOR UNIVERSAL
//================================================================

var documentsValidator = function(requiredItemsObj){
	this.requiredItems =  requiredItemsObj;
/*
	requiredItems = {
		email:{
				name: "email"
		},
		phone:{
				name: "teléfono"
		},
		documents:{
			"1":{
				properties: { "name":"ID Card","hasReverso":true,"hasExpiration":true},
				isIdentification: true
			},
			"2":{
				properties: { "name":"ID Card","hasReverso":true,"hasExpiration":true},
				isIdentification: true
			},
			"3":{
				properties: { "name":"Driving Licence","hasReverso":false,"hasExpiration":true},
				isIdentification: true
			},
			"5":{
				properties: { "name":"Utility Bill","hasReverso":false,"hasExpiration":false},
				isIdentification: false
			}

		}
	}
*/

	this.interfaceSelector =  "[data-featuresBlock]";
	this.phoneValidationModalElem = '[data-reveal-source="validatePhone"]';
	this.emailValidationModalElem = '[data-reveal-source="validateEmail"]';

	this.docManager = null;
	this.emailRequired = false;
	this.phoneRequired = false;

	this.strings = {
		sending:"{t}Enviando un email de activación a tu cuenta... Espera por favor{/t}"
	}

	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.sending != "undefined"){ this.strings.sending = options.strings.sending}
		}
	}
}

documentsValidator.prototype.attachDocsManager = function(docsManagerObj){
	var self = this;
	self.docsManagerObj = docsManagerObj;
	var launchDM = new launchDocumentsManagerScripts(self.docsManagerObj);


	//Eventos

	$(document).off('click',self.interfaceSelector + " button").on("click",self.interfaceSelector + " button",function(){
		var elem = $(this).closest('[data-forDocument]');
		var docType = $(this).closest('[data-forDocument]').attr('data-forDocument');
		switch(docType){
			//customLabelEvents()
			case "phone":
				var phoneModal = $(self.phoneValidationModalElem);
				$(phoneModal).data('callback',function(e){
					launchPhoneValidationScript({
						callbackOnSuccess: function(e,statusMsgElem){
							var text = $(statusMsgElem).text();
							var intervalo = 3;
							$(statusMsgElem).text(text +" (" + intervalo + ")");
							var closeInterval = setInterval(function(){
								intervalo--;
								if(intervalo == 0){
									location.reload();
								}else{
									$(statusMsgElem).text(text +" (" + intervalo + ")");
								}
							}, 1000)
							$(elem).fadeOut('slow',function(){ $(this).remove(); })
						}
					});
				})
				$(phoneModal).core_reveal('open',{ params:{ 'ignoreScripts':true}});
			break;
			case "email":
				var emailModal = $(self.emailValidationModalElem);
				sendValidateEmail(null,$(this),{
					strings:{
						sending: self.strings.sending
					},
					callbackOnSuccess:function(e){
						$(emailModal).data('callback',function(e){
							launchEMailValidationScript({
								callbackOnSuccess: function(e,statusMsgElem){
									var text = $(statusMsgElem).text();
									var intervalo = 3;
									$(statusMsgElem).text(text +" (" + intervalo + ")");
									var closeInterval = setInterval(function(){
										intervalo--;
										if(intervalo == 0){
											location.reload();
										}else{
											$(statusMsgElem).text(text +" (" + intervalo + ")");
										}
									}, 1000);
									$(elem).fadeOut('slow',function(){ $(this).remove(); })
								}
							});
						})
						$(emailModal).core_reveal('open',{ params:{ 'ignoreScripts':true}});
					},
					callbackOnError:function(e){
						alert(e.error);
						$(emailModal).core_reveal('close');
						return false;
					},
					callbackOnFail:function(e,j,k){
						alert(j);
						$(emailModal).core_reveal('close');
						return false;
					}

				})
			break;
			default:
			break;
		}

	})

}

documentsValidator.prototype.render = function(injectInto,options){
	var self = this;
	var html = "";
	var groupedHtml = "";
	var animated = false;
	var callbackOnRender = function(){};
	if(typeof options != "undefined"){
		if(typeof options.animated != "undefined" && options.animated === true){ animated = true;}
		if(typeof options.callbackOnRender != "undefined" ){ callbackOnRender = options.callbackOnRender;}
	}
	$.each(self.requiredItems,function(k,v){
		if(k == "email"){
			html = html + '<li data-forDocument="email">'+
								'<button type="button">'+
								'<span></span>'+
								'<i class="icon-slim-mail"></i>' + v.name + '</button>'+
							'</li>'
		}
		if(k == "phone"){
			html = html + '<li data-forDocument="phone">'+
								'<button type="button">'+
								'<span></span>'+
								'<i class="icon-slim-phone"></i>' + v.name + '</button>'+
							'</li>'
		}

		if(k == "documents"){

		}
	})
/*
				<ul data-featuresBlock>
				<li data-forDocument="email">
					<button type="button" {* disabled="disabled" *}>
					<span></span>
					<i class="icon-slim-mail"></i>Email</button>
				</li>
				<li data-forDocument="phone">
					<button type="button" {* disabled="disabled" *}>
					<span></span>
					<i class="icon-slim-phone"></i>Teléfono</button>
				</li>
			</ul>
*/
	html = "<ul data-featuresBlock data-docsItems>" + html + "</ul>";
	if(typeof injectInto != "undefined"){

		if(animated){
			$(injectInto).hide();
		}
		$(injectInto).html(html);
		if(animated){
			$(injectInto).slideDown('fast', function(){ callbackOnRender() }).addClass('animated fadeIn');
		}
		if(!animated){
			callbackOnRender();
		}
	}
	return html;

}

documentsValidator.prototype.getDocTypes = function(){
	var self = this;
	var ri = self.requiredItems;
	var docTypes = {};
	if(typeof ri.documents != "undefined" && Object.keys(ri.documents).length > 0){
		$.each(ri.documents,function(k,v){
			docTypes[k] = v.properties
		})
	}
	return docTypes;
}

//formatMoney se mantiene por compatibilidad. Se ha movido a la clase currency.js
Number.prototype.formatMoney = function(c, d, t){
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "," : d,
        t = t == undefined ? "." : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
       return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function submitPromoBets(elem,redirectURL,game,bets,options){
	//Función que envía las apuestas de las pantallas de promos al carro.
	var params = { }
	params[game] = bets;
	const strings = {
		wait: options?.strings?.wait ?? "",
		fail: options?.strings?.fail ?? "{t}Error al intentar añadir las apuestas{/t}"
	}
	const statusMsgElem = options?.statusMsgElem ?? "[data-status-msg]";
	const callback = options?.callbackOnSuccess ?? function(){}
	const callbackFail = options?.callbackOnFail ?? function(){}

	myForm = new formeSubmit(false,"/data/?action=toCart",
	{
		submitBt: {
			elem : $(elem),
			holdMsg: strings.wait
		},
		statusMsg: {
			elem: 	statusMsgElem,
			ko: 	strings.fail,
		},
		extraFields: { 	"bets":JSON.stringify({ "1":params}),
						"fastMode": 1
					},
		redirectURL: redirectURL,
		callbackOnSuccess: function (e) {
			callback(e);
		},
		callbackOnFail: function(e){
			callbackFail(e);
		}
	});
}